import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const translations = {
  en: {
    dir: "ltr",
    // Navbar
    "nav.title": "ePlay",
    "nav.section": "Master League",
    "nav.dashboard": "Dashboard",
    "nav.fixtures": "Fixtures",
    "nav.standings": "Standings",
    "nav.leagues": "Leagues",
    "nav.social": "Social",
    "nav.myMatches": "My Matches",
    "nav.chat": "Chat",
    "nav.admin": "Admin",
    "nav.login": "Login",
    "nav.register": "Register",
    "nav.exit": "Exit",
    "nav.lobby": "LOBBY",
    "nav.locked": "LOCKED",
    "nav.noLeague": "NO ACTIVE LEAGUE",
    "nav.id": "ID",
    "nav.language": "AR",
    "nav.dark": "Dark",
    "nav.light": "Light",

    // Home
    "home.kicker": "// ePlay hub",
    "home.v2Banner.beta": "BETA",
    "home.v2Banner.headline": "TRY THE NEW DESIGN",
    "home.v2Banner.body": "We're rolling out a fresh mobile-first experience. Be one of the first to test it.",
    "home.v2Banner.cta": "Try v2 →",
    "home.v2Banner.dismiss": "Dismiss banner",
    "home.title1": "Pick Your",
    "home.title2": "Competition",
    "home.intro": "Six ePlay game modes. The first is live — tap in, draft your slot, play the season. The rest are on deck.",
    "home.count": "{n} LIVE · {m} COMING SOON",
    "home.live": "LIVE",
    "home.private": "PRIVATE",

    // Active Leagues overview on Home
    "active.title": "Current Active Leagues",
    "active.kicker": "// live seasons",
    "active.subtitle": "Tap any league to see its full standings.",
    "active.empty": "[ NO LEAGUES LOCKED YET — check back once a new season starts. ]",
    "active.platform.mobile": "MOBILE",
    "active.platform.console": "PS5 · STEAM",
    "active.status.locked": "LOCKED",
    "active.status.running": "LIVE",
    "active.status.complete": "COMPLETE",
    "active.noResults": "No results yet",
    "active.viewStandings": "View full standings →",
    "active.toggle": "Show active leagues",
    "active.hide": "Hide",
    "home.mobileBadge": "MOBILE",
    "home.consoleBadge": "PS5 · STEAM",
    "home.comingSoon": "Coming Soon",
    "home.enterLeague": "Enter League",
    "home.tile.mobileTitle": "eFootball Mobile",
    "home.tile.mobileSub": "Online Master League",
    "home.tile.consoleTitle": "eFootball Console",
    "home.tile.consoleSub": "Online Master League",
    "home.tile.byolTitle": "Build Your Own League",
    "home.tile.byolSub": "Private · Invite-Only",
    "home.tile.uflTitle": "UFL · Mobile",
    "home.tile.uflSub": "Quick Play 4-player rooms · Create or join teams",
    "home.uflBadge": "Live",
    "home.tile.classicsTitle": "Classics — Retro PES & FIFA",
    "home.tile.classicsSub": "PES 13–21 over Parsec · 1v1 nostalgia",
    "home.pcOnly": "PC Only",
    "home.tile.wcAuthMob": "eFootball World Cup Authentic",
    "home.tile.wcAuthMobSub": "Mobile",
    "home.tile.wcAuthCon": "eFootball World Cup Authentic",
    "home.tile.wcAuthConSub": "Console",
    "home.tile.wcDream": "eFootball World Cup Dream Team \"Continent\"",
    "home.tile.wcDreamSub": "Mobile",
    "home.tile.wc2026Title": "FIFA World Cup 2026",
    "home.tile.wc2026Sub": "Authentic 48-Team · Immersion · Dream Team",
    "home.wc2026Badge": "3 Modes",

    // Dashboard
    "dash.kicker": "// MASTER LEAGUE :: CONTROL ROOM",
    "dash.heroLine1": "Twenty players.",
    "dash.heroLine2": "One league.",
    "dash.heroIntro": "Sign up, get drafted into the next open league, play each rival twice, submit your screenshots, and watch the table update the moment both players confirm the score.",
    "dash.currentSeason": "Current Season",
    "dash.status": "Status",
    "dash.players": "Players",
    "dash.fill": "Fill",
    "dash.slotsRemaining": "slots remaining before lock-in",
    "dash.claimSlot": "Claim a Slot",
    "dash.playerSignIn": "Player Sign-In",
    "dash.viewFixtures": "View Fixtures",
    "dash.leaderboard": "Leaderboard",
    "dash.pendingTitle": "Your Pending Matches",
    "dash.pendingKicker": "// queue",
    "dash.pendingEmpty": "[ NO PENDING MATCHES — you're clear, player. ]",
    "dash.pendingAdmin": "[ ADMIN VIEW — use admin panel to resolve disputes. ]",
    "dash.pendingGuest": "[ SIGN IN TO SEE YOUR FIXTURES. ]",
    "dash.topKicker": "// top 5",
    "dash.topTitle": "Leaderboard",
    "dash.noLeagueActive": "[ NO LEAGUE ACTIVE ]",
    "dash.awaitingResult": "[ AWAITING FIRST RESULT ]",

    // Terms & Conditions
    "tc.kicker": "// SQUAD RULES // TERMS & CONDITIONS",
    "tc.title": "Squad Rules",
    "tc.intro": "Before you submit a fixture, your squad must comply with the league's fair-play ruleset. Violations result in forfeit of the match and may lead to removal from the league.",
    "tc.rule1": "Only current real-life players are allowed in your squad.",
    "tc.rule2": "No EPIC or SHOWTIME cards are permitted — strictly banned.",
    "tc.rule3": "Player of the Week (POTW) cards, or cards of a similar event tier, are allowed.",
    "tc.rule4": "Nothing higher rated than POTW-tier is allowed.",
    "tc.ack": "By registering and submitting results, you confirm your squad complies with these rules.",

    // Login
    "login.kicker": "// player sign-in",
    "login.title": "Enter the League",
    "login.subtitle": "Sign in with your player credentials to submit results and track standings.",
    "login.username": "Username",
    "login.password": "Password",
    "login.submit": "Sign In",
    "login.submitting": "Authenticating...",
    "login.noCreds": "No credentials yet?",
    "login.registerLink": "Register for the next season",
    "login.toast": "Welcome back, player.",

    // Register
    "reg.kicker": "// new player",
    "reg.title": "Claim a Slot",
    "reg.subtitle": "20 players per league. Once full, fixtures lock instantly and a new season opens.",
    "reg.username": "Username",
    "reg.gameId": "Game ID",
    "reg.gameIdPlaceholder": "e.g. eFootball#12345",
    "reg.whatsapp": "WhatsApp Number",
    "reg.whatsappPlaceholder": "+201234567890",
    "reg.whatsappHelp": "Type your full WhatsApp number including country code (e.g. +20 for Egypt, +44 for UK, +1 for US). Other players in your league will use this to contact you and agree on a match time.",
    "reg.password": "Password",
    "reg.submit": "Lock in my slot",
    "reg.submitting": "Registering...",
    "reg.already": "Already a player?",
    "reg.loginLink": "Sign in",
    "reg.toast": "Player registered. You're in the current league.",
    "reg.clubName": "Club Name (optional)",
    "reg.clubNamePh": "Add it later in your account",
    "reg.nationality": "Nationality (optional)",
    "reg.nationalityPh": "— select country —",
    "reg.platform": "Platform",
    "reg.signInWithGoogle": "Sign up with Google",

    // Fixtures
    "fx.title": "Match Schedule",
    "fx.viewMyLeague": "View My League",
    "fx.myLeague": "My League",
    "fx.noLock": "[ NO LEAGUE LOCKED YET — fixtures generate the moment 20 players register. ]",
    "fx.loading": "LOADING FIXTURES",
    "fx.empty": "[ NO FIXTURES AVAILABLE ]",
    "fx.home": "HOME",
    "fx.away": "AWAY",
    "fx.round": "Round",
    "fx.matchday": "Matchday",
    "fx.game": "Game",
    "fx.pending": "Pending",
    "fx.confirmed": "Confirmed",
    "fx.disputed": "Disputed",

    // Standings
    "st.title": "League Table",
    "admStand.loading": "LOADING ALL LEAGUES",
    "admStand.mobile": "Mobile",
    "admStand.console": "Console",
    "admStand.pickLeague": "Pick a season:",
    "admStand.empty": "— no leagues for this platform —",
    "admStand.noLeagues": "[ NO LEAGUES ON THIS PLATFORM YET. ]",
    "st.noResults": "[ NO RESULTS SUBMITTED YET ]",
    "st.headerPlayer": "Player",
    "st.played": "P",
    "st.wins": "W",
    "st.draws": "D",
    "st.losses": "L",
    "st.gf": "GF",
    "st.ga": "GA",
    "st.gd": "GD",
    "st.pts": "Pts",

    // My Matches
    "mm.title": "My Matches",
    "mm.loading": "LOADING YOUR MATCHES",
    "mm.empty": "[ NO MATCHES YET — wait for your league to fill. ]",
    "mm.vs": "vs",
    "mm.submit": "Submit Result",
    "mm.confirm": "Confirm",
    "mm.submitted": "Submitted",
    "mm.awaitingOpponent": "Awaiting opponent",

    // Leagues list
    "lg.title": "All Leagues",
    "lg.loading": "LOADING LEAGUES",
    "lg.empty": "[ NO LEAGUES YET ]",
    "lg.season": "Season",
    "lg.openStatus": "OPEN",
    "lg.lockedStatus": "LOCKED",
    "lg.completeStatus": "COMPLETE",

    // League detail
    "ld.back": "Back",
    "ld.hallOfFame": "Hall of Fame",
    "ld.feed": "Feed",
    "ld.standings": "Standings",
    "ld.fixtures": "Fixtures",
    "ld.loading": "LOADING LEAGUE",

    // Player profile
    "pp.title": "Player Profile",
    "pp.loading": "LOADING PROFILE",
    "pp.notFound": "Player not found.",
    "pp.viewProfile": "View My Public Profile",
    "pp.joined": "Joined",
    "pp.played": "Played",
    "pp.won": "Won",
    "pp.drawn": "Drawn",
    "pp.lost": "Lost",
    "pp.winRate": "Win %",
    "pp.points": "Points",
    "pp.form": "Form",
    "pp.seasons": "Seasons",
    "pp.pending": "Pending",
    "pp.h2hTitle": "Head-to-Head",
    "pp.h2hEmpty": "No head-to-head history yet.",
    "pp.recentTitle": "Recent Matches",
    "pp.recentEmpty": "No matches played yet.",
    "pp.seasonsTitle": "Seasons Played",
    "pp.h2hRoom": "H2H Room",
    "pp.message": "Message",
    "pp.lastPlayed": "Last played",
    "pp.opponent": "Opponent",
    "pp.banned": "BANNED",
    "pp.admin": "ADMIN",
    "pp.moderator": "MOD",

    // Hall of Fame
    "hof.kicker": "// all-time legends",
    "hof.title": "Hall of Fame",
    "hof.subtitle": "Top 5 · all leagues · all time",
    "hof.empty": "Throne awaits a champion",
    "hof.emptyBody": "No matches confirmed yet. First legend gets the crown.",
    "hof.rank": "#",
    "hof.player": "Player",
    "hof.pts": "Pts",

    // Account
    "acc.title": "Account",
    "acc.kicker": "// profile",
    "acc.viewProfile": "View My Public Profile",
    "acc.changeUsername": "// change username",
    "acc.current": "Current",
    "acc.newUsername": "new username",
    "acc.updateUsername": "Update Username",
    "acc.changePassword": "// change password",
    "acc.currentPassword": "current password",
    "acc.newPassword": "new password (min 4 chars)",
    "acc.updatePassword": "Update Password",
    "acc.usernameUpdated": "Username is now {name}",
    "acc.passwordUpdated": "Password updated",
    "acc.yourReliability": "Your reliability:",
    "acc.scoreBreakdown": "Score breakdown (last 60 days)",
    "acc.matchesInWindow": "Matches in window",
    "acc.completion": "Completion",
    "acc.onTime": "On time",
    "acc.chatEng": "Chat engagement",
    "acc.scoreAgreement": "Score agreement",
    "acc.reports90d": "Reports (90d)",
    "acc.autoForfeits": "Auto-forfeits",
    "acc.inactiveDays": "Inactive days",
    "acc.profilePicture": "// profile picture",
    "acc.replacePhoto": "Replace photo",
    "acc.uploadPhoto": "Upload photo",
    "acc.imageTooBig": "Image too large (max 1MB). Crop or compress first.",
    "acc.picUpdated": "Profile picture updated",
    "acc.picRemoved": "Profile picture removed",
    "acc.picMeta": "jpg · png · webp · max 1MB",
    "acc.removeBtn": "Remove",
    "acc.dangerZone": "Danger zone",
    "acc.dangerBody": "Delete your account permanently. If your current league hasn't played any confirmed match yet, your slot reopens for a new player. Otherwise your unplayed matches become 3-0 forfeits for your opponents. This cannot be undone.",
    "acc.deleteMyAccount": "Delete my account",
    "acc.confirmWithPassword": "Confirm with your current password",
    "acc.typeUsername": "Type your username to confirm ({name})",
    "acc.permanentlyDelete": "PERMANENTLY DELETE",
    "acc.deleting": "DELETING…",
    "acc.cancel": "Cancel",
    "acc.deletedToast": "Account deleted. Removed from {n} league(s){slots}{forfeits}",
    "acc.slotsReopened": " · {n} slot(s) reopened",
    "acc.forfeitedMatches": " · {n} match(es) auto-forfeited",

    // Exit league
    "exit.kicker": "// quit current season",
    "exit.title": "Exit Current League",
    "exit.body": "Leave your current league while keeping your account, club name, profile data, and historical stats. Your slot will NOT be reopened — it stays closed for the rest of the season. Your pending matches will be auto-forfeited 3-0 to your opponents. After leaving, you'll be auto-placed into the next open league for your platform and your overall career stats carry forward.",
    "exit.button": "Leave League",
    "exit.confirmTitle": "Confirm league exit",
    "exit.confirmBody": "Type your username to confirm: this action cannot be undone for this season.",
    "exit.confirm": "Leave League Now",
    "exit.cancel": "Cancel",
    "exit.exiting": "Leaving…",
    "exit.toastJoined": "You left the league. {n} match(es) forfeited. You've been placed into a new open league.",
    "exit.toastNoNewLeague": "You left the league. {n} match(es) forfeited. No open league available — you can register again later.",
    "exit.notInLeague": "You're not in a league right now.",
    "exit.adminBlocked": "Admin accounts cannot exit a league.",

    // Report player
    "report.btn": "Report",
    "report.reportName": "Report {name}",
    "report.alreadyReported": "You already reported this player",
    "report.intro": "Report {name}. At {threshold} unique reports, the player is auto-removed and their remaining games awarded 3-0 to opponents.",
    "report.reasonPh": "Reason (min 5 chars) — e.g. no-show, cheating, abuse",
    "report.screenshotRequired": "A screenshot is required to file a report.",
    "report.screenshotRequiredLabel": "Screenshot evidence (required)",
    "report.screenshotMeta": "PNG / JPG / WEBP · max 5 MB",
    "report.fileTooBig": "Screenshot too large (max 5 MB).",
    "report.fileBadType": "Screenshot must be PNG, JPG, or WEBP.",
    "report.cancel": "Cancel",
    "report.submit": "Submit",
    "report.update": "Update",
    "report.submitting": "Submitting…",
    "report.toastSubmitted": "Report submitted. {count}/{threshold}",
    "report.toastBanned": "{name} has been auto-removed ({threshold}+ reports).",

    // Profile completion (email / nationality / club name)
    "pc.kicker": "// profile completion",
    "pc.title": "Complete Your Profile",
    "pc.subtitle": "Verify your account so other players can trust your results. We never share your email.",
    "pc.email": "Email",
    "pc.emailPh": "you@example.com",
    "pc.nationality": "Nationality",
    "pc.nationalityPh": "— select country —",
    "pc.clubName": "Club Name",
    "pc.clubNamePh": "e.g. Lions FC",
    "pc.clubWarning": "Important: Your club name MUST match exactly the club name shown on your match-result screenshots. It must also be unique — no two players in ePlay can use the same club name. Pick one carefully.",
    "pc.save": "Save Profile",
    "pc.saving": "Saving…",
    "pc.saved": "Profile updated",
    "pc.complete": "Profile complete",
    "pc.incomplete": "Profile incomplete — fill the missing fields below",
    "pc.clubTakenError": "This club name is already taken by another player. Pick a unique club name that matches your screenshot exactly.",

    // Google sign-in
    "google.signIn": "Sign in with Google",
    "google.continueWith": "Or continue with",
    "google.welcome": "Almost there",
    "google.signingIn": "Signing you in",
    "google.pickUsername": "Pick your username",
    "google.pickUsernameHelp": "Signing in as {email}. Choose your in-app username (2-24 chars, letters/digits/_/- only).",
    "google.pickNationalityOpt": "— Nationality (optional) —",
    "google.create": "Create Account",
    "google.creating": "Creating…",
    "google.failed": "Google sign-in failed",
    "google.backLogin": "Back to login",
    "google.noSession": "[ NO GOOGLE SESSION DETECTED. RETURN TO /login. ]",
    "google.linkedToast": "Google linked. Welcome back!",
    "google.welcomeToast": "Welcome to ePlay!",
    "google.welcomeBack": "Welcome back!",

    // Social
    "social.tab.browse": "Browse",
    "social.tab.mine": "My Socials",
    "social.tab.friends": "Friends",
    "social.tab.following": "Following",
    "social.tab.followers": "Followers",
    "social.platform.all": "All",
    "social.platform.mobile": "Mobile",
    "social.platform.console": "Console",
    "social.sort.points": "Points",
    "social.sort.reliability": "Reliability",
    "social.sort.winrate": "Win rate",
    "social.searchPh": "Search username or game ID…",
    "social.signinToFollow": "Sign in to follow players",
    "social.empty": "[ NO PLAYERS FOUND ]",
    "social.loading": "LOADING PLAYERS",
    "social.follow": "Follow",
    "social.following": "Following",
    "social.unfollow": "Unfollow",
    "social.mutual": "MUTUAL",
    "social.whatsapp": "WhatsApp",
    "social.viewProfile": "View profile",
    "social.heroKicker": "// social layer",
    "social.heroLine1": "THE CLUB",
    "social.heroLine2": "MEET YOUR RIVALS.",
    "social.heroIntro": "Cross-league discovery. Follow players, build a crew, and unlock direct chat + WhatsApp when the follow goes both ways.",
    "social.allLeagues": "ALL LEAGUES",
    "social.players": "{n} players",
    "social.player": "{n} player",
    "social.noPlayersFilter": "[ NO PLAYERS MATCH THESE FILTERS. ]",
    "social.mineAnon": "[ Sign in to see your followers, people you follow, and friends. ]",
    "social.mineSignIn": "Sign in",
    "social.empty.friends": "[ NO FRIENDS YET. FOLLOW SOMEONE BACK TO UNLOCK CHAT. ]",
    "social.empty.following": "[ YOU'RE NOT FOLLOWING ANYONE YET. BROWSE THE CLUB. ]",
    "social.empty.followers": "[ NO FOLLOWERS YET. PLAY SOME GOOD MATCHES. ]",
    "social.loadingShort": "LOADING",
    "social.followers": "{n} FOLLOWERS",
    "social.btnFriends": "FRIENDS",
    "social.btnFollowing": "FOLLOWING",
    "social.btnFollow": "+ FOLLOW",
    "social.btnMsg": "MSG",

    // Push notifications
    "push.kicker": "// push notifications",
    "push.title": "Match Day Alerts",
    "push.on": "ON · this device",
    "push.off": "OFF",
    "push.blocked": "BLOCKED — re-enable in browser settings",
    "push.unsupported": "Push isn't supported in this browser. Use Chrome / Edge / Firefox on desktop, or install this app to your home screen on mobile.",
    "push.description": "Get a phone buzz + sound when you have a match today, when an opponent submits a score, when results are confirmed, and when someone invites you to a private league.",
    "push.enable": "Enable Push Alerts",
    "push.disable": "Disable",
    "push.test": "Send Test",
    "push.testSent": "Test push sent — check your device",
    "push.notEnabled": "Push not enabled yet",
    "push.blocked.toast": "Notifications blocked — enable in browser settings",

    // BYOL
    "byol.kicker": "// build your own league",
    "byol.title": "BYOL",
    "byol.subtitle": "Private, invite-only leagues for you and your friends.",
    "byol.create": "Create League",
    "byol.empty": "[ NO BYOL LEAGUES YET. CREATE ONE ABOVE OR OPEN AN INVITE LINK TO JOIN A FRIEND'S LEAGUE. ]",
    "byol.captain": "captain",
    "byol.created": "created",
    "byol.status.pending": "pending",
    "byol.status.open": "open",
    "byol.status.active": "active",
    "byol.status.complete": "complete",
    "byol.loading": "LOADING",
    "byol.new.title": "Create a BYOL League",
    "byol.new.nameLabel": "League name",
    "byol.new.namePlaceholder": "e.g. Sunday Legends",
    "byol.new.sizeLabel": "Max players",
    "byol.new.submit": "Create League",
    "byol.new.submitting": "Creating...",
    "byol.new.toast": "League created — share the invite link!",
    "byol.new.cancel": "Cancel",
    "byol.captainView.inviteTitle": "Invite Link",
    "byol.captainView.copy": "Copy Link",
    "byol.captainView.copied": "Copied!",
    "byol.captainView.share": "Share",
    "byol.captainView.roster": "Roster",
    "byol.captainView.startNow": "Start League Now",
    "byol.captainView.starting": "Starting...",
    "byol.captainView.minPlayers": "Need at least {n} players to start",
    "byol.captainView.autoStart": "Auto-starts at {max} players",
    "byol.captainView.leave": "Leave League",
    "byol.captainView.kick": "Remove",
    "byol.captainView.started": "This league has started. Go to the fixtures page.",
    "byol.captainView.goLeague": "Go to League",
    "byol.invite.title": "You're Invited",
    "byol.invite.subtitle": "A private eFootball league is waiting for you.",
    "byol.invite.joinBtn": "Join League",
    "byol.invite.joining": "Joining...",
    "byol.invite.loginFirst": "Please log in or register to join this private league.",
    "byol.invite.loginBtn": "Log in",
    "byol.invite.registerBtn": "Register",
    "byol.invite.full": "This league is full.",
    "byol.invite.joined": "You've joined the league!",
    "byol.invite.alreadyIn": "You're already in this league.",

    // Match detail / submission
    "md.title": "Match",
    "md.loading": "LOADING MATCH",
    "md.yourScore": "Your score",
    "md.theirScore": "Their score",
    "md.screenshot": "Screenshot",
    "md.uploadScreenshot": "Upload screenshot",
    "md.submit": "Submit Result",
    "md.submitting": "Submitting...",
    "md.retract": "Retract",
    "md.retracting": "Retracting...",
    "md.game1First": "Game 1 must be confirmed by both players before you can submit Game 2",
    "md.alreadyConfirmed": "Match already confirmed",
    "md.submitted": "Result submitted — awaiting opponent",
    "md.confirmed": "Result confirmed",
    "md.proposeReschedule": "Propose New Date",
    "md.withdraw": "Withdraw",

    // Notifications
    "notif.title": "Notifications",
    "notif.empty": "No notifications yet.",
    "notif.markAllRead": "Mark all read",
    "notif.matchReminder": "Match reminder",
    "notif.matchSubmitted": "Opponent submitted",
    "notif.matchConfirmed": "Result confirmed",
    "notif.matchDisputed": "Match disputed",
    "notif.leagueLocked": "League locked",
    "notif.byolInvite": "BYOL invite",

    // Today's games
    "today.title": "Today's Games",
    "today.empty": "No games scheduled for today.",
    "today.loading": "LOADING",
    "today.kickoff": "Kickoff",

    // Schedule badge
    "sb.today": "Today",
    "sb.tomorrow": "Tomorrow",
    "sb.yesterday": "Yesterday",
    "sb.overdue": "Overdue",
    "sb.scheduled": "Scheduled",

    // Chat / DMs
    "chat.title": "Chat",
    "chat.empty": "No conversations yet.",
    "chat.newMessage": "Type a message",
    "chat.send": "Send",
    "chat.loading": "LOADING MESSAGES",

    // Feed / Polls / Likes
    "feed.title": "ePlay Feed",
    "feed.kicker": "// announcements",
    "feed.empty": "[ NO ANNOUNCEMENTS YET — check back soon. ]",
    "feed.adminKicker": "// admin announcement",
    "feed.placeholder": "Post an announcement to every ePlay user…",
    "feed.addImage": "Add image",
    "feed.addVideo": "Add video",
    "feed.broadcast": "Broadcast",
    "feed.posting": "Posting...",
    "feed.posted": "Announcement posted.",
    "feed.edit": "Edit",
    "feed.delete": "Delete",
    "feed.deleteConfirm": "Delete this post?",
    "feed.like": "Like",
    "feed.liked": "Liked",
    "feed.likes": "likes",
    "feed.newPoll": "New Poll",
    "feed.pollTab": "Poll",
    "feed.announceTab": "Announcement",
    "poll.question": "Poll question",
    "poll.questionPh": "What should we decide?",
    "poll.option": "Option",
    "poll.optionPh": "Option {n}",
    "poll.addOption": "+ Add option",
    "poll.removeOption": "Remove",
    "poll.duration": "Duration",
    "poll.dur.1d": "1 day",
    "poll.dur.1w": "1 week",
    "poll.dur.never": "Until closed",
    "poll.submit": "Post Poll",
    "poll.submitting": "Posting...",
    "poll.posted": "Poll published",
    "poll.vote": "Vote",
    "poll.voting": "Voting...",
    "poll.voted": "You voted",
    "poll.closed": "Poll closed",
    "poll.endsIn": "Ends in {when}",
    "poll.endsToday": "Ends today",
    "poll.total": "{n} votes",
    "poll.close": "Close poll",
    "poll.closing": "Closing...",
    "poll.closeConfirm": "Close this poll now? No more votes will be accepted.",
    "poll.badge": "POLL",

    // Admin
    "admin.title": "Admin Panel",
    "admin.users": "Users",
    "admin.leagues": "Leagues",
    "admin.matches": "Matches",
    "admin.analytics": "Analytics",
    "admin.modReports": "Mod Reports",
    "admin.byol": "BYOL",
    "admin.feed": "Feed",
    "admin.nonResponding": "Non-Responding",
    "admin.moderators": "Moderators",

    // Moderators tab
    "mods.kicker": "// promoted users",
    "mods.title": "Moderators",
    "mods.subtitle": "Players you have promoted to moderator. They can file mod reports, resolve disputes, and view player reports. Use the chat or WhatsApp icon to coordinate with them, or demote to revert to player.",
    "mods.refresh": "Refresh",
    "mods.loading": "LOADING MODERATORS",
    "mods.empty": "[ NO MODERATORS YET — promote a player from the Users tab to add them here. ]",
    "mods.col.player": "Moderator",
    "mods.col.contact": "Contact",
    "mods.col.actions": "Actions",
    "mods.dm": "Message",
    "mods.demote": "Demote",
    "mods.demoting": "Demoting…",
    "mods.demoteConfirm": "Demote {name} back to a regular player?",
    "mods.demoteToast": "{name} is now a regular player.",

    // Non-Responding Players (admin)
    "nr.kicker": "// chat-silence forfeits",
    "nr.title": "Non-Responding Players",
    "nr.subtitle": "Matches awarded as 3-0 forfeit because one player chatted on match day and the opponent never replied. Includes both live sweeper resolutions and historical backfill corrections (originally recorded as 0-0 draws).",
    "nr.section.live": "Live forfeits",
    "nr.section.backfilled": "Backfill corrections",
    "nr.refresh": "Refresh",
    "nr.loading": "LOADING NON-RESPONDING LIST",
    "nr.empty.live": "[ NO CHAT-SILENCE FORFEITS ON RECORD. ]",
    "nr.empty.backfilled": "[ NO BACKFILL CORRECTIONS YET — run the chat-forfeit backfill tool to repair old 0-0 draws. ]",
    "nr.col.date": "Match day",
    "nr.col.league": "League",
    "nr.col.winner": "Winner (chatted)",
    "nr.col.loser": "Loser (silent)",
    "nr.col.score": "Final",
    "nr.col.original": "0-0 → 3-0",
    "nr.col.action": "Match",
    "nr.col.view": "View",
    "nr.col.viewChat": "Chat",
    "nr.unknownPlayer": "(deleted)",
    "nr.chat.kicker": "// chat-silence audit",
    "nr.chat.matchDay": "Scheduled",
    "nr.chat.matchDayBadge": "match day",
    "nr.chat.loading": "Loading conversation…",
    "nr.chat.empty": "No messages between these players.",
    "nr.chat.emptyHelp": "Neither player ever opened a DM thread. The forfeit was awarded by some other rule (e.g., admin override or league chat post). Open the match detail to inspect.",
    "nr.chat.errMissingPlayers": "Cannot load chat — one of the players was deleted.",
    "nr.chat.legend.winner": "Awarded winner",
    "nr.chat.legend.loser": "Awarded loser",
    "nr.chat.legend.matchDay": "Sent on match day",
    "nr.chat.counter.winner": "Winner (chatted)",
    "nr.chat.counter.loser": "Loser (silent)",
    "nr.chat.counter.onDay": "on match day",
    "nr.chat.counter.total": "total",

    // Reminders
    "rem.kicker": "// score reminders",
    "rem.title": "Missing Submissions",
    "rem.subtitle": "Players who haven't submitted scores yet — includes today's games and any overdue matches.",
    "rem.empty": "[ ALL CLEAR — every overdue match has both scores. ]",
    "rem.daysOverdue": "{n}d overdue",
    "rem.lastNever": "No reminder sent yet",
    "rem.last": "Last: L{level} · {when}",
    "rem.byAuto": "auto",
    "rem.byAdmin": "by admin/mod",
    "rem.send": "Send Reminder",
    "rem.sending": "Sending...",
    "rem.sent": "Reminder L{level} sent to {name}",
    "rem.maxedOut": "Max level (3) reached for this player",
    "rem.level1": "Level 1 · Friendly nudge",
    "rem.level2": "Level 2 · Warning",
    "rem.level3": "Level 3 · Block warning",

    // Errors / toasts
    "err.network": "Network error",
    "err.notFound": "Not found",
    "err.unauthorized": "Unauthorized",
    "err.required": "Required",

    // Common buttons
    "btn.cancel": "Cancel",
    "btn.save": "Save",
    "btn.delete": "Delete",
    "btn.confirm": "Confirm",
    "btn.close": "Close",
    "btn.back": "Back",
    "btn.next": "Next",
    "btn.edit": "Edit",
    "btn.view": "View",
    "btn.copy": "Copy",
    "btn.share": "Share",
    "btn.loading": "Loading...",

    // Classics league (Parsec PC PES retro)
    "common.yes": "Yes",
    "common.no": "No",
    "common.back": "Back",
    "nav.classics": "Classics",
    "cl.loading": "LOADING CLASSICS...",
    "cl.signinToContinue": "SIGN IN TO ACCESS THE CLASSICS LEAGUE",
    "cl.kicker": "RETRO LEAGUE",
    "cl.title": "CLASSICS",
    "cl.subtitle": "PES 13–21 over Parsec — pure PC nostalgia, head-to-head.",
    "cl.gate.kicker": "ENTRY GATE",
    "cl.gate.q1": "Do you play on PC?",
    "cl.gate.q1Help": "Classics is exclusively for PC players who can run retro PES titles via Parsec remote-play.",
    "cl.gate.q2": "Do you have Parsec installed?",
    "cl.gate.q2Help": "Parsec is the remote-play tool we use for low-latency 1v1 sessions. If you don't have it yet, we'll show you how.",
    "cl.blocked.title": "CLASSICS IS PC-ONLY",
    "cl.blocked.body": "The Classics league requires a PC running PES 13–21 with Parsec for remote-play. If you're on console or mobile, check out the Master League or BYOL instead.",
    "cl.blocked.back": "Back",
    "cl.guide.kicker": "PARSEC SETUP",
    "cl.guide.title": "How to install Parsec",
    "cl.guide.downloadEn": "Guide (EN)",
    "cl.guide.downloadAr": "Guide (AR)",
    "cl.guide.installed": "I've installed it",
    "cl.profile.kicker": "ONE LAST STEP",
    "cl.profile.title": "Complete your profile",
    "cl.profile.body": "We need your nationality and age to enable the Classics league features.",
    "cl.profile.age": "Age",
    "cl.profile.errNat": "Please pick your nationality",
    "cl.profile.errAge": "Please enter a valid age (1–120)",
    "cl.dashboard.kicker": "MY CLASSICS",
    "cl.dashboard.title": "Pick your retro arena",
    "cl.dashboard.settings": "Availability & Parsec",
    "cl.dashboard.mine": "// MY GAMES",
    "cl.dashboard.noGames": "No games joined yet — pick one below to register your role.",
    "cl.dashboard.pickGame": "// PICK A GAME",
    "cl.family.all": "All",
    "cl.comingSoon.kicker": "COMING NEXT",
    "cl.comingSoon.body": "Player browse, match requests, leaderboards and per-game community chat are coming in the next phase. Lock in your availability now so you're ready when it goes live.",
    "cl.role.back": "Back to games",
    "cl.role.title": "Choose your role",
    "cl.role.host": "HOST",
    "cl.role.hostHelp": "You run the game and stream it via Parsec. Requires a fast upload speed (≥30 Mbps recommended).",
    "cl.role.guest": "GUEST",
    "cl.role.guestHelp": "You connect remotely to the host's session via Parsec. A stable 25 Mbps download is enough.",
    "cl.role.hostDisclaimer": "Hosting requires consistent ≥30 Mbps upload to keep latency low. Please run a speed test and confirm before joining as host.",
    "cl.role.speedtestBtn": "Run speed test",
    "cl.role.hostConfirm": "I confirm my upload speed is at least 30 Mbps and I'm ready to host stable Parsec sessions.",
    "cl.role.guestDisclaimer": "As a guest you only need a stable 25 Mbps download — but a wired connection or strong 5GHz Wi-Fi is highly recommended for low input lag.",
    "cl.role.join": "Join {name}",
    "cl.join.toast": "Joined {name} as {role}",
    "cl.leave.toast": "Left {name}",
    "cl.settings.kicker": "PROFILE",
    "cl.settings.title": "Availability & Parsec",
    "cl.settings.saved": "Settings saved",
    "cl.settings.save": "Save",
    "cl.settings.saving": "Saving...",
    "cl.settings.parsec": "Parsec username",
    "cl.settings.parsecPh": "your Parsec handle",
    "cl.settings.parsecHelp": "Other players will use this to send you a Parsec invite.",
    "cl.settings.calKicker": "WEEKLY CALENDAR",
    "cl.settings.calTitle": "When are you available?",
    "cl.settings.calHelp": "Tap any cell to toggle a 1-hour slot. Hours shown in your local timezone.",
    "cl.settings.day.sun": "SUN",
    "cl.settings.day.mon": "MON",
    "cl.settings.day.tue": "TUE",
    "cl.settings.day.wed": "WED",
    "cl.settings.day.thu": "THU",
    "cl.settings.day.fri": "FRI",
    "cl.settings.day.sat": "SAT",

    // Phase 2: browse, requests, matches, request modal
    "cl.browse.title": "Lobby",
    "cl.browse.back": "Back to Classics",
    "cl.browse.openCta": "open lobby",
    "cl.browse.tabPlayers": "Players",
    "cl.browse.tabRequests": "Requests",
    "cl.browse.tabMatches": "Matches",
    "cl.browse.loading": "LOADING LOBBY...",
    "cl.browse.noPlayers": "No other players have joined this game yet — be the first to invite someone.",
    "cl.browse.slots": "slots",
    "cl.browse.requestBtn": "Request",
    "cl.browse.pendingBtn": "Pending",
    "cl.requests.kicker": "PENDING",
    "cl.requests.pendingCount": "{n} pending request(s)",
    "cl.requests.incomingKicker": "// INCOMING",
    "cl.requests.outgoingKicker": "// OUTGOING",
    "cl.requests.noIncoming": "No incoming requests.",
    "cl.requests.noOutgoing": "No outgoing requests.",
    "cl.requests.accept": "Accept",
    "cl.requests.decline": "Decline",
    "cl.requests.cancel": "Cancel",
    "cl.requests.acceptedToast": "Match accepted — chat opened",
    "cl.requests.declinedToast": "Request declined",
    "cl.requests.cancelledToast": "Request cancelled",
    "cl.matches.upcomingKicker": "// UPCOMING CLASSICS MATCHES",
    "cl.matches.noUpcoming": "No upcoming Classics matches yet.",
    "cl.matches.chat": "Chat",
    "cl.matches.anytime": "anytime",
    "cl.request.title": "Request match · {name}",
    "cl.request.proposedAt": "Proposed time",
    "cl.request.optional": "optional",
    "cl.request.message": "Message",
    "cl.request.messagePh": "Say hi or propose a time…",
    "cl.request.send": "Send",
    "cl.request.sending": "Sending...",
    "cl.request.cancel": "Cancel",
    "cl.request.sentToast": "Request sent to {name}",

    // Phase 3: score submission, leaderboard, disputes
    "cl.browse.tabLeaderboard": "Leaderboard",
    "cl.matches.acceptedKicker": "// ACCEPTED",
    "cl.matches.disputedKicker": "// DISPUTED",
    "cl.matches.pastKicker": "// PAST RESULTS",
    "cl.matches.disputeBadge": "Dispute",
    "cl.matches.awaitingOpp": "awaiting opponent",
    "cl.matches.oppSubmitted": "opponent submitted — your turn",
    "cl.matches.processing": "processing…",
    "cl.matches.expired": "Expired",
    "cl.matches.submitScore": "Submit Score",
    "cl.matches.editScore": "Edit Score",
    "cl.score.title": "Score vs {name}",
    "cl.score.helper": "Both players submit their score from their own perspective. If both match, the result is final. If they don't, it's flagged as a dispute for an admin to resolve.",
    "cl.score.myScore": "Your score",
    "cl.score.oppScore": "Opponent's score",
    "cl.score.save": "Submit",
    "cl.score.savedToast": "Score submitted",
    "cl.score.errInvalid": "Both scores must be 0–99 integers",
    "cl.lb.kicker": "// LEADERBOARD",
    "cl.lb.loading": "LOADING LEADERBOARD...",
    "cl.lb.empty": "No completed matches yet — be the first to lock in a result.",
    "cl.lb.player": "Player",
    "cl.lb.form": "Form",
    "clAdm.kicker": "CLASSICS DISPUTES",
    "clAdm.title": "Resolve Classics disputes",
    "clAdm.empty": "No active Classics disputes.",
    "clAdm.loading": "LOADING DISPUTES...",
    "clAdm.resolve": "Resolve",
    "clAdm.reported": "reported",
    "clAdm.notSubmitted": "not submitted",
    "clAdm.modalTitle": "Set final score",
    "clAdm.modalHelp": "Both scores will be force-set as the final result. Both players will receive a push notification.",
    "clAdm.note": "Internal note (optional)",
    "clAdm.cancel": "Cancel",
    "clAdm.confirm": "Confirm Override",
    "clAdm.confirming": "Confirming...",
    "clAdm.resolvedToast": "Classics dispute resolved",
    "clAna.kicker": "CLASSICS ANALYTICS",
    "clAna.title": "Classics performance dashboard",
    "clAna.loading": "LOADING ANALYTICS...",
    "clAna.empty": "No data for the selected family.",
    "clAna.kpiQualified": "Qualified",
    "clAna.kpiActive": "Active",
    "clAna.kpiActiveGames": "Active games",
    "clAna.kpiRequests": "Pending requests",
    "clAna.kpiCompleted": "Completed",
    "clAna.kpiDisputes": "Open disputes",
    "clAna.perGameKicker": "PER-GAME BREAKDOWN",
    "clAna.colGame": "Game",
    "clAna.colPlayers": "Players",
    "clAna.colPending": "Pending requests",
    "clAna.colCompleted": "Completed matches",
    "clAna.colDisputes": "Disputed matches",
    "clAna.colChat": "Chat messages",
    "clAna.colTop": "Top player",
    "clAna.generatedAt": "Generated at",

    // Phase 4: community chat
    "cl.browse.tabChat": "Chat",
    "cl.chat.loading": "LOADING CHAT...",
    "cl.chat.empty": "No messages yet — be the first to say hi.",
    "cl.chat.placeholder": "Type a message…",
    "cl.chat.send": "Send",
    "cl.chat.sending": "Sending...",
    "cl.chat.pinKicker": "PINNED",
    "cl.chat.pinEmpty": "No pinned rules yet.",
    "cl.chat.pinEdit": "Edit",
    "cl.chat.pinSave": "Save",
    "cl.chat.pinCancel": "Cancel",
    "cl.chat.pinSaved": "Pinned message saved",
    "cl.chat.deleteConfirm": "Delete this message?",
    "cl.chat.deleted": "deleted by {by}",
    "cl.chat.errImageType": "Image must be PNG, JPEG or WEBP",
    "cl.chat.errImageSize": "Image must be at most 5 MB",

    // Footer
    "footer.left": "ePLAY // SEASON SYSTEM v1.0",
    "footer.right": "[ 20 PLAYERS · DOUBLE ROUND-ROBIN · 38 MATCHES / PLAYER ]",

    // ─── V2 mobile shell (iter 42 i18n) ───
    // Bottom nav
    "v2.nav.myleague": "My League",
    "v2.nav.explore":  "Explore",
    "v2.nav.social":   "Social",
    "v2.nav.store":    "Store",
    "v2.nav.profile":  "Profile",
    "v2.nav.back2v1":  "← back to v1",
    "v2.shell.preview": "EPLAY · MOBILE PREVIEW",
    "v2.shell.phase":   "v2 / phase 1",
    "v2.shell.loading": "Loading…",

    // V2 Match Detail
    "v2.match.back":              "Back",
    "v2.match.notfound":          "Match not found.",
    "v2.match.scheduled":         "Scheduled",
    "v2.match.home":              "Home",
    "v2.match.away":              "Away",
    "v2.match.you":               "you",
    "v2.match.final":             "Final",
    "v2.match.pending":           "Pending",
    "v2.match.autoDrawn":         "Auto-drawn (both teams no-show)",
    "v2.match.adminOverride":     "Admin override",
    "v2.match.status.confirmed":  "Confirmed",
    "v2.match.status.pending":    "Pending",
    "v2.match.status.disputed":   "Disputed",
    "v2.match.status.scheduled":  "Scheduled",
    "v2.match.status.admin":      "Admin",
    "v2.match.submission.received": "Submitted",
    "v2.match.submission.waiting":  "Waiting",
    "v2.match.submission.empty":    "No score submitted yet",
    "v2.match.submit.title":        "Submit your result",
    "v2.match.submit.help":         "Both players submit independently. Match confirms when both submissions agree.",
    "v2.match.submit.screenshot":   "Tap to upload a screenshot",
    "v2.match.submit.change":       "change",
    "v2.match.submit.pick":         "pick file",
    "v2.match.submit.cta":          "Submit result",
    "v2.match.submit.busy":         "Submitting…",
    "v2.match.toast.noFile":        "Upload a screenshot first.",
    "v2.match.toast.submitted":     "Result submitted.",
    "v2.match.disputed.title":      "Disputed",
    "v2.match.disputed.body":       "Submissions don't match. An admin will review the screenshots and rule shortly.",
    "v2.match.chat.kicker":     "// h2h chat",
    "v2.match.chat.title":      "Chat with {name}",
    "v2.match.chat.rule":       "If you message and your opponent doesn't reply by end of match day, you'll be awarded the match 3-0 (+3 league points). Use this to lock in a kickoff time.",
    "v2.match.chat.placeholder":"Suggest a kickoff time…",
    "v2.match.chat.empty.title":"No messages yet",
    "v2.match.chat.empty.body": "Drop the first message to lock in your kickoff. Your opponent has until end of day to respond.",
    "v2.match.yourScore":   "Your score",
    "v2.match.oppScore":    "Opponent score",
    "v2.match.locked.title":"Game 2 locked",
    "v2.match.locked.body": "You'll be able to submit Game 2 once Game 1 is confirmed by both players (or a mod resolves it).",
    "v2.match.locked.gotoG1":"Go to Game 1",
    "v2.match.mod.kicker":  "// mod tools",
    "v2.match.mod.title":   "Override result",
    "v2.match.mod.help":    "Manually set the final score for this match. Use this to resolve disputes or fix mistaken submissions reported by players. Standings recalculate immediately and both players get a notification.",
    "v2.match.mod.cta.open":      "Override result",
    "v2.match.mod.cta.reoverride":"Change override",
    "v2.match.mod.apply":   "Apply override",
    "v2.match.mod.applied": "Result overridden to {h}–{a}. Standings updated.",



    // V2 Player Profile
    "v2.player.notfound":   "Player not found.",
    "v2.player.error":      "Couldn't load this player. Try again.",
    "v2.player.winRate":    "Win %",
    "v2.player.followers":  "followers",
    "v2.player.following":  "following",
    "v2.player.follow":     "Follow",
    "v2.player.unfollow":   "Unfollow",
    "v2.player.h2h":        "H2H",
    "v2.player.message":    "Message",
    "v2.player.stats":      "Career stats",
    "v2.player.played":     "Played",
    "v2.player.won":        "Won",
    "v2.player.drawn":      "Drawn",
    "v2.player.lost":       "Lost",
    "v2.player.gf":         "GF",
    "v2.player.ga":         "GA",
    "v2.player.gd":         "GD",
    "v2.player.points":     "Points",
    "v2.player.pts":        "PTS",
    "v2.player.wdl":        "W-D-L",
    "v2.player.seasons":    "Seasons",
    "v2.player.form":       "Recent form",
    "v2.player.h2hHistory": "Head-to-head history",
    "v2.player.avatar.tooLarge": "Image too large (max 1MB). Crop or compress first.",
    "v2.player.avatar.updated":  "Profile picture updated.",
    "v2.player.avatar.upload":   "Upload profile picture",
    "v2.player.avatar.replace":  "Replace profile picture",

    // V2 DM thread
    "v2.dm.empty.title":    "No messages yet",
    "v2.dm.empty.body":     "Say hi to schedule your match. Both legs of the same week appear here.",
    "v2.dm.placeholder":    "Type a message…",
    "v2.dm.send":           "Send",

    // V2 H2H room
    "v2.h2h.kicker":              "// head-to-head",
    "v2.h2h.help":                "One game = 2 legs (home + reverse). Both legs are scheduled the same day. Game 2 unlocks once both players confirm Game 1.",
    "v2.h2h.message":             "Message",
    "v2.h2h.profile":              "Profile",
    "v2.h2h.opp":                  "Opponent",
    "v2.h2h.game":                 "Game {n}",
    "v2.h2h.locked":               "Locked until Game 1",
    "v2.h2h.yourSubmission":       "Your submission",
    "v2.h2h.oppSubmission":        "Opponent submission",
    "v2.h2h.cta.submit":           "Submit your result",
    "v2.h2h.cta.waiting":          "Waiting on opponent",
    "v2.h2h.cta.view":             "View match detail",
    "v2.h2h.toast.win":            "✓ Round {round} confirmed — you win {h}-{a}! +3 pts",
    "v2.h2h.toast.loss":           "Round {round} confirmed — final {h}-{a}.",
    "v2.h2h.toast.draw":           "Round {round} confirmed — draw {h}-{a}. +1 pt",
    "v2.h2h.toast.disputed":       "Round {round} disputed — your score didn't match. Admin will review.",
    "v2.h2h.reschedule.cta":       "Reschedule",
    "v2.h2h.reschedule.scheduled": "Scheduled",
    "v2.h2h.reschedule.send":      "Send proposal",
    "v2.h2h.reschedule.accept":    "Accept",
    "v2.h2h.reschedule.withdraw":  "Withdraw",
    "v2.h2h.reschedule.applied":   "Rescheduled to {date}.",
    "v2.h2h.reschedule.proposed":  "Proposal sent — waiting for opponent to confirm {date}.",
    "v2.h2h.reschedule.withdrawn": "Proposal withdrawn.",
    "v2.h2h.reschedule.errFuture": "Pick a future date.",
    "v2.h2h.reschedule.oppProposed": "Opponent proposed {date}",
    "v2.h2h.reschedule.youProposed": "You proposed {date} — waiting on opponent.",



    // V2 AuthGate (mobile login/register at /v2)
    "v2.auth.kicker.signin": "// player sign-in",
    "v2.auth.kicker.signup": "// new player",
    "v2.auth.title.signin":  "Enter the league.",
    "v2.auth.title.signup":  "Create your account.",
    "v2.auth.sub.signin":    "Sign in to submit results, climb standings, and earn tokens.",
    "v2.auth.sub.signup":    "20-player double round-robins, screenshot-verified results, weekly skin drops.",
    "v2.auth.tab.signin":    "Sign In",
    "v2.auth.tab.signup":    "Create Account",
    "v2.auth.or":            "or",
    "v2.auth.googleCta":     "Continue with Google",
    "v2.auth.platform.mobile":  "Mobile",
    "v2.auth.platform.console": "Console",
    "v2.auth.gameid":        "Game ID",
    "v2.auth.whatsapp":      "WhatsApp",
    "v2.auth.nationality":   "Nationality",
    "v2.auth.nationality.placeholder": "Pick your country (optional)",
    "v2.auth.placeholder.username": "your_handle",
    "v2.auth.placeholder.gameid":   "in-game ID / username",
    "v2.auth.placeholder.whatsapp": "+971 5x xxx xxxx",
    "v2.auth.creating":      "Creating account…",
    "v2.auth.create":        "Create Account",
    "v2.auth.haveAccount":   "Already have an account? Sign in",
    "v2.auth.footer":        "ePlay · Master League",


    // MyLeague
    "v2.my.welcome":      "Welcome back",
    "v2.my.season":       "Current Season",
    "v2.my.master":       "Master League",
    "v2.my.players":      "{n}/{m} players",
    "v2.my.viewing":      "· viewing",
    "v2.my.rank":         "Rank",
    "v2.my.points":       "Points",
    "v2.my.gd":           "GD",
    "v2.my.viewHub":      "View League Hub",
    "v2.my.empty.title":  "No active league",
    "v2.my.empty.body":   "Pick a competition from Explore to start a season.",
    "v2.my.empty.cta":    "Browse competitions",
    "v2.my.nextMatch":    "Next Match",
    "v2.my.allMatches":   "All matches",
    "v2.my.noScheduled":  "No matches scheduled",
    "v2.my.scheduled":    "Scheduled",
    "v2.my.seeAll":       "See all",
    "v2.my.recent":       "Recent Results",
    "v2.my.tbd":          "TBD",
    "v2.my.round":        "Round {n}",
    "v2.my.vs":           "vs {opp}",
    "v2.my.auto":         "auto",
    "v2.my.quick":        "Standings",
    "v2.my.myStats":      "My Stats",
    "v2.my.classics":     "Classics",
    "v2.my.byol":         "BYOL",
    "v2.my.picker.title": "Switch League",
    "v2.my.picker.empty": "No leagues available.",
    "v2.my.picker.mine":  "MINE",

    // Explore
    "v2.exp.kicker":       "Explore",
    "v2.exp.title":        "Pick your competition",
    "v2.exp.subtitle":     "Six modes. Five live now.",
    "v2.exp.mobileMaster": "Mobile Master League",
    "v2.exp.consoleMaster":"Console Master League",
    "v2.exp.classicsTitle":"Classics",
    "v2.exp.byolTitle":    "BYOL",
    "v2.exp.byolBody":     "Bring Your Own League — invite-only seasons with your friends.",
    "v2.exp.classicsBody": "Retro PES & FIFA on PC via Parsec.",
    "v2.exp.live":         "LIVE",
    "v2.exp.open":         "OPEN",
    "v2.exp.locked":       "LOCKED",
    "v2.exp.soon":         "SOON",
    "v2.exp.viewLeague":   "View league",
    "v2.exp.openLeague":   "Open",
    "v2.exp.fillProgress": "{n}/{m} · {p}% filled",
    "v2.exp.classics.cta": "Enter Classics",
    "v2.exp.byol.cta":     "Open BYOL",

    // Social
    "v2.soc.kicker":       "Social",
    "v2.soc.title":        "Community",
    "v2.soc.tab.feed":     "Feed",
    "v2.soc.tab.messages": "Messages",
    "v2.soc.tab.discover": "Discover",
    "v2.soc.feed.empty":   "No posts yet — match results land here automatically.",
    "v2.soc.msg.empty":    "No conversations yet.",
    "v2.soc.search":       "Search players or clubs",
    "v2.soc.discover.empty": "No players to discover yet.",
    "v2.soc.search.empty":  "No matches",

    // Profile
    "v2.prof.kicker":         "Profile",
    "v2.prof.title":          "My Account",
    "v2.prof.noClub":         "No club name",
    "v2.prof.reliability":    "Reliability",
    "v2.prof.performance":    "Performance",
    "v2.prof.played":         "Played",
    "v2.prof.won":            "Won",
    "v2.prof.lost":           "Lost",
    "v2.prof.gf":             "GF",
    "v2.prof.ga":             "GA",
    "v2.prof.winPct":         "Win %",
    "v2.prof.loadingStats":   "Loading stats…",
    "v2.prof.settings":       "Settings",
    "v2.prof.language":       "Language",
    "v2.prof.logout":         "Logout",
    "v2.prof.admin":          "Admin",

    // Tokens — wallet + widget + reward
    "v2.tok.balance":     "Balance",
    "v2.tok.tokens":      "tokens",
    "v2.tok.next":        "Next token",
    "v2.tok.pts":         "pts",
    "v2.tok.ratio":       "{n} pts = 1",
    "v2.tok.unlock":      "Spending unlocks when the Store launches.",
    "v2.tok.wallet":      "Token Wallet",
    "v2.tok.earned":      "earned {e} · spent {s}",
    "v2.tok.activity":    "Recent Activity",
    "v2.tok.empty":       "No earned points yet — win matches to start filling your wallet.",
    "v2.tok.simulate":    "Simulate Win (+3 pts)",
    "v2.tok.simulating":  "Simulating…",
    "v2.tok.outcomeWin":  "Win",
    "v2.tok.outcomeDraw": "Draw",
    "v2.tok.outcomeLoss": "Loss",
    "v2.tok.simulated":   "Simulated",
    "v2.tok.simWin":      "Simulated win",
    "v2.tok.runningTotal":"running {pts}",
    "v2.tok.tokenGained": "+{n} token",
    "v2.tok.soon":        "soon",

    // Reward overlay
    "v2.rew.victory":     "Victory",
    "v2.rew.testWin":     "Test win",
    "v2.rew.matchWin":    "Match win",
    "v2.rew.tokenLine":   "+{n} TOKENS",
    "v2.rew.tokenLineOne":"+1 TOKEN",
    "v2.rew.pointsLine":  "+{n} POINTS",
    "v2.rew.totalBalance":"Total balance",
    "v2.rew.continue":    "Continue",

    // Store
    "v2.store.kicker":      "Store",
    "v2.store.title":       "Profile Skins",
    "v2.store.balance":     "Your balance",
    "v2.store.career":      "{n} career pts",
    "v2.store.skins":       "Skins",
    "v2.store.teasers":     "Coming Soon — Borders & Frames",
    "v2.store.footer":      "// earn tokens by winning matches // {n} pts = 1 token //",
    "v2.store.redeem":      "Redeem",
    "v2.store.locked":      "Locked",
    "v2.store.apply":       "Apply",
    "v2.store.remove":      "Remove",
    "v2.store.active":      "Active",
    "v2.store.unlocked":    "{name} unlocked!",
    "v2.store.applied":     "{name} applied",
    "v2.store.removed":     "Skin removed",
    "v2.store.errRedeem":   "Couldn't redeem",
    "v2.store.errApply":    "Apply failed",
    "v2.store.needMore":    "Need {n} more tokens",

    // Skins (display name + tagline)
    "v2.skin.bronze.name":     "Bronze",
    "v2.skin.bronze.tagline":  "Start the climb",
    "v2.skin.bronze.label":    "BRONZE",
    "v2.skin.elite.name":      "Elite",
    "v2.skin.elite.tagline":   "Sharpen the edge",
    "v2.skin.elite.label":     "ELITE",
    "v2.skin.legend.name":     "Legend",
    "v2.skin.legend.tagline":  "Earn your gold",
    "v2.skin.legend.label":    "LEGEND",
    "v2.skin.phantom.name":    "Phantom",
    "v2.skin.phantom.tagline": "Vanish with the win",
    "v2.skin.phantom.label":   "PHANTOM",
    "v2.skin.egypt_pharaohs.name":    "Egypt Pharaohs",
    "v2.skin.egypt_pharaohs.tagline": "Rule the Nile",
    "v2.skin.egypt_pharaohs.label":   "PHARAOHS",
    "v2.skin.algeria_fennecs.name":    "Algeria Fennecs",
    "v2.skin.algeria_fennecs.tagline": "Desert Warriors",
    "v2.skin.algeria_fennecs.label":   "FENNECS",
    "v2.skin.saudi_falcons.name":    "Saudi Falcons",
    "v2.skin.saudi_falcons.tagline": "Soar Above All",
    "v2.skin.saudi_falcons.label":   "FALCONS",
    "v2.skin.morocco_atlas.name":    "Morocco Atlas Lions",
    "v2.skin.morocco_atlas.tagline": "Roar of the Atlas",
    "v2.skin.morocco_atlas.label":   "ATLAS LIONS",

    // My Skins
    "v2.myskins.title":     "My Skins",
    "v2.myskins.owned":     "{n} owned",
    "v2.myskins.empty":     "No skins owned yet.",
    "v2.myskins.cta":       "Visit the Store →",
    "v2.myskins.store":     "Store",

    // League Hub (V2)
    "v2.hub.error":          "League not available",
    "v2.hub.back":           "Back",
    "v2.hub.tab.standings":  "Standings",
    "v2.hub.tab.fixtures":   "Fixtures",
    "v2.hub.tab.players":    "Players",
    "v2.hub.tab.feed":       "Feed",
    "v2.hub.tab.chat":       "Chat",
    "v2.hub.players.you":    "YOU",
    "v2.hub.players.dm":     "DM",
    "v2.hub.players.empty":  "No players drafted yet.",
    "v2.hub.standings.empty":"No standings yet — matches haven't been played.",
    "v2.hub.fixtures.openEmpty":"Fixtures will be generated when the league fills up.",
    "v2.hub.fixtures.empty": "No fixtures yet.",
    "v2.cal.today":      "Today",
    "v2.cal.tomorrow":   "Tomorrow",
    "v2.cal.yesterday":  "Yesterday",
    "v2.cal.inDays":     "in {n} days",
    "v2.cal.daysAgo":    "{n} days ago",
    "v2.cal.tbd.line1":  "TBD",
    "v2.cal.tbd.line2":  "—",
    "v2.cal.matchCount": "{n} match",
    "v2.cal.matchCount_plural": "{n} matches",

    // V2 My Matches
    "v2.mm.kicker":     "// schedule",
    "v2.mm.title":      "My matches",
    "v2.mm.filter.upcoming": "Upcoming",
    "v2.mm.filter.recent":   "Recent",
    "v2.mm.filter.all":      "All",
    "v2.mm.empty.upcoming":  "No upcoming matches. You're all caught up — check back when the next round drops.",
    "v2.mm.empty.recent":    "No confirmed results yet. Submit a screenshot to record your first match.",
    "v2.mm.empty.all":       "No matches in any league yet.",
    "v2.mm.won":  "Won",
    "v2.mm.lost": "Lost",
    "v2.mm.drawn":"Drawn",

    // V2 Account
    "v2.acc.kicker":        "// settings",
    "v2.acc.title":         "Account",
    "v2.acc.lang.kicker":   "// language",
    "v2.acc.lang.title":    "Language",
    "v2.acc.pass.kicker":   "// security",
    "v2.acc.pass.title":    "Change password",
    "v2.acc.pass.old":      "Current password",
    "v2.acc.pass.new":      "New password (min 6 chars)",
    "v2.acc.pass.cta":      "Update password",
    "v2.acc.pass.busy":     "Updating…",
    "v2.acc.pass.toast":    "Password updated.",
    "v2.acc.pass.errShort": "New password must be at least 6 characters.",
    "v2.acc.exit.kicker":   "// league",
    "v2.acc.exit.title":    "Exit current league",
    "v2.acc.exit.body":     "You'll be removed from your league and any unplayed matches forfeit. You'll be placed into a new open league if one is available.",
    "v2.acc.exit.confirmPh":"Type EXIT to confirm",
    "v2.acc.exit.cta":      "Exit league",
    "v2.acc.exit.errConfirm":"Type EXIT exactly to confirm.",
    "v2.acc.del.kicker":    "// danger zone",
    "v2.acc.del.title":     "Delete account",
    "v2.acc.del.body":      "This permanently deletes your profile, stats, and chat history. All unplayed matches forfeit.",
    "v2.acc.del.cta":       "Delete my account",
    "v2.acc.del.passPh":    "Your password",
    "v2.acc.del.confirmPh": "Type DELETE to confirm",
    "v2.acc.del.cancel":    "Cancel",
    "v2.acc.del.confirmCta":"Delete forever",
    "v2.acc.del.warn":      "This action cannot be undone.",
    "v2.acc.del.errConfirm":"Type DELETE exactly to confirm.",

    // V2 Notifications
    "v2.notif.kicker":     "// inbox",
    "v2.notif.title":      "Notifications",
    "v2.notif.markAll":    "Mark all read",
    "v2.notif.empty.title":"You're all caught up",
    "v2.notif.empty.body": "Match invites, results, follows and chat messages will show up here.",
    "v2.notif.fallback":   "New notification",

    // V2 push notifications opt-in card
    "v2.push.kicker":  "// stay in the loop",
    "v2.push.title":   "Turn on match alerts",
    "v2.push.body":    "Get a ping the moment your opponent submits a score, when your match confirms, or when a new round drops.",
    "v2.push.enable":  "Enable",
    "v2.push.busy":    "Asking…",
    "v2.push.later":   "Not now",
    "v2.push.dismiss": "Dismiss",
    "v2.push.toast.on":     "Notifications on — we'll ping you when it matters.",
    "v2.push.toast.denied": "Notifications blocked. Enable them in your browser settings to opt in later.",
    "v2.push.toast.failed": "Couldn't enable notifications. Try again later.",

    // V2 World Cup mode banners (pre-launch)
    "v2.wc.kicker":         "// world cup mode",
    "v2.wc.tagline":        "Live now · Reveal a team · Anonymous matchmaking · Climb the standings",
    "v2.wc.soon":           "Coming Soon",
    "v2.wc.testing":        "TESTING",
    "v2.wc.cta.join":       "Join Now",
    "v2.wc.mobile.title":   "World Cup · Mobile",
    "v2.wc.mobile.sub":     "Anonymous matchmaking · 4 weeks · 20 games per week",
    "v2.wc.console.title":  "World Cup · Console",
    "v2.wc.console.sub":    "Anonymous matchmaking · 4 weeks · 20 games per week",
    "v2.wc.cta.players":    "Join Now",
    "v2.wc.cta.staff":      "Open mode",
    "v2.wc.spec.title":     "How it works",
    // WC page tabs / labels
    "v2.wc.tab.play":       "Play",
    "v2.wc.tab.stats":      "My Stats",
    "v2.wc.tab.standings":  "Standings",
    "v2.wc.tab.timeline":   "Timeline",
    "v2.wc.tab.admin":      "Admin",
    "v2.wc.tab.rules":      "Rules",
    "v2.wc.reveal.cta":     "Reveal my team",
    "v2.wc.reveal.again":   "Reveal again",
    "v2.wc.notice.testing": "TESTING — all results will be reset before the official World Cup start date. 20 games per week applies as if real.",
    "v2.wc.week":           "Week",
    "v2.wc.champions":      "Champions Week",
    "v2.wc.champions.sub":  "Top 100 mobile · Top 50 console qualify",
    "v2.wc.cap":            "{played}/{cap} games this week",
    "v2.wc.next.ends":      "Week ends in",
    "v2.wc.players.title":  "Online Players",
    "v2.wc.players.empty":  "No anonymous players online right now. Stay on this page — new players appear as soon as they reveal.",
    "v2.wc.send.invite":    "Send invite",
    "v2.wc.invites.in":     "Invitations received",
    "v2.wc.invites.out":    "Invitations sent",
    "v2.wc.accept":         "Accept",
    "v2.wc.decline":        "Decline",
    "v2.wc.cancel":         "Cancel",
    "v2.wc.match.host":     "HOST — create the room and share the code",
    "v2.wc.match.guest":    "GUEST — join the host's room",
    "v2.wc.match.forfeit":  "Leave (counts as a 0-3 loss)",
    "v2.wc.match.report":   "Report opponent",
    "v2.wc.report.title":   "Report this player",
    "v2.wc.report.rules":   "3 reports = warning. 4 reports = automatic removal from the World Cup league. Use this only for cheating, abuse, or refusing to play.",
    "v2.wc.report.submit":  "Submit report",
    "v2.wc.removed.title":  "Removed from World Cup",
    "v2.wc.removed.body":   "You have been removed from the World Cup league this season due to repeated reports.",
    "v2.wc.warning.body":   "You have 3 reports against you. One more and you will be automatically removed from the league.",
    "v2.wc.qualifies":      "QUALIFIES",
    "v2.wc.standings.empty": "No matches confirmed yet. Be the first.",
    "v2.wc.host":           "HOST",
    "v2.wc.guest":          "GUEST",

    // V2 Friendlies banner / page
    "v2.fr.kicker":         "// international friendlies",
    "v2.fr.tagline":        "Live now · Reveal a team · Invite anyone · Climb the standings",
    "v2.fr.live":           "LIVE",
    "v2.fr.banner.title":   "International Friendlies",
    "v2.fr.banner.sub":     "Reveal a random national team & challenge any player",
    "v2.fr.banner.cta":     "Reveal your team",

    // V2 UFL banners (iter 86 — Mobile is LIVE, Console removed)
    "v2.ufl.kicker":        "// ufl",
    "v2.ufl.tagline":       "Authentic squads · Mobile · Live now",
    "v2.ufl.console.title": "UFL · Console",
    "v2.ufl.console.sub":   "Console-only league for UFL pros — group stage + knockouts",
    "v2.ufl.mobile.title":  "UFL · Mobile",
    "v2.ufl.mobile.sub":    "Mobile-only league for UFL pros — group stage + knockouts",
    "v2.ufl.mobile.subLive":"Quick Play 4-player rooms · Create or join teams",
    "v2.ufl.livePill":      "Live",
    "v2.ufl.cta.enter":     "Tap to enter",

    // V2 UFL Hub & flows (iter 86)
    "ufl.hub.kicker":            "// UFL · Mobile",
    "ufl.hub.title":             "UFL Mobile",
    "ufl.hub.sub":               "Find a squad. Earn credibility. Climb the ladder.",
    "ufl.hub.quickPlay.title":   "Quick Play",
    "ufl.hub.quickPlay.sub":     "Match with 4 random players",
    "ufl.hub.teams.title":       "Create / Join Team",
    "ufl.hub.teams.sub":         "Build your invite-only squad",
    "ufl.hub.teams.premium":     "Premium · Thrive for Free",
    "ufl.hub.credibility":       "Credibility",
    "ufl.hub.gamesRated":        "{n} games rated",
    "ufl.hub.history":           "History",
    "ufl.hub.back":              "Back",

    "ufl.qp.idle.title":         "Find a Game",
    "ufl.qp.idle.body":          "Tap below to join the queue. Once 2 players are matched, a 1-minute timer starts — when the 4th joins, the room locks instantly.",
    "ufl.qp.idle.uflName":       "Your UFL username",
    "ufl.qp.idle.uflNamePh":     "e.g. ProStriker99 — shared in chat when the room locks",
    "ufl.qp.exitRoom":           "Leave — not responding",
    "ufl.qp.toast.leftRoom":     "You left the room.",
    "ufl.qp.idle.queueLine":     "{n} {label} in queue",
    "ufl.qp.idle.queuePlayer":   "player",
    "ufl.qp.idle.queuePlayers":  "players",
    "ufl.qp.idle.estimated":     "Estimated wait: ~{secs}s",
    "ufl.qp.idle.joinBtn":       "Quick Play · Join queue",
    "ufl.qp.queuing.title":      "Searching for players…",
    "ufl.qp.queuing.body":       "You'll be matched as soon as someone else queues. Waiting time depends on traffic.",
    "ufl.qp.queuing.position":   "{n} {label} waiting",
    "ufl.qp.queuing.leaveBtn":   "Leave queue",
    "ufl.qp.matched.leaveBtn":   "Leave room",
    "ufl.qp.matched.title":      "Room found",
    "ufl.qp.matched.body":       "Waiting for more players · {n}/{cap}",
    "ufl.qp.matched.countdown":  "Locking in {ss}s",
    "ufl.qp.locked.title":       "Room locked",
    "ufl.qp.locked.body":        "{n} players · chat for {mins}min, then it closes.",
    "ufl.qp.locked.chatLeft":    "Chat closes in {ss}",
    "ufl.qp.closed.title":       "Chat closed",
    "ufl.qp.closed.body":        "Rate every other player from 1–5 to earn a token.",
    "ufl.qp.rate.title":         "Rate this player",
    "ufl.qp.rate.note":          "Every player must rate every other player. Once all ratings are in, each member earns 1 token.",
    "ufl.qp.rate.you":           "you",
    "ufl.qp.rate.done":          "✓ rated",
    "ufl.qp.chat.placeholder":   "Send a message",
    "ufl.qp.chat.empty":         "Say hi — coordinate a UFL match together.",
    "ufl.qp.addFriend":          "Add friend",
    "ufl.qp.alreadyFriend":      "Friends ✓",
    "ufl.qp.tokenEarned":        "+1 token earned",
    "ufl.qp.toast.queued":       "You're in the queue.",
    "ufl.qp.toast.leftQueue":    "Left the queue.",
    "ufl.qp.toast.locked":       "Room locked — chat is now open.",
    "ufl.qp.toast.rated":        "Rating saved.",

    "ufl.teams.title":           "Teams",
    "ufl.teams.sub":             "Premium · Thrive for Free",
    "ufl.teams.disclaimer":      "Premium Feature, Thrive for Free — this will become a paid feature in the future.",
    "ufl.teams.create":          "Create team",
    "ufl.teams.namePlaceholder": "Team name (2–40 chars)",
    "ufl.teams.createBtn":       "Create",
    "ufl.teams.invitesTitle":    "Pending invites for you",
    "ufl.teams.myTeams":         "Your teams",
    "ufl.teams.captain":         "Captain",
    "ufl.teams.member":          "Member",
    "ufl.teams.membersCount":    "{n} {label}",
    "ufl.teams.memberSingular":  "member",
    "ufl.teams.memberPlural":    "members",
    "ufl.teams.copyLink":        "Copy invite link",
    "ufl.teams.copied":          "Link copied",
    "ufl.teams.invite":          "Invite by username",
    "ufl.teams.inviteSend":      "Send",
    "ufl.teams.pendingInvites":  "Pending invites",
    "ufl.teams.pendingRequests": "Pending join requests",
    "ufl.teams.accept":          "Accept",
    "ufl.teams.decline":         "Decline",
    "ufl.teams.leave":           "Leave team",
    "ufl.teams.delete":          "Delete team",
    "ufl.teams.empty":           "You're not in any team yet. Create one or accept an invite.",
    "ufl.teams.shareHint":       "Share this link with anyone you want on your squad. They'll send a join request you can approve.",
    "ufl.teams.requestSent":     "Join request sent — wait for captain to approve.",
    "ufl.teams.alreadyMember":   "You're already on this team.",




    "v2.hub.feed.empty":     "No posts yet — match results land here automatically.",
    "v2.hub.chat.empty":     "No messages yet — say hi 👋",
    "v2.hub.chat.placeholder":"Type a message",
    "v2.hub.fillPct":        "{n}/{m} players · {p}% filled",
    "v2.hub.openTag":        "Open",

    // Common
    "v2.common.loading":     "Loading…",
    "v2.common.cancel":      "Cancel",
    "v2.common.close":       "Close",
    "v2.common.done":        "Done",

    // ========== Pro Clubs (pcl.*) ==========
    "pcl.title":              "Pro Clubs",
    "pcl.kicker":             "// EA FC Pro Clubs",
    "pcl.backToHub":          "back",
    "pcl.tab.team":           "Team",
    "pcl.tab.fixtures":       "Fixtures",
    "pcl.tab.standings":      "Standings",
    "pcl.league.current":     "current league",
    "pcl.league.seasonOf":    "Season #{n} — {pool}",
    "pcl.league.progress":    "{registered}/10 teams registered",
    "pcl.league.toKickOff":   "{n} more to kick off",
    "pcl.invites.kicker":     "your invites",
    "pcl.invites.captain":    "Captain @{name}",
    "pcl.invites.accept":     "Accept",
    "pcl.invites.decline":    "Decline",
    "pcl.create.kicker":      "Captain — create your team",
    "pcl.create.namePh":      "Team name",
    "pcl.create.btn":         "Create team",
    "pcl.create.subtitle":    "You'll be captain. Invite up to 9 more players. League starts the moment 10 teams have registered.",
    "pcl.create.tooShort":    "Team name too short",
    "pcl.create.failed":      "Couldn't create team.",
    "pcl.create.success":     "Team created! Invite up to 9 more players.",
    "pcl.team.squad":         "Squad",
    "pcl.team.size":          "{size}/10 players · {pool} pool",
    "pcl.team.invitePh":      "User ID to invite",
    "pcl.team.inviteOk":      "Invite sent",
    "pcl.team.inviteFail":    "Couldn't invite",
    "pcl.team.actionOk":      "Done",
    "pcl.team.actionFail":    "Action failed",
    "pcl.role.captain":       "captain",
    "pcl.role.deputy":        "deputy",
    "pcl.role.player":        "player",
    "pcl.role.you":           "◂ you",
    "pcl.role.promote":       "+Deputy",
    "pcl.role.transfer":      "+C",
    "pcl.role.kick":          "Kick",
    "pcl.fx.empty":           "League hasn't started yet. Fixtures publish the moment 10 teams have joined.",
    "pcl.fx.matchday":        "Matchday",
    "pcl.fx.notFound":        "Fixture not found.",
    "pcl.fx.backToHub":       "back to Pro Clubs",
    "pcl.fx.readOnly":        "View-only — only the two competing teams' officers can submit or chat.",
    "pcl.fx.tabSubmit":       "Submit",
    "pcl.fx.tabChat":         "Chat",
    "pcl.fx.tabResch":        "Reschedule",
    "pcl.fx.scorers":         "Goal scorers",
    "pcl.fx.home":            "Home",
    "pcl.fx.away":            "Away",
    "pcl.status.scheduled":   "scheduled",
    "pcl.status.awaiting":    "awaiting scores",
    "pcl.status.confirmed":   "confirmed",
    "pcl.status.disputed":    "disputed",
    "pcl.sub.title":          "Final score",
    "pcl.sub.yourGoals":      "Your goals",
    "pcl.sub.oppGoals":       "Opp goals",
    "pcl.sub.scorers":        "Goal scorers",
    "pcl.sub.noScorers":      "Add a scorer per goal once you set your team's score (own goals allowed).",
    "pcl.sub.pickPlayer":     "pick scorer",
    "pcl.sub.ownGoal":        "Own goal",
    "pcl.sub.addScorer":      "+ Add scorer",
    "pcl.sub.goals":          "goals",
    "pcl.sub.screenshot":     "Screenshot of final score",
    "pcl.sub.pickFile":       "Pick screenshot",
    "pcl.sub.submitBtn":      "Submit score",
    "pcl.sub.alreadySent":    "Your team already submitted — waiting for the other captain.",
    "pcl.sub.oppSubmitted":   "Other team has submitted — your turn.",
    "pcl.sub.needScreenshot": "Attach a screenshot of the final score.",
    "pcl.sub.sumMismatch":    "Sum of scorers' goals must match your team's score.",
    "pcl.sub.failed":         "Submission failed.",
    "pcl.sub.recorded":       "Score recorded — awaiting the other team.",
    "pcl.sub.confirmed":      "Score confirmed!",
    "pcl.sub.disputed":       "Scores disagree — moderator will review.",
    "pcl.chat.placeholder":   "Type a message…",
    "pcl.chat.empty":         "No messages yet. Start the conversation.",
    "pcl.chat.failed":        "Couldn't send message.",
    "pcl.rs.proposeTitle":    "Propose a new date",
    "pcl.rs.proposeBody":     "Both captains must agree before the calendar updates.",
    "pcl.rs.proposeBtn":      "Send proposal",
    "pcl.rs.pickDate":        "Pick a new date first.",
    "pcl.rs.proposed":        "Proposal sent — waiting for the other captain.",
    "pcl.rs.accepted":        "Reschedule accepted — calendar updated.",
    "pcl.rs.declined":        "Reschedule declined.",
    "pcl.rs.acceptBtn":       "Accept",
    "pcl.rs.declineBtn":      "Decline",
    "pcl.rs.recent":          "Recent proposals (this session)",
    "pcl.rs.failed":          "Reschedule failed.",

    // ============================================================
    // WC 2026 — Hub, modes, locked view (iter 81+85)
    // ============================================================
    "wc26.back":               "Back",
    "wc26.hub.subtitle":       "Choose your path to the trophy.",
    "wc26.hub.unitedAsOne":    "United · As · One",
    "wc26.hero.united":        "UNITED",
    "wc26.hero.as":            "AS",
    "wc26.hero.one":           "ONE",
    "wc26.host.mexico":        "Mexico",
    "wc26.host.usa":           "USA",
    "wc26.host.canada":        "Canada",
    "wc26.fact.teams":         "Teams",
    "wc26.fact.cities":        "Cities",
    "wc26.fact.matches":       "Matches",
    "wc26.fact.days":          "Days",
    "wc26.staffPreview":       "Staff preview",
    "wc26.staffPreview.body":  "Public access unlocks 24h before kickoff. Players currently see countdown + rules + Notify toggles.",
    "wc26.locked.title":       "Player access unlocks",
    "wc26.locked.firstMatch":  "First match · Jun 11, 2026 · 12:00 ET (Mexico vs South Africa)",
    "wc26.locked.howItWorks":  "How it will work",
    "wc26.locked.threeModes":  "3 modes · 1 trophy",
    "wc26.locked.footer":      "See you on the pitch.",
    "wc26.notify.on":          "We'll notify you",
    "wc26.notify.off":         "Notify me",
    "wc26.notify.signin":      "Sign in to opt in for alerts.",
    "wc26.notify.success":     "We'll ping you when this mode unlocks.",
    "wc26.notify.removed":     "Notification off.",
    "wc26.enter":              "Enter",
    "wc26.kickoff":            "Kickoff in",
    "wc26.opensIn":            "Opens in",
    "wc26.mode.tournament.chapter":   "01 · Authentic",
    "wc26.mode.tournament.title":     "48-Team Tournament",
    "wc26.mode.tournament.tagline":   "Pick a nation. Defend the badge. One trophy.",
    "wc26.mode.tournament.hook":      "Pick a nation. Defend the badge. One trophy.",
    "wc26.mode.immersion.chapter":    "02 · Immersion",
    "wc26.mode.immersion.title":      "Immersion — Daily League",
    "wc26.mode.immersion.tagline":    "Live the real World Cup. Random team every day.",
    "wc26.mode.immersion.hook":       "Live the real World Cup. Random team every day. Same fixture they're playing.",
    "wc26.mode.dreamteam.chapter":    "03 · Dream Team",
    "wc26.mode.dreamteam.title":      "Dream Team — Weekly Quotas",
    "wc26.mode.dreamteam.tagline":    "Build a squad the world hasn't seen. Beat anyone who plays the same rules.",
    "wc26.mode.dreamteam.hook":       "Build a squad the world hasn't seen. Beat anyone who plays the same rules.",
    "wc26.rules.tournament.1":   "First 48 sign-ups per platform fill the bracket. Pick any of the 48 real nations.",
    "wc26.rules.tournament.2":   "12 groups of 4 · 6 round-robin matches · top 2 per group + 8 best 3rds advance.",
    "wc26.rules.tournament.3":   "R32 → R16 → QF → SF: two-leg ties — home and away, away-goals rule, extra time, penalties.",
    "wc26.rules.tournament.4":   "Final + 3rd-place playoff: single leg with ET and penalties.",
    "wc26.rules.tournament.5":   "Mobile and console run independent brackets. One champion per platform.",
    "wc26.rules.immersion.1":    "Every real match day, you're auto-assigned a random team from the day's pool.",
    "wc26.rules.immersion.2":    "Your opponent drew the team yours faces in that real fixture — the exact matchup the world is watching.",
    "wc26.rules.immersion.3":    "Each pairing plays TWO matches: home leg + away leg, same opponent both legs.",
    "wc26.rules.immersion.4":    "Points accumulate across 33 days. After each stage, the bottom 70% are cut — only top 30% survive.",
    "wc26.rules.immersion.5":    "Shards cap at 1,000 players. All shard champions face off in a Grand Final on Jul 19.",
    "wc26.rules.immersion.6":    "Win = 3 pts · Draw = 1 · Loss = 0. Coordinate kickoff in the match chat.",
    "wc26.rules.dreamteam.1":    "Every Monday 00:00 UTC: 20 fresh continental quotas are revealed for the week.",
    "wc26.rules.dreamteam.2":    "Declare a 24-player squad: 8 DEF / 8 MID / 8 FWD matching your chosen game's quota.",
    "wc26.rules.dreamteam.3":    "Server validates your squad — no honor-system loopholes.",
    "wc26.rules.dreamteam.4":    "Win = 3 + (your goals − opponent's goals) · Draw = 1 · Loss = 0.",
    "wc26.rules.dreamteam.5":    "Top 3 of each Monday-to-Monday cycle enter the Hall of Fame.",
    "wc26.rules.dreamteam.6":    "Suspicious squad? File a screenshot report. Repeat offenders get banned.",
    "wc26.rules.dreamteam.7":    "Only current real players allowed — no retired players in your squad.",
    "wc26.rules.dreamteam.8":    "Maximum one Booster player card allowed per squad.",
    "wc26.authentic.subhubTitle":     "Authentic · Choose Format",
    "wc26.authentic.subhubSub":       "Both formats count toward the same trophy.",
    "wc26.dreamteam.subhubTitle":     "Dream Team — Pick Platform",
    "wc26.dreamteam.subhubSub":       "One mode. Two pools. Weekly quotas reset every Monday.",
    // Mode entry pages (dedicated per-mode landings)
    "wc26.entry.format":        "Format",
    "wc26.entry.schedule":      "Schedule",
    "wc26.entry.feel":          "What it feels like",
    "wc26.entry.hook.label":    "The hook",
    "wc26.entry.pickPlatform":  "Choose your platform",
    "wc26.entry.platformNote":  "Pick once on entry — keeps the matchups fair.",
    "wc26.entry.enter":         "Enter",
    "wc26.entry.openMobile":    "Open on the new mobile shell:",
    "wc26.entry.backToHub":     "All modes",
    "wc26.entry.locked":        "Opens 24h before kickoff",
    "wc26.card.sched.tournament": "~4 weeks · Jun 11 – Jul 19",
    "wc26.card.sched.immersion":  "33 match days · Final Jul 19",
    "wc26.card.sched.dreamteam":  "Weekly · resets every Monday",
    // Mode 01 — Tournament feel + schedule
    "wc26.tournament.feel":     "Sign up, claim a nation, and dig in for ~4 weeks of real competition. The group stage is grueling — six matches in seven days. Survive the cut and the knockout rounds get tense: you only progress if you outscore your opponent over two legs.",
    "wc26.tournament.sched.1.label": "Group stage closes",
    "wc26.tournament.sched.1.date":  "~Jun 27",
    "wc26.tournament.sched.2.label": "Bracket runs through",
    "wc26.tournament.sched.2.date":  "Jul 19",
    "wc26.tournament.stat.1":   "Nations",
    "wc26.tournament.stat.2":   "Groups of 4",
    "wc26.tournament.stat.3":   "Bracket",
    // Mode 02 — Immersion feel + schedule
    "wc26.immersion.feel":      "Open the app on June 11. Mexico is playing South Africa. You tap \"Roll my team\" — flags cycle and settle on 🇲🇽 Mexico. You're matched with the player who drew South Africa. Two matches today: home leg, away leg. Submit, confirm, bank your points. Tomorrow, a new team.",
    "wc26.immersion.sched.1.label": "Group Stage",
    "wc26.immersion.sched.1.date":  "Jun 11 – 27",
    "wc26.immersion.sched.2.label": "Round of 32",
    "wc26.immersion.sched.2.date":  "Jun 28 – Jul 3",
    "wc26.immersion.sched.3.label": "Round of 16",
    "wc26.immersion.sched.3.date":  "Jul 4 – 7",
    "wc26.immersion.sched.4.label": "Quarterfinals",
    "wc26.immersion.sched.4.date":  "Jul 9 – 11",
    "wc26.immersion.sched.5.label": "Semifinals",
    "wc26.immersion.sched.5.date":  "Jul 14 – 15",
    "wc26.immersion.sched.6.label": "Grand Final",
    "wc26.immersion.sched.6.date":  "Jul 19",
    "wc26.immersion.stat.1":    "Match days",
    "wc26.immersion.stat.2":    "Per shard",
    "wc26.immersion.stat.3":    "Survive each cut",
    // Mode 03 — Dream Team feel + schedule
    "wc26.dreamteam.feel":      "It's Monday morning. A new cycle just dropped. You scroll the 20 quotas — Game 7 wants 8 EUR / 8 AFR / 6 ASI / 2 AMR. Spicy. You hand-pick 24 players that fit, commit your squad — server validates ✓. Enter the lobby, invite the highest-rated opponent, win 3-1 with a goal-diff bonus. +5 for the cycle.",
    "wc26.dreamteam.sched.1.label": "Cycle begins",
    "wc26.dreamteam.sched.1.date":  "Mon 00:00 UTC",
    "wc26.dreamteam.sched.2.label": "Games per cycle",
    "wc26.dreamteam.sched.2.date":  "20",
    "wc26.dreamteam.sched.3.label": "Resets",
    "wc26.dreamteam.sched.3.date":  "Every Monday",
    "wc26.dreamteam.stat.1":    "Weekly quotas",
    "wc26.dreamteam.stat.2":    "Player squad",
    "wc26.dreamteam.stat.3":    "Make Hall of Fame",
    "wc26.platform.mobile":     "Mobile",
    "wc26.platform.console":    "Console",
    "wc26.platform.openOnV2":   "Open on the new mobile shell:",
    // Tournament + Immersion + DreamTeam page chrome
    "wc26.chip.tournament":     "Authentic · 48-Team Tournament",
    "wc26.chip.immersion":      "Authentic · Immersion · Daily League",
    "wc26.chip.dreamteam":      "Dream Team · Weekly Quotas",
    // Immersion League V2 tabs
    "wc26.league.tabs.home":      "Home",
    "wc26.league.tabs.myleague":  "My League",
    "wc26.league.tabs.today":     "Today",
    "wc26.league.tabs.schedule":  "Schedule",
    "wc26.league.tabs.history":   "History",
    "wc26.league.register":       "Register for this pool",
    "wc26.league.registered":     "Registered",
    "wc26.league.coordinate":     "Coordinate kickoff in the chat below — then submit",
    "wc26.league.submitResult":   "Submit result",
    "wc26.league.awaiting":       "Awaiting opponent confirmation.",
    "wc26.league.replaying":      "Replaying real fixture:",
    "wc26.league.you":            "YOU",
    "wc26.league.opponent":       "opponent",
    "wc26.league.chat.title":     "Coordinate kickoff",
    "wc26.league.chat.empty":     "No messages yet. Use a quick reply or type below.",
    "wc26.league.chat.placeholder": "Type a message…",
    "wc26.league.chat.send":      "Send",
    "wc26.league.chip.ready":     "Ready?",
    "wc26.league.chip.5min":      "5 min",
    "wc26.league.chip.10min":     "Need 10 min",
    "wc26.league.chip.gg":        "GG",
    "wc26.league.chip.tomorrow":  "Same time tomorrow?",
    "wc26.league.chip.lag":       "Lag — re-roll?",
    "wc26.league.day":            "Day",
    "wc26.league.bye":            "Bye",
    "wc26.league.bye.body":       "Enjoy the rest day. Points awarded automatically.",
    "wc26.league.noDay":          "No fixtures today.",
    "wc26.league.noDay.body":     "Next match day will trigger your daily draw automatically.",
    "wc26.league.filter.all":     "All",
    "wc26.league.filter.safe":    "Safe",
    "wc26.league.filter.cut":     "Below cut",
    "wc26.league.filter.out":     "Eliminated",
    "wc26.league.filter.win":     "Wins",
    "wc26.league.filter.draw":    "Draws",
    "wc26.league.filter.loss":    "Losses",
    "wc26.league.filter.bye":     "Byes",
    "wc26.league.searchPlayer":   "Search player…",
    "wc26.league.cutBar":         "CUT · top {pct}% advance",
    "wc26.league.todayBadge":     "TODAY",
    "wc26.league.nextCut":        "Next cut",
    "wc26.league.viewFullTable":  "View full table →",
    "wc26.league.reveal.drawing":  "Drawing your team…",
    "wc26.league.reveal.yourTeam": "Your team",
    "wc26.league.reveal.fixture":  "You're replaying",
    "wc26.league.reveal.matching": "Finding your opponent…",
    "wc26.league.reveal.opponent": "Your opponent",
    "wc26.league.reveal.waiting":  "Waiting for an opponent to be drawn…",
    "wc26.league.reveal.waitingBody": "You'll be paired as soon as another player on the opposing side is drawn. Check back shortly.",
    "wc26.league.reveal.bye":      "BYE · Rest day",
    "wc26.league.reveal.byeBody":  "No opponent today — points awarded automatically.",
    "wc26.league.reveal.continue": "Let's play →",
    // ─── Immersion League V2 (additional) ───
    "wc26.league.locked":         "WC 2026 League opens 24h before kickoff.",
    "wc26.league.toastJoined":    "You're in. Good luck.",
    "wc26.league.headerChip":     "Authentic · Immersion · Daily League",
    "wc26.league.backChip":       "Authentic",
    "wc26.league.kickerImm":      "// Immersion",
    "wc26.league.title":          "Daily League",
    "wc26.league.sub":            "Mirrors the real WC fixture · 33 days · top 30% advance",
    "wc26.league.rank":           "Rank",
    "wc26.league.points":         "Points",
    "wc26.league.enterTitle":     "Enter the League",
    "wc26.league.enterBody":      "Once you're in, every WC match day you'll be auto-assigned a fixture + one of its teams, and paired against another player on the opposing side. Points accumulate across all 33 days. Top 30% advance each stage.",
    "wc26.league.registerBtn":    "Register · {pool}",
    "wc26.league.journey":        "// Journey",
    "wc26.league.miniStandings":  "Mini Standings · Top 5",
    "wc26.league.idleTitle":      "Today's Real Fixtures",
    "wc26.league.idleNoFix":      "No fixtures yet for this date — admins are filling them in.",
    "wc26.league.idleHelp":       "You'll be randomly assigned to one of today's real fixtures and matched with another player on the opposing team.",
    "wc26.league.rollBtn":        "Roll my team",
    "wc26.league.screenshotReq":  "Screenshot required",
    "wc26.league.scoreSubmitted": "Score submitted.",
    "wc26.league.legHome":        "Leg {n} · HOME",
    "wc26.league.legAway":        "Leg {n} · AWAY",
    "wc26.league.leg":            "Leg {n}",
    "wc26.league.submittedLine":  "You submitted {h}–{a}. Awaiting opponent confirmation.",
    "wc26.league.confirmedTag":   "Confirmed",
    "wc26.league.victory":        "Victory",
    "wc26.league.defeat":         "Defeat",
    "wc26.league.draw":           "Draw",
    "wc26.league.byeDay":         "Bye day",
    "wc26.league.byeFooter":      "+{pts} pts · No opponent today.",
    "wc26.league.dispTitle":      "Scores don't match.",
    "wc26.league.dispBody":       "An admin will resolve this.",
    "wc26.league.survival":       "// Survival",
    "wc26.league.shardLine":      "Shard #{n} · {total} players · top {pct}% advance",
    "wc26.league.safeLine":       "Safe · #{rank} of {cutoff}",
    "wc26.league.belowCut":       "Below cut · #{rank} (cut at #{cutoff})",
    "wc26.league.yourPts":        "Your pts",
    "wc26.league.cutMarker":      "cut · #{cutoff}",
    "wc26.league.registerFirst":  "Register first.",
    "wc26.league.shardShown":     "Shard #{n} · {shown}/{total} shown",
    "wc26.league.statTotal":      "Total",
    "wc26.league.statScheduled":  "Scheduled",
    "wc26.league.statLive":       "Live",
    "wc26.league.statSubmitted":  "Submitted",
    "wc26.league.statConfirmed":  "Confirmed",
    "wc26.league.statDisputed":   "Disputed",
    "wc26.league.noShard":        "No matches drawn for this fixture in your shard.",
    "wc26.league.stage.group":    "Group Stage",
    "wc26.league.stage.r32":      "Round of 32",
    "wc26.league.stage.r16":      "Round of 16",
    "wc26.league.stage.qf":       "Quarterfinals",
    "wc26.league.stage.sf":       "Semifinals",
    "wc26.league.stage.final":    "Final",
    "wc26.league.cutAdvance":     "▼ CUT · top {pct}% advance",
    "wc26.league.noMatches":      "No matches yet.",
    "wc26.league.noFilter":       "No matches match this filter.",
    "wc26.league.preview":        "Preview mode · as of {date}",
    "wc26.league.fixtureCount":   "{n} fixtures",
    "wc26.league.statusScheduled":"scheduled",
    "wc26.league.statusLive":     "live",
    "wc26.league.statusAwait":    "awaiting",
    "wc26.league.statusConf":     "confirmed",
    "wc26.league.statusDisp":     "disputed",
    "wc26.league.statusForf":     "forfeit",
    "wc26.league.statusBye":      "bye",
    "wc26.league.statusSafe":     "SAFE",
    "wc26.league.statusCut":      "CUT",
    "wc26.league.statusOut":      "OUT",
    "wc26.league.tstatus.registration": "registration",
    "wc26.league.tstatus.live":         "live",
    "wc26.league.tstatus.complete":     "complete",
    "wc26.league.tstatus.scheduled":    "scheduled",

    // ─── World Cup Tournament V2 ───
    "wct.unavailable":            "Tournament unavailable. Try again later.",
    "wct.headerChip":             "Authentic · 48-Team Tournament",
    "wct.backChip":               "back",
    "wct.kicker":                 "// Authentic",
    "wct.title":                  "48-Team Tournament",
    "wct.sub":                    "Pilot for the official launch · 12 groups · KO bracket",
    "wct.testBadge":              "TEST",
    "wct.testMode":               "TEST MODE",
    "wct.testingBody":            "pilot for the official 2026 World Cup launch. 48 players · 12 groups · group stage ends Monday 23:59 Riyadh. Top 2 per group + 8 best 3rd-placed advance to the knockout bracket.",
    "wct.platform.console":       "Console",
    "wct.platform.mobile":        "Mobile",
    "wct.join.slots":             "Slots filling up",
    "wct.join.cta":               "Join the World Cup",
    "wct.join.body":              "First-come-first-served. When all 48 slots fill, the tournament starts and a fresh one opens.",
    "wct.join.toast":             "You drew {flag} {name}! Group {g}",
    "wct.join.fail":              "Could not join",
    "wct.idleBody":               "A new tournament will open when the current one finishes. Stay tuned.",
    "wct.yourTeam":               "Your team",
    "wct.group":                  "Group {g}",
    "wct.deadline.ends":          "Group ends",
    "wct.tabs.matches":           "My matches",
    "wct.tabs.group":             "Group",
    "wct.tabs.standings":         "Standings",
    "wct.tabs.bracket":           "Bracket",
    "wct.noMatches":              "No matches yet. The group stage will start once 48 slots fill.",
    "wct.match.host":             "HOST",
    "wct.match.guest":            "GUEST",
    "wct.match.forfSilence":      "Resolved by chat-silence rule",
    "wct.match.forfDeadline":     "Deadline passed — match forfeited",
    "wct.submit.scores":          "Enter both scores",
    "wct.submit.shotReq":         "Screenshot required",
    "wct.submit.toast":           "Score submitted",
    "wct.submit.fail":            "Failed",
    "wct.submit.cta":             "Submit score",
    "wct.submit.phMy":            "my",
    "wct.submit.phOpp":           "opp",
    "wct.submit.waiting":         "You submitted. Waiting for opponent…",
    "wct.et.title":               "Extra time",
    "wct.et.body":                "This match was level. Enter the extra-time score (and penalties if extra time is also level) to decide the winner.",
    "wct.et.pens":                "Penalties",
    "wct.et.cta":                 "Submit extra time",
    "wct.auto.body":              "Auto-confirm is paused until",
    "wct.auto.deadline":          "Monday 23:59 Riyadh",
    "wct.auto.body2":             "Submitted scores wait until the deadline; until then, neither side loses by inactivity. After the deadline, an unsubmitted opponent inherits the submitted score.",
    "wct.auto.waiting":           "Waiting on opponent…",
    "wct.auto.yourTurn":          "Your turn — submit before Mon 23:59 Riyadh",
    "wct.chat.title":             "Match chat",
    "wct.chat.empty":             "Say hi to coordinate the game.",
    "wct.chat.placeholder":       "Message…",
    "wct.groupChat.title":        "Group {g} chat",
    "wct.groupChat.empty":        "Coordinate game times with your group here.",
    "wct.groupChat.placeholder":  "Message your group…",
    "wct.bracket.final":          "Final",
    "wct.bracket.third":          "3rd-place",
    "wct.bracket.tbd":            "TBD",
    "wct.tracker.title":          "Registered",
    "wct.tracker.slots":          "/48 slots",
    "wct.tracker.remaining":      "{n} slots remaining until the tournament starts",
    "wct.tracker.groupProgress":  "Group stage in progress",
    "wct.tracker.koProgress":     "Knockout stage in progress",
    "wct.tracker.complete":       "Tournament complete",
    "wct.preview.kicker":         "// Groups Preview",
    "wct.preview.meta":           "12 groups · 4 per group",
    "wct.preview.openSlot":       "— open slot —",
    "wct.you":                    "you",
    "wct.played":                 "P",

    // ─── Dream Team V2 ───
    "dt.back":                    "Back",
    "dt.headerChip":              "Dream Team · Weekly Quotas",
    "dt.kicker":                  "// Dream Team",
    "dt.title":                   "Weekly Quotas",
    "dt.sub":                     "20 games per cycle · 8 DEF / 8 MID / 8 FWD",
    "dt.tabs.home":               "Home",
    "dt.tabs.lobby":              "Lobby",
    "dt.tabs.match":              "Match",
    "dt.tabs.leaderboard":        "Leaderboard",
    "dt.tabs.history":            "History",
    "dt.continent.europe":        "Europe",
    "dt.continent.africa":        "Africa",
    "dt.continent.asia":          "Asia",
    "dt.continent.americas":      "Americas",
    "dt.pos.def":                 "DEF",
    "dt.pos.mid":                 "MID",
    "dt.pos.fwd":                 "FWD",
    "dt.week":                    "// Week {id}",
    "dt.gameOf":                  "Game",
    "dt.gameUnlock":              "Next game unlocks after you complete this match.",
    "dt.cycleDone":               "You've finished all {n} games for this week. New cycle drops Monday 00:00 UTC.",
    "dt.split.banner":            "Game {n} · build a {total}-man squad matching this quota",
    "dt.split.player":            "{n} player",
    "dt.split.players":           "{n} players",
    "dt.split.total":             "Total: {n} players · 8 DEF · 8 MID · 8 FWD",
    "dt.lobby.online":            "// Online · {n} {label}",
    "dt.lobby.player":            "player",
    "dt.lobby.players":           "players",
    "dt.lobby.gameBanner":        "You're on Game {n} · invite anyone to keep wait time short.",
    "dt.lobby.firstInvite":       "You'll join the cycle automatically the moment you send your first invite or play a match.",
    "dt.lobby.empty":             "Nobody else is online right now. Invite a friend to play!",
    "dt.lobby.invite":            "Invite",
    "dt.lobby.inviteSent":        "Sent ✓",
    "dt.lobby.inviteToast":       "Invite sent for Game {n} — they have 30s to accept.",
    "dt.lobby.rankLine":          "Rank #{rank} · {pts} pts · GD {gd}",
    "dt.invite.notify":           "{name} invited you to Game {n}",
    "dt.invite.accept":           "Accept",
    "dt.invite.decline":          "Decline",
    "dt.invite.started":          "Match started!",
    "dt.invite.aPlayer":          "A player",
    "dt.match.empty":             "No active match. Head to the Lobby to invite an opponent.",
    "dt.match.gameStatus":        "Game {n} · {status}",
    "dt.match.confirmed":         "✓ confirmed",
    "dt.match.disputed":          "⚠ disputed",
    "dt.match.homeLabel":         "HOME · G{n}",
    "dt.match.awayLabel":         "AWAY · G{n}",
    "dt.match.condTitle":         "// Squad conditions · cross-check before you start",
    "dt.match.condYours":         "Your squad",
    "dt.match.condOpp":           "@{name}'s squad",
    "dt.match.spotMismatch":      "Spot a mismatch? Tap report and attach a screenshot.",
    "dt.match.updateReport":      "Update report",
    "dt.match.reportSquad":       "Report squad",
    "dt.match.reportedStatus":    "You reported this match · status: {status}",
    "dt.match.waiting":           "You submitted {h}–{a}. Waiting for opponent to confirm.",
    "dt.match.disputeBody":       "Scores don't match. An admin will resolve this.",
    "dt.match.finalLine":         "Final · You {a} pts · Opponent {b} pts",
    "dt.match.chatTitle":         "Match Chat",
    "dt.match.chatPlaceholder":   "Type a message…",
    "dt.match.chatEmpty":         "Say hi to your opponent.",
    "dt.mini.condPending":        "Conditions pending…",
    "dt.mini.totalLine":          "Total {n} · 8D/8M/8F",
    "dt.report.title":            "Report squad",
    "dt.report.body":             "Flag if their lineup didn't honour the quota for their game.",
    "dt.report.already":          "You already reported this match — submitting again will update your evidence.",
    "dt.report.issue":            "What's the issue?",
    "dt.report.placeholder":      "e.g. Their lineup had 5 Asian players but Game 4 requires 6.",
    "dt.report.attach":           "Attach screenshot (required)",
    "dt.report.attached":         "Attached: {name}",
    "dt.report.minReason":        "Reason must be at least 5 characters.",
    "dt.report.needShot":         "Please attach a screenshot as evidence.",
    "dt.report.failed":           "Report failed.",
    "dt.report.sentToast":        "Report sent to admin team.",
    "dt.report.send":             "Send report",
    "dt.submit.title":            "// Submit final score",
    "dt.submit.toast":            "Score submitted.",
    "dt.submit.cta":              "Submit final score",
    "dt.submit.attachOpt":        "Attach screenshot (optional)",
    "dt.lb.you":                  "you",
    "dt.lb.yourRank":             "Your rank · #{rank}",
    "dt.lb.header":               "P · W-D-L · GD · PTS",
    "dt.lb.empty":                "No matches played yet this week.",
    "dt.lb.col.player":           "Player",
    "dt.history.empty":           "No matches yet this week.",
    "dt.history.gameNum":         "Game {n}",
    "dt.history.win":             "WIN",
    "dt.history.loss":            "LOSS",
    "dt.history.draw":            "DRAW",
    "dt.opp":                     "Opponent",

  },
  ar: {
    dir: "rtl",
    // Navbar
    "nav.title": "ePlay",
    "nav.section": "الدوري الرئيسي",
    "nav.dashboard": "الرئيسية",
    "nav.fixtures": "المباريات",
    "nav.standings": "الترتيب",
    "nav.leagues": "البطولات",
    "nav.social": "اجتماعي",
    "nav.myMatches": "مبارياتي",
    "nav.chat": "المحادثات",
    "nav.admin": "المشرف",
    "nav.login": "تسجيل الدخول",
    "nav.register": "تسجيل جديد",
    "nav.exit": "خروج",
    "nav.lobby": "القائمة",
    "nav.locked": "مُغلق",
    "nav.noLeague": "لا يوجد دوري فعّال",
    "nav.id": "المعرّف",
    "nav.language": "EN",
    "nav.dark": "داكن",
    "nav.light": "فاتح",

    // Home
    "home.kicker": "// مركز ePlay",
    "home.v2Banner.beta": "تجريبي",
    "home.v2Banner.headline": "جرّب التصميم الجديد",
    "home.v2Banner.body": "نطلق تجربة جديدة مصممة خصيصًا للجوّال. كن من أوائل المجرّبين.",
    "home.v2Banner.cta": "جرّب v2 ←",
    "home.v2Banner.dismiss": "إخفاء الإشعار",
    "home.title1": "اختر",
    "home.title2": "بطولتك",
    "home.intro": "ستة أوضاع لعب. الأول متاح الآن — انضم، احجز مقعدك، العب الموسم كاملاً. الباقي قادم قريبًا.",
    "home.count": "{n} متاحة · {m} قريبًا",
    "home.live": "مفتوح",
    "home.private": "خاص",

    // Active Leagues overview on Home
    "active.title": "البطولات الجارية حاليًا",
    "active.kicker": "// المواسم النشطة",
    "active.subtitle": "اضغط على أي بطولة لعرض ترتيبها الكامل.",
    "active.empty": "[ لا توجد بطولات مُغلقة بعد — تابع لاحقًا عند انطلاق موسم جديد. ]",
    "active.platform.mobile": "موبايل",
    "active.platform.console": "PS5 · STEAM",
    "active.status.locked": "مُغلق",
    "active.status.running": "مباشر",
    "active.status.complete": "منتهٍ",
    "active.noResults": "لا توجد نتائج بعد",
    "active.viewStandings": "عرض الترتيب الكامل ←",
    "active.toggle": "عرض البطولات الجارية",
    "active.hide": "إخفاء",
    "home.mobileBadge": "موبايل",
    "home.consoleBadge": "PS5 · STEAM",
    "home.comingSoon": "قريبًا",
    "home.enterLeague": "ادخل الدوري",
    "home.tile.mobileTitle": "eFootball موبايل",
    "home.tile.mobileSub": "الدوري الرئيسي أونلاين",
    "home.tile.consoleTitle": "eFootball كونسول",
    "home.tile.consoleSub": "الدوري الرئيسي أونلاين",
    "home.tile.byolTitle": "أنشئ دوريك الخاص",
    "home.tile.byolSub": "خاص · بالدعوة فقط",
    "home.tile.uflTitle": "UFL · موبايل",
    "home.tile.uflSub": "غرف لعب سريعة من ٤ لاعبين · أنشئ أو انضم لفريق",
    "home.uflBadge": "مباشر",
    "home.tile.classicsTitle": "كلاسيكي — PES و FIFA القديمة",
    "home.tile.classicsSub": "PES من 13 إلى 21 عبر Parsec · حنين 1 ضد 1",
    "home.pcOnly": "للحاسوب فقط",
    "home.tile.wcAuthMob": "كأس العالم الأصلي",
    "home.tile.wcAuthMobSub": "موبايل",
    "home.tile.wcAuthCon": "كأس العالم الأصلي",
    "home.tile.wcAuthConSub": "كونسول",
    "home.tile.wcDream": "فريق أحلام كأس العالم \"القارة\"",
    "home.tile.wcDreamSub": "موبايل",
    "home.tile.wc2026Title": "كأس العالم فيفا 2026",
    "home.tile.wc2026Sub": "الأصلي ٤٨ منتخباً · الانغماس · فريق الأحلام",
    "home.wc2026Badge": "٣ أوضاع",

    // Dashboard
    "dash.kicker": "// الدوري الرئيسي :: غرفة التحكم",
    "dash.heroLine1": "عشرون لاعبًا.",
    "dash.heroLine2": "دوري واحد.",
    "dash.heroIntro": "سجّل حسابك، انضم إلى الدوري المفتوح التالي، واجه كل منافس مرتين، ارفع لقطات الشاشة، وشاهد الترتيب يتحدّث فور تأكيد اللاعبين للنتيجة.",
    "dash.currentSeason": "الموسم الحالي",
    "dash.status": "الحالة",
    "dash.players": "اللاعبون",
    "dash.fill": "الامتلاء",
    "dash.slotsRemaining": "مقاعد متبقية قبل الإغلاق",
    "dash.claimSlot": "احجز مقعدك",
    "dash.playerSignIn": "دخول اللاعب",
    "dash.viewFixtures": "عرض المباريات",
    "dash.leaderboard": "لوحة الصدارة",
    "dash.pendingTitle": "مبارياتك المعلّقة",
    "dash.pendingKicker": "// قائمة الانتظار",
    "dash.pendingEmpty": "[ لا توجد مباريات معلّقة — كل شيء جاهز. ]",
    "dash.pendingAdmin": "[ عرض المشرف — استخدم لوحة المشرف لحل النزاعات. ]",
    "dash.pendingGuest": "[ سجّل الدخول لرؤية مبارياتك. ]",
    "dash.topKicker": "// أفضل 5",
    "dash.topTitle": "الصدارة",
    "dash.noLeagueActive": "[ لا يوجد دوري نشط ]",
    "dash.awaitingResult": "[ بانتظار أول نتيجة ]",

    // Terms & Conditions
    "tc.kicker": "// قوانين التشكيلة // الشروط والأحكام",
    "tc.title": "قوانين التشكيلة",
    "tc.intro": "قبل إرسال أي نتيجة، يجب أن تتوافق تشكيلتك مع قوانين اللعب النظيف في الدوري. أي مخالفة تؤدي إلى خسارة المباراة وقد تؤدي إلى الاستبعاد من الدوري.",
    "tc.rule1": "يُسمح فقط باستخدام اللاعبين الحاليين من الواقع في تشكيلتك.",
    "tc.rule2": "يُمنع منعًا باتًا استخدام بطاقات EPIC أو SHOWTIME.",
    "tc.rule3": "يُسمح باستخدام بطاقات لاعب الأسبوع (POTW) أو ما يعادلها من بطاقات الفعاليات.",
    "tc.rule4": "لا يُسمح بأي بطاقة تقييمها أعلى من مستوى لاعب الأسبوع.",
    "tc.ack": "بتسجيلك وإرسال النتائج فإنك تؤكد التزام تشكيلتك بهذه القوانين.",

    // Login
    "login.kicker": "// دخول اللاعب",
    "login.title": "ادخل الدوري",
    "login.subtitle": "سجّل الدخول ببيانات لاعبك لإرسال النتائج ومتابعة الترتيب.",
    "login.username": "اسم المستخدم",
    "login.password": "كلمة المرور",
    "login.submit": "تسجيل الدخول",
    "login.submitting": "جارٍ المصادقة...",
    "login.noCreds": "لا تملك حسابًا بعد؟",
    "login.registerLink": "سجّل للموسم القادم",
    "login.toast": "أهلاً بعودتك يا لاعب.",

    // Register
    "reg.kicker": "// لاعب جديد",
    "reg.title": "احجز مقعدك",
    "reg.subtitle": "20 لاعبًا لكل دوري. بمجرد اكتمال العدد، يُغلق الدوري فورًا ويُفتح موسم جديد.",
    "reg.username": "اسم المستخدم",
    "reg.gameId": "معرّف اللعبة",
    "reg.gameIdPlaceholder": "مثال: eFootball#12345",
    "reg.whatsapp": "رقم واتساب",
    "reg.whatsappPlaceholder": "+201234567890",
    "reg.whatsappHelp": "أدخل رقم واتساب كاملاً مع رمز الدولة (مثال: +20 لمصر، +966 للسعودية، +971 للإمارات). سيستخدمه باقي اللاعبين في الدوري للتواصل معك وتحديد موعد المباراة.",
    "reg.password": "كلمة المرور",
    "reg.submit": "ثبّت مقعدي",
    "reg.submitting": "جارٍ التسجيل...",
    "reg.already": "لديك حساب بالفعل؟",
    "reg.loginLink": "تسجيل الدخول",
    "reg.toast": "تم تسجيل اللاعب. أنت الآن ضمن الدوري الحالي.",
    "reg.clubName": "اسم النادي (اختياري)",
    "reg.clubNamePh": "يمكنك إضافته لاحقًا من حسابك",
    "reg.nationality": "الجنسية (اختياري)",
    "reg.nationalityPh": "— اختر الدولة —",
    "reg.platform": "المنصّة",
    "reg.signInWithGoogle": "سجّل عبر Google",

    // Fixtures
    "fx.title": "جدول المباريات",
    "fx.viewMyLeague": "عرض دوريي",
    "fx.myLeague": "دوريي",
    "fx.noLock": "[ لم يُغلق الدوري بعد — تُولَّد المباريات فور تسجيل 20 لاعبًا. ]",
    "fx.loading": "جارٍ تحميل المباريات",
    "fx.empty": "[ لا توجد مباريات متاحة ]",
    "fx.home": "صاحب الأرض",
    "fx.away": "الضيف",
    "fx.round": "الجولة",
    "fx.matchday": "يوم المباراة",
    "fx.game": "المباراة",
    "fx.pending": "معلّقة",
    "fx.confirmed": "مؤكدة",
    "fx.disputed": "متنازع عليها",

    // Standings
    "st.title": "جدول الترتيب",
    "admStand.loading": "جارٍ تحميل البطولات",
    "admStand.mobile": "موبايل",
    "admStand.console": "كونسول",
    "admStand.pickLeague": "اختر الموسم:",
    "admStand.empty": "— لا توجد بطولات لهذه المنصّة —",
    "admStand.noLeagues": "[ لا توجد بطولات على هذه المنصّة بعد. ]",
    "st.noResults": "[ لم تُرسل أي نتائج بعد ]",
    "st.headerPlayer": "اللاعب",
    "st.played": "ل",
    "st.wins": "ف",
    "st.draws": "ت",
    "st.losses": "خ",
    "st.gf": "له",
    "st.ga": "عليه",
    "st.gd": "فارق",
    "st.pts": "نقاط",

    // My Matches
    "mm.title": "مبارياتي",
    "mm.loading": "جارٍ تحميل مبارياتك",
    "mm.empty": "[ لا توجد مباريات بعد — انتظر اكتمال دوريك. ]",
    "mm.vs": "ضد",
    "mm.submit": "إرسال النتيجة",
    "mm.confirm": "تأكيد",
    "mm.submitted": "تم الإرسال",
    "mm.awaitingOpponent": "بانتظار الخصم",

    // Leagues list
    "lg.title": "جميع البطولات",
    "lg.loading": "جارٍ تحميل البطولات",
    "lg.empty": "[ لا توجد بطولات بعد ]",
    "lg.season": "الموسم",
    "lg.openStatus": "مفتوح",
    "lg.lockedStatus": "مُغلق",
    "lg.completeStatus": "منتهٍ",

    // League detail
    "ld.back": "رجوع",
    "ld.hallOfFame": "قاعة المشاهير",
    "ld.feed": "الأخبار",
    "ld.standings": "الترتيب",
    "ld.fixtures": "المباريات",
    "ld.loading": "جارٍ تحميل الدوري",

    // Player profile
    "pp.title": "ملف اللاعب",
    "pp.loading": "جارٍ تحميل الملف",
    "pp.notFound": "اللاعب غير موجود.",
    "pp.viewProfile": "عرض ملفي العام",
    "pp.joined": "انضم في",
    "pp.played": "لُعبت",
    "pp.won": "فوز",
    "pp.drawn": "تعادل",
    "pp.lost": "خسارة",
    "pp.winRate": "نسبة الفوز %",
    "pp.points": "النقاط",
    "pp.form": "الأداء",
    "pp.seasons": "المواسم",
    "pp.pending": "معلّقة",
    "pp.h2hTitle": "المواجهات المباشرة",
    "pp.h2hEmpty": "لا توجد مواجهات سابقة بعد.",
    "pp.recentTitle": "آخر المباريات",
    "pp.recentEmpty": "لم تُلعب أي مباريات بعد.",
    "pp.seasonsTitle": "المواسم المُلعوبة",
    "pp.h2hRoom": "غرفة المواجهة",
    "pp.message": "مراسلة",
    "pp.lastPlayed": "آخر لقاء",
    "pp.opponent": "الخصم",
    "pp.banned": "محظور",
    "pp.admin": "مشرف",
    "pp.moderator": "مراقب",

    // Hall of Fame
    "hof.kicker": "// أساطير كل الأزمان",
    "hof.title": "قاعة المشاهير",
    "hof.subtitle": "أفضل 5 · كل البطولات · على مر الأزمان",
    "hof.empty": "العرش بانتظار بطل",
    "hof.emptyBody": "لم تُؤكد أي مباراة بعد. أول أسطورة يحصل على التاج.",
    "hof.rank": "#",
    "hof.player": "اللاعب",
    "hof.pts": "نقاط",

    // Account
    "acc.title": "الحساب",
    "acc.kicker": "// الملف الشخصي",
    "acc.viewProfile": "عرض ملفي العام",
    "acc.changeUsername": "// تغيير اسم المستخدم",
    "acc.current": "الحالي",
    "acc.newUsername": "اسم المستخدم الجديد",
    "acc.updateUsername": "تحديث اسم المستخدم",
    "acc.changePassword": "// تغيير كلمة المرور",
    "acc.currentPassword": "كلمة المرور الحالية",
    "acc.newPassword": "كلمة المرور الجديدة (4 أحرف على الأقل)",
    "acc.updatePassword": "تحديث كلمة المرور",
    "acc.usernameUpdated": "تم تحديث اسم المستخدم إلى {name}",
    "acc.passwordUpdated": "تم تحديث كلمة المرور",
    "acc.yourReliability": "موثوقيتك:",
    "acc.scoreBreakdown": "تفاصيل النقاط (آخر 60 يومًا)",
    "acc.matchesInWindow": "المباريات في الفترة",
    "acc.completion": "نسبة الإكمال",
    "acc.onTime": "الالتزام بالوقت",
    "acc.chatEng": "تفاعل الدردشة",
    "acc.scoreAgreement": "اتفاق النتائج",
    "acc.reports90d": "البلاغات (90 يومًا)",
    "acc.autoForfeits": "الخسائر التلقائية",
    "acc.inactiveDays": "أيام عدم النشاط",
    "acc.profilePicture": "// صورة الملف الشخصي",
    "acc.replacePhoto": "تغيير الصورة",
    "acc.uploadPhoto": "رفع صورة",
    "acc.imageTooBig": "الصورة كبيرة جدًا (الحد الأقصى 1 ميجا). قُص أو اضغط الصورة أولًا.",
    "acc.picUpdated": "تم تحديث صورة الملف الشخصي",
    "acc.picRemoved": "تم حذف صورة الملف الشخصي",
    "acc.picMeta": "jpg · png · webp · حتى 1 ميجا",
    "acc.removeBtn": "حذف",
    "acc.dangerZone": "منطقة الخطر",
    "acc.dangerBody": "احذف حسابك نهائيًا. إذا لم تُلعب أي مباراة مؤكدة في دوريك الحالي، فسيُعاد فتح مقعدك للاعب آخر. وإلا فإن مبارياتك غير الملعوبة ستُحتسب 3-0 لخصومك. لا يمكن التراجع عن هذا الإجراء.",
    "acc.deleteMyAccount": "احذف حسابي",
    "acc.confirmWithPassword": "أكّد بكلمة المرور الحالية",
    "acc.typeUsername": "اكتب اسم المستخدم للتأكيد ({name})",
    "acc.permanentlyDelete": "احذف نهائيًا",
    "acc.deleting": "جارٍ الحذف…",
    "acc.cancel": "إلغاء",
    "acc.deletedToast": "تم حذف الحساب. أُزيل من {n} دوري{slots}{forfeits}",
    "acc.slotsReopened": " · أُعيد فتح {n} مقعد",
    "acc.forfeitedMatches": " · {n} مباراة احتُسبت خسارة تلقائية",

    // Exit league
    "exit.kicker": "// مغادرة الموسم الحالي",
    "exit.title": "مغادرة الدوري الحالي",
    "exit.body": "اترك دوريك الحالي مع الحفاظ على حسابك واسم نادي الفريق وبياناتك وإحصائياتك التاريخية كاملةً. **لن** يُعاد فتح مقعدك — سيبقى مغلقًا حتى نهاية الموسم. ستُحتسب مبارياتك المعلّقة خسارة 3-0 لخصومك. بعد المغادرة، ستُضاف تلقائيًا إلى الدوري المفتوح التالي لمنصّتك، وتُنقَل إحصائيات مسيرتك معك.",
    "exit.button": "مغادرة الدوري",
    "exit.confirmTitle": "تأكيد مغادرة الدوري",
    "exit.confirmBody": "اكتب اسم المستخدم للتأكيد: لا يمكن التراجع عن هذا الإجراء لهذا الموسم.",
    "exit.confirm": "مغادرة الدوري الآن",
    "exit.cancel": "إلغاء",
    "exit.exiting": "جارٍ المغادرة…",
    "exit.toastJoined": "غادرت الدوري. {n} مباراة احتُسبت خسارة. تم وضعك في دوري مفتوح جديد.",
    "exit.toastNoNewLeague": "غادرت الدوري. {n} مباراة احتُسبت خسارة. لا يوجد دوري مفتوح حاليًا — يمكنك التسجيل لاحقًا.",
    "exit.notInLeague": "أنت لست في دوري حاليًا.",
    "exit.adminBlocked": "حسابات المشرف لا يمكنها مغادرة الدوري.",

    // Report player
    "report.btn": "بلاغ",
    "report.reportName": "أبلغ عن {name}",
    "report.alreadyReported": "لقد أبلغت عن هذا اللاعب مسبقًا",
    "report.intro": "أبلغ عن {name}. عند بلوغ {threshold} بلاغات من لاعبين مختلفين، يُستبعد اللاعب تلقائيًا وتُحتسب مبارياته المتبقية 3-0 لخصومه.",
    "report.reasonPh": "السبب (5 أحرف على الأقل) — مثلًا: عدم حضور، غش، إساءة",
    "report.screenshotRequired": "يجب إرفاق لقطة شاشة لتقديم البلاغ.",
    "report.screenshotRequiredLabel": "لقطة شاشة كدليل (إلزامي)",
    "report.screenshotMeta": "PNG / JPG / WEBP · حتى 5 ميجا",
    "report.fileTooBig": "لقطة الشاشة كبيرة جدًا (الحد الأقصى 5 ميجا).",
    "report.fileBadType": "يجب أن تكون لقطة الشاشة من نوع PNG أو JPG أو WEBP.",
    "report.cancel": "إلغاء",
    "report.submit": "إرسال",
    "report.update": "تحديث",
    "report.submitting": "جارٍ الإرسال…",
    "report.toastSubmitted": "تم إرسال البلاغ. {count}/{threshold}",
    "report.toastBanned": "{name} تم استبعاده تلقائيًا ({threshold}+ بلاغًا).",

    // Profile completion (email / nationality / club name)
    "pc.kicker": "// إكمال الملف الشخصي",
    "pc.title": "أكمل ملفك الشخصي",
    "pc.subtitle": "وثّق حسابك حتى يثق بك بقية اللاعبين بنتائجك. لن نشارك بريدك الإلكتروني مع أحد.",
    "pc.email": "البريد الإلكتروني",
    "pc.emailPh": "you@example.com",
    "pc.nationality": "الجنسية",
    "pc.nationalityPh": "— اختر الدولة —",
    "pc.clubName": "اسم النادي",
    "pc.clubNamePh": "مثال: نادي الأسود",
    "pc.clubWarning": "تنبيه هام: يجب أن يتطابق اسم نادي تطبيقك تمامًا مع اسم النادي الظاهر في لقطات شاشة نتائج مبارياتك. كما يجب أن يكون اسمًا فريدًا — لا يمكن لأي لاعبَين في ePlay استخدام نفس اسم النادي. اختر بعناية.",
    "pc.save": "حفظ الملف الشخصي",
    "pc.saving": "جارٍ الحفظ…",
    "pc.saved": "تم تحديث الملف الشخصي",
    "pc.complete": "الملف الشخصي مكتمل",
    "pc.incomplete": "الملف الشخصي غير مكتمل — يُرجى تعبئة الحقول الناقصة أدناه",
    "pc.clubTakenError": "اسم النادي مستخدم بالفعل من لاعب آخر. اختر اسمًا فريدًا يطابق لقطة شاشتك تمامًا.",

    // Google sign-in
    "google.signIn": "تسجيل الدخول عبر Google",
    "google.continueWith": "أو تابع باستخدام",
    "google.welcome": "خطوة أخيرة",
    "google.signingIn": "جارٍ تسجيل دخولك",
    "google.pickUsername": "اختر اسم المستخدم",
    "google.pickUsernameHelp": "أنت تسجّل الدخول باسم {email}. اختر اسم المستخدم داخل التطبيق (2-24 حرفًا، أحرف/أرقام/_/-).",
    "google.pickNationalityOpt": "— الجنسية (اختياري) —",
    "google.create": "إنشاء الحساب",
    "google.creating": "جارٍ الإنشاء…",
    "google.failed": "فشل تسجيل الدخول عبر Google",
    "google.backLogin": "العودة لتسجيل الدخول",
    "google.noSession": "[ لم يتم اكتشاف جلسة Google. عُد إلى /login. ]",
    "google.linkedToast": "تم ربط حساب Google. أهلاً بعودتك!",
    "google.welcomeToast": "أهلاً بك في ePlay!",
    "google.welcomeBack": "أهلاً بعودتك!",

    // Social
    "social.tab.browse": "استكشاف",
    "social.tab.mine": "صلاتي",
    "social.tab.friends": "الأصدقاء",
    "social.tab.following": "أتابعهم",
    "social.tab.followers": "يتابعونني",
    "social.platform.all": "الكل",
    "social.platform.mobile": "موبايل",
    "social.platform.console": "كونسول",
    "social.sort.points": "النقاط",
    "social.sort.reliability": "الموثوقية",
    "social.sort.winrate": "نسبة الفوز",
    "social.searchPh": "ابحث باسم المستخدم أو معرّف اللعبة…",
    "social.signinToFollow": "سجّل الدخول لمتابعة اللاعبين",
    "social.empty": "[ لا يوجد لاعبون ]",
    "social.loading": "جارٍ تحميل اللاعبين",
    "social.follow": "متابعة",
    "social.following": "تتابعه",
    "social.unfollow": "إلغاء المتابعة",
    "social.mutual": "متبادل",
    "social.whatsapp": "واتساب",
    "social.viewProfile": "عرض الملف",
    "social.heroKicker": "// الطبقة الاجتماعية",
    "social.heroLine1": "النادي",
    "social.heroLine2": "تعرّف على منافسيك.",
    "social.heroIntro": "استكشاف اللاعبين عبر جميع البطولات. تابع اللاعبين، كوّن فريقًا، وافتح المراسلة والواتساب عند المتابعة المتبادلة.",
    "social.allLeagues": "كل البطولات",
    "social.players": "{n} لاعبًا",
    "social.player": "لاعب واحد",
    "social.noPlayersFilter": "[ لا يوجد لاعبون مطابقون لهذه الفلاتر. ]",
    "social.mineAnon": "[ سجّل الدخول لعرض من يتابعك، من تتابعهم، وأصدقائك. ]",
    "social.mineSignIn": "سجّل الدخول",
    "social.empty.friends": "[ لا أصدقاء بعد. تابع لاعبًا يتابعك لفتح المحادثة. ]",
    "social.empty.following": "[ أنت لا تتابع أحدًا بعد. استكشف النادي. ]",
    "social.empty.followers": "[ لا متابعون بعد. العب مباريات قوية. ]",
    "social.loadingShort": "جارٍ التحميل",
    "social.followers": "{n} متابع",
    "social.btnFriends": "أصدقاء",
    "social.btnFollowing": "تتابعه",
    "social.btnFollow": "+ متابعة",
    "social.btnMsg": "رسالة",

    // Push notifications
    "push.kicker": "// الإشعارات الفورية",
    "push.title": "تنبيهات المباريات",
    "push.on": "مُفعَّل · هذا الجهاز",
    "push.off": "مُعطَّل",
    "push.blocked": "محظور — فعّله من إعدادات المتصفح",
    "push.unsupported": "الإشعارات غير مدعومة في هذا المتصفح. استخدم Chrome أو Edge أو Firefox على الحاسوب، أو ثبّت التطبيق على الشاشة الرئيسية للموبايل.",
    "push.description": "استلم اهتزازًا وصوتًا على جهازك عند بدء مبارياتك اليومية، وعند إرسال خصمك للنتيجة، وعند تأكيد النتائج، وعند دعوتك لدوري خاص.",
    "push.enable": "فعّل الإشعارات",
    "push.disable": "تعطيل",
    "push.test": "إرسال تجريبي",
    "push.testSent": "تم إرسال التنبيه التجريبي — تحقق من جهازك",
    "push.notEnabled": "الإشعارات غير مفعّلة بعد",
    "push.blocked.toast": "الإشعارات محظورة — فعّلها من إعدادات المتصفح",

    // BYOL
    "byol.kicker": "// أنشئ دوريك الخاص",
    "byol.title": "دوري خاص",
    "byol.subtitle": "بطولات خاصة بالدعوة فقط لك ولأصدقائك.",
    "byol.create": "إنشاء دوري",
    "byol.empty": "[ لا توجد دوريات خاصة بعد. أنشئ واحدًا من الأعلى أو افتح رابط دعوة للانضمام إلى دوري صديقك. ]",
    "byol.captain": "الكابتن",
    "byol.created": "أُنشئ في",
    "byol.status.pending": "بانتظار اللاعبين",
    "byol.status.open": "مفتوح",
    "byol.status.active": "جارٍ",
    "byol.status.complete": "منتهٍ",
    "byol.loading": "جارٍ التحميل",
    "byol.new.title": "أنشئ دوريًا خاصًا",
    "byol.new.nameLabel": "اسم الدوري",
    "byol.new.namePlaceholder": "مثال: أساطير الأحد",
    "byol.new.sizeLabel": "أقصى عدد للاعبين",
    "byol.new.submit": "إنشاء الدوري",
    "byol.new.submitting": "جارٍ الإنشاء...",
    "byol.new.toast": "تم إنشاء الدوري — شارك رابط الدعوة!",
    "byol.new.cancel": "إلغاء",
    "byol.captainView.inviteTitle": "رابط الدعوة",
    "byol.captainView.copy": "نسخ الرابط",
    "byol.captainView.copied": "تم النسخ!",
    "byol.captainView.share": "مشاركة",
    "byol.captainView.roster": "اللاعبون",
    "byol.captainView.startNow": "ابدأ الدوري الآن",
    "byol.captainView.starting": "جارٍ البدء...",
    "byol.captainView.minPlayers": "تحتاج {n} لاعبين على الأقل للبدء",
    "byol.captainView.autoStart": "يبدأ تلقائيًا عند {max} لاعبين",
    "byol.captainView.leave": "مغادرة الدوري",
    "byol.captainView.kick": "إزالة",
    "byol.captainView.started": "بدأ هذا الدوري. اذهب إلى صفحة المباريات.",
    "byol.captainView.goLeague": "اذهب للدوري",
    "byol.invite.title": "أنت مدعوّ",
    "byol.invite.subtitle": "دوري eFootball خاص ينتظرك.",
    "byol.invite.joinBtn": "انضم للدوري",
    "byol.invite.joining": "جارٍ الانضمام...",
    "byol.invite.loginFirst": "سجّل الدخول أو أنشئ حسابًا للانضمام إلى هذا الدوري الخاص.",
    "byol.invite.loginBtn": "تسجيل الدخول",
    "byol.invite.registerBtn": "تسجيل جديد",
    "byol.invite.full": "هذا الدوري مكتمل.",
    "byol.invite.joined": "انضممت إلى الدوري!",
    "byol.invite.alreadyIn": "أنت مسجّل بالفعل في هذا الدوري.",

    // Match detail / submission
    "md.title": "المباراة",
    "md.loading": "جارٍ تحميل المباراة",
    "md.yourScore": "نتيجتك",
    "md.theirScore": "نتيجة الخصم",
    "md.screenshot": "لقطة الشاشة",
    "md.uploadScreenshot": "رفع لقطة الشاشة",
    "md.submit": "إرسال النتيجة",
    "md.submitting": "جارٍ الإرسال...",
    "md.retract": "تراجع",
    "md.retracting": "جارٍ التراجع...",
    "md.game1First": "يجب تأكيد المباراة الأولى من كلا اللاعبين قبل إرسال المباراة الثانية",
    "md.alreadyConfirmed": "المباراة مؤكدة بالفعل",
    "md.submitted": "أُرسلت النتيجة — بانتظار الخصم",
    "md.confirmed": "تم تأكيد النتيجة",
    "md.proposeReschedule": "اقتراح موعد جديد",
    "md.withdraw": "سحب الاقتراح",

    // Notifications
    "notif.title": "الإشعارات",
    "notif.empty": "لا توجد إشعارات بعد.",
    "notif.markAllRead": "اقرأ الكل",
    "notif.matchReminder": "تذكير بالمباراة",
    "notif.matchSubmitted": "الخصم أرسل النتيجة",
    "notif.matchConfirmed": "تأكدت النتيجة",
    "notif.matchDisputed": "نزاع على المباراة",
    "notif.leagueLocked": "أُغلق الدوري",
    "notif.byolInvite": "دعوة لدوري خاص",

    // Today's games
    "today.title": "مباريات اليوم",
    "today.empty": "لا توجد مباريات مجدولة اليوم.",
    "today.loading": "جارٍ التحميل",
    "today.kickoff": "الانطلاقة",

    // Schedule badge
    "sb.today": "اليوم",
    "sb.tomorrow": "غدًا",
    "sb.yesterday": "أمس",
    "sb.overdue": "متأخرة",
    "sb.scheduled": "مجدولة",

    // Chat / DMs
    "chat.title": "المحادثات",
    "chat.empty": "لا توجد محادثات بعد.",
    "chat.newMessage": "اكتب رسالة",
    "chat.send": "إرسال",
    "chat.loading": "جارٍ تحميل الرسائل",

    // Feed / Polls / Likes
    "feed.title": "أخبار ePlay",
    "feed.kicker": "// الإعلانات",
    "feed.empty": "[ لا توجد إعلانات بعد — عد لاحقًا. ]",
    "feed.adminKicker": "// إعلان إداري",
    "feed.placeholder": "انشر إعلانًا لكل لاعبي ePlay…",
    "feed.addImage": "إضافة صورة",
    "feed.addVideo": "إضافة فيديو",
    "feed.broadcast": "بث",
    "feed.posting": "جارٍ النشر...",
    "feed.posted": "تم نشر الإعلان.",
    "feed.edit": "تعديل",
    "feed.delete": "حذف",
    "feed.deleteConfirm": "حذف هذه المشاركة؟",
    "feed.like": "إعجاب",
    "feed.liked": "أعجبني",
    "feed.likes": "إعجاب",
    "feed.newPoll": "استطلاع جديد",
    "feed.pollTab": "استطلاع",
    "feed.announceTab": "إعلان",
    "poll.question": "سؤال الاستطلاع",
    "poll.questionPh": "ما الذي تريد أن تستطلع آراء اللاعبين فيه؟",
    "poll.option": "خيار",
    "poll.optionPh": "الخيار {n}",
    "poll.addOption": "+ إضافة خيار",
    "poll.removeOption": "إزالة",
    "poll.duration": "المدة",
    "poll.dur.1d": "يوم واحد",
    "poll.dur.1w": "أسبوع",
    "poll.dur.never": "حتى الإغلاق",
    "poll.submit": "نشر الاستطلاع",
    "poll.submitting": "جارٍ النشر...",
    "poll.posted": "تم نشر الاستطلاع",
    "poll.vote": "صوّت",
    "poll.voting": "جارٍ التصويت...",
    "poll.voted": "لقد صوّتت",
    "poll.closed": "الاستطلاع مُغلق",
    "poll.endsIn": "ينتهي خلال {when}",
    "poll.endsToday": "ينتهي اليوم",
    "poll.total": "{n} صوت",
    "poll.close": "إغلاق الاستطلاع",
    "poll.closing": "جارٍ الإغلاق...",
    "poll.closeConfirm": "إغلاق هذا الاستطلاع الآن؟ لن تُقبل أصوات جديدة بعد ذلك.",
    "poll.badge": "استطلاع",

    // Admin
    "admin.title": "لوحة المشرف",
    "admin.users": "المستخدمون",
    "admin.leagues": "البطولات",
    "admin.matches": "المباريات",
    "admin.analytics": "التحليلات",
    "admin.modReports": "بلاغات المراقبين",
    "admin.byol": "دوريات خاصة",
    "admin.feed": "الأخبار",
    "admin.nonResponding": "غير المستجيبين",
    "admin.moderators": "المراقبون",

    // Moderators tab
    "mods.kicker": "// الترقيات",
    "mods.title": "المراقبون",
    "mods.subtitle": "اللاعبون الذين رقّيتهم إلى مراقبين. يمكنهم تقديم بلاغات المراقبة وحسم النزاعات ومراجعة بلاغات اللاعبين. استخدم المحادثة أو واتساب للتواصل معهم، أو رتبتهم للعب فقط لإلغاء الصلاحيات.",
    "mods.refresh": "تحديث",
    "mods.loading": "جارٍ تحميل المراقبين",
    "mods.empty": "[ لا يوجد مراقبون بعد — رقّ لاعبًا من تبويب المستخدمين لإضافته هنا. ]",
    "mods.col.player": "المراقب",
    "mods.col.contact": "التواصل",
    "mods.col.actions": "الإجراءات",
    "mods.dm": "محادثة",
    "mods.demote": "إلغاء الترقية",
    "mods.demoting": "جارٍ الإلغاء…",
    "mods.demoteConfirm": "هل تريد إعادة {name} إلى وضع لاعب عادي؟",
    "mods.demoteToast": "{name} أصبح لاعبًا عاديًا الآن.",

    // Non-Responding Players (admin)
    "nr.kicker": "// خسائر بسبب عدم الرد",
    "nr.title": "اللاعبون غير المستجيبين",
    "nr.subtitle": "المباريات التي احتُسبت 3-0 لصالح لاعب راسل خصمه يوم المباراة بينما لم يرد الخصم. تشمل القائمة الخسائر التي حسمها النظام تلقائيًا بنهاية اليوم وكذلك المباريات التي صُحّحت لاحقًا (كانت تُسجَّل تعادلًا 0-0 وتم تعديلها).",
    "nr.section.live": "خسائر مباشرة",
    "nr.section.backfilled": "تصحيحات سابقة",
    "nr.refresh": "تحديث",
    "nr.loading": "جارٍ تحميل قائمة غير المستجيبين",
    "nr.empty.live": "[ لا توجد خسائر بسبب عدم الرد. ]",
    "nr.empty.backfilled": "[ لا توجد تصحيحات سابقة بعد — استخدم أداة تصحيح خسائر عدم الرد لمعالجة التعادلات القديمة 0-0. ]",
    "nr.col.date": "يوم المباراة",
    "nr.col.league": "الدوري",
    "nr.col.winner": "الفائز (راسَل)",
    "nr.col.loser": "الخاسر (لم يرد)",
    "nr.col.score": "النتيجة",
    "nr.col.original": "0-0 ← 3-0",
    "nr.col.action": "المباراة",
    "nr.col.view": "عرض",
    "nr.col.viewChat": "المحادثة",
    "nr.unknownPlayer": "(محذوف)",
    "nr.chat.kicker": "// مراجعة سكوت الدردشة",
    "nr.chat.matchDay": "يوم المباراة",
    "nr.chat.matchDayBadge": "يوم المباراة",
    "nr.chat.loading": "جارٍ تحميل المحادثة…",
    "nr.chat.empty": "لا توجد رسائل بين اللاعبين.",
    "nr.chat.emptyHelp": "لم يفتح أي من اللاعبين محادثة خاصة. تم احتساب الخسارة بناءً على قاعدة أخرى (مثلاً تجاوز المشرف أو رسالة في دردشة الدوري). افتح تفاصيل المباراة لمزيد من المعلومات.",
    "nr.chat.errMissingPlayers": "تعذّر تحميل المحادثة — أحد اللاعبين محذوف.",
    "nr.chat.legend.winner": "الفائز المُحتسب",
    "nr.chat.legend.loser": "الخاسر المُحتسب",
    "nr.chat.legend.matchDay": "أُرسلت يوم المباراة",
    "nr.chat.counter.winner": "الفائز (راسَل)",
    "nr.chat.counter.loser": "الخاسر (لم يرد)",
    "nr.chat.counter.onDay": "يوم المباراة",
    "nr.chat.counter.total": "الإجمالي",

    // Reminders
    "rem.kicker": "// تذكير بالنتائج",
    "rem.title": "النتائج المتأخرة",
    "rem.subtitle": "اللاعبون الذين لم يُرسلوا نتائج مبارياتهم بعد — يشمل مباريات اليوم وأي مباريات متأخرة.",
    "rem.empty": "[ كل شيء مرتب — جميع المباريات المتأخرة تم إرسال نتائجها. ]",
    "rem.daysOverdue": "متأخر {n} يوم",
    "rem.lastNever": "لم يُرسل أي تذكير بعد",
    "rem.last": "آخر تذكير: المستوى {level} · {when}",
    "rem.byAuto": "تلقائي",
    "rem.byAdmin": "بواسطة المشرف/المراقب",
    "rem.send": "إرسال تذكير",
    "rem.sending": "جارٍ الإرسال...",
    "rem.sent": "تم إرسال تذكير المستوى {level} إلى {name}",
    "rem.maxedOut": "وصل اللاعب إلى الحد الأقصى للتذكير (المستوى 3)",
    "rem.level1": "المستوى 1 · تذكير ودي",
    "rem.level2": "المستوى 2 · تحذير",
    "rem.level3": "المستوى 3 · تحذير قبل الحظر",

    // Errors / toasts
    "err.network": "خطأ في الشبكة",
    "err.notFound": "غير موجود",
    "err.unauthorized": "غير مصرح",
    "err.required": "حقل مطلوب",

    // Common buttons
    "btn.cancel": "إلغاء",
    "btn.save": "حفظ",
    "btn.delete": "حذف",
    "btn.confirm": "تأكيد",
    "btn.close": "إغلاق",
    "btn.back": "رجوع",
    "btn.next": "التالي",
    "btn.edit": "تعديل",
    "btn.view": "عرض",
    "btn.copy": "نسخ",
    "btn.share": "مشاركة",
    "btn.loading": "جارٍ التحميل...",

    // Classics league (Parsec PC PES retro)
    "common.yes": "نعم",
    "common.no": "لا",
    "common.back": "رجوع",
    "nav.classics": "كلاسيكي",
    "cl.loading": "جارٍ تحميل الكلاسيكي...",
    "cl.signinToContinue": "سجّل الدخول للوصول إلى دوري الكلاسيكي",
    "cl.kicker": "دوري الكلاسيكي",
    "cl.title": "كلاسيكي",
    "cl.subtitle": "PES من 13 إلى 21 عبر Parsec — حنين خالص للحاسوب، وجهًا لوجه.",
    "cl.gate.kicker": "بوابة الدخول",
    "cl.gate.q1": "هل تلعب على الحاسوب؟",
    "cl.gate.q1Help": "دوري الكلاسيكي مخصص حصريًا للاعبي الحاسوب القادرين على تشغيل ألعاب PES القديمة عبر Parsec.",
    "cl.gate.q2": "هل قمت بتثبيت Parsec؟",
    "cl.gate.q2Help": "Parsec هو أداة اللعب عن بُعد التي نستخدمها لجلسات 1 ضد 1 بزمن استجابة منخفض. إذا لم يكن لديك بعد، سنرشدك إلى طريقة التثبيت.",
    "cl.blocked.title": "دوري الكلاسيكي للحاسوب فقط",
    "cl.blocked.body": "يتطلب دوري الكلاسيكي حاسوبًا يشغّل PES 13–21 مع Parsec للّعب عن بُعد. إذا كنت تلعب على كونسول أو موبايل، جرّب دوري الماستر أو BYOL.",
    "cl.blocked.back": "رجوع",
    "cl.guide.kicker": "إعداد PARSEC",
    "cl.guide.title": "طريقة تثبيت Parsec",
    "cl.guide.downloadEn": "دليل (EN)",
    "cl.guide.downloadAr": "دليل (AR)",
    "cl.guide.installed": "قمت بالتثبيت",
    "cl.profile.kicker": "خطوة أخيرة",
    "cl.profile.title": "أكمل ملفك الشخصي",
    "cl.profile.body": "نحتاج إلى جنسيتك وعمرك لتفعيل ميزات دوري الكلاسيكي.",
    "cl.profile.age": "العمر",
    "cl.profile.errNat": "يرجى اختيار جنسيتك",
    "cl.profile.errAge": "يرجى إدخال عمر صحيح (1–120)",
    "cl.dashboard.kicker": "كلاسيكياتي",
    "cl.dashboard.title": "اختر ساحتك الكلاسيكية",
    "cl.dashboard.settings": "التوفر و Parsec",
    "cl.dashboard.mine": "// ألعابي",
    "cl.dashboard.noGames": "لم تنضم إلى أي لعبة بعد — اختر واحدة أدناه لتسجيل دورك.",
    "cl.dashboard.pickGame": "// اختر لعبة",
    "cl.family.all": "الكل",
    "cl.comingSoon.kicker": "قريبًا",
    "cl.comingSoon.body": "تصفّح اللاعبين، طلبات المباريات، لوحات الصدارة، ودردشات اللعبة قادمة في المرحلة التالية. حدّد توفّرك الآن لتكون جاهزًا عند الإطلاق.",
    "cl.role.back": "رجوع إلى الألعاب",
    "cl.role.title": "اختر دورك",
    "cl.role.host": "مضيف",
    "cl.role.hostHelp": "أنت تشغّل اللعبة وتبثّها عبر Parsec. يتطلب سرعة رفع عالية (≥30 ميجابت/ث موصى به).",
    "cl.role.guest": "ضيف",
    "cl.role.guestHelp": "أنت تتصل بجلسة المضيف عن بُعد عبر Parsec. سرعة تنزيل ثابتة 25 ميجابت/ث كافية.",
    "cl.role.hostDisclaimer": "الاستضافة تتطلب رفعًا ثابتًا ≥30 ميجابت/ث للحفاظ على زمن استجابة منخفض. يرجى إجراء اختبار سرعة والتأكيد قبل الانضمام كمضيف.",
    "cl.role.speedtestBtn": "إجراء اختبار سرعة",
    "cl.role.hostConfirm": "أؤكد أن سرعة الرفع لديّ لا تقل عن 30 ميجابت/ث وأنني مستعد لاستضافة جلسات Parsec ثابتة.",
    "cl.role.guestDisclaimer": "كضيف، تحتاج فقط إلى تنزيل ثابت 25 ميجابت/ث — لكن يُنصح بشدة باتصال سلكي أو واي فاي 5GHz قوي لتقليل تأخر الإدخال.",
    "cl.role.join": "انضم إلى {name}",
    "cl.join.toast": "انضممت إلى {name} كـ {role}",
    "cl.leave.toast": "غادرت {name}",
    "cl.settings.kicker": "الإعدادات",
    "cl.settings.title": "التوفر و Parsec",
    "cl.settings.saved": "تم حفظ الإعدادات",
    "cl.settings.save": "حفظ",
    "cl.settings.saving": "جارٍ الحفظ...",
    "cl.settings.parsec": "اسم Parsec",
    "cl.settings.parsecPh": "اسم المستخدم لديك على Parsec",
    "cl.settings.parsecHelp": "سيستخدمه اللاعبون الآخرون لإرسال دعوة Parsec إليك.",
    "cl.settings.calKicker": "التقويم الأسبوعي",
    "cl.settings.calTitle": "متى تكون متاحًا؟",
    "cl.settings.calHelp": "اضغط على أي خلية لتبديل خانة لساعة واحدة. تُعرض الساعات بتوقيتك المحلي.",
    "cl.settings.day.sun": "أحد",
    "cl.settings.day.mon": "إثن",
    "cl.settings.day.tue": "ثلا",
    "cl.settings.day.wed": "أرب",
    "cl.settings.day.thu": "خمي",
    "cl.settings.day.fri": "جمع",
    "cl.settings.day.sat": "سبت",

    // Phase 2: browse, requests, matches, request modal
    "cl.browse.title": "اللوبي",
    "cl.browse.back": "العودة إلى الكلاسيكي",
    "cl.browse.openCta": "افتح اللوبي",
    "cl.browse.tabPlayers": "اللاعبون",
    "cl.browse.tabRequests": "الطلبات",
    "cl.browse.tabMatches": "المباريات",
    "cl.browse.loading": "جارٍ تحميل اللوبي...",
    "cl.browse.noPlayers": "لم ينضم أي لاعب آخر إلى هذه اللعبة بعد — كن أول من يدعو لاعبًا.",
    "cl.browse.slots": "خانات",
    "cl.browse.requestBtn": "طلب",
    "cl.browse.pendingBtn": "بانتظار",
    "cl.requests.kicker": "بانتظار",
    "cl.requests.pendingCount": "{n} طلب(ات) بانتظار الرد",
    "cl.requests.incomingKicker": "// واردة",
    "cl.requests.outgoingKicker": "// صادرة",
    "cl.requests.noIncoming": "لا توجد طلبات واردة.",
    "cl.requests.noOutgoing": "لا توجد طلبات صادرة.",
    "cl.requests.accept": "قبول",
    "cl.requests.decline": "رفض",
    "cl.requests.cancel": "إلغاء",
    "cl.requests.acceptedToast": "تم قبول المباراة — فُتحت المحادثة",
    "cl.requests.declinedToast": "تم رفض الطلب",
    "cl.requests.cancelledToast": "تم إلغاء الطلب",
    "cl.matches.upcomingKicker": "// مباريات الكلاسيكي القادمة",
    "cl.matches.noUpcoming": "لا توجد مباريات كلاسيكي قادمة بعد.",
    "cl.matches.chat": "محادثة",
    "cl.matches.anytime": "أي وقت",
    "cl.request.title": "طلب مباراة · {name}",
    "cl.request.proposedAt": "الوقت المقترح",
    "cl.request.optional": "اختياري",
    "cl.request.message": "رسالة",
    "cl.request.messagePh": "ألقِ التحية أو اقترح وقتًا…",
    "cl.request.send": "إرسال",
    "cl.request.sending": "جارٍ الإرسال...",
    "cl.request.cancel": "إلغاء",
    "cl.request.sentToast": "تم إرسال الطلب إلى {name}",

    // Phase 3: score submission, leaderboard, disputes
    "cl.browse.tabLeaderboard": "الترتيب",
    "cl.matches.acceptedKicker": "// المقبولة",
    "cl.matches.disputedKicker": "// متنازع عليها",
    "cl.matches.pastKicker": "// نتائج سابقة",
    "cl.matches.disputeBadge": "نزاع",
    "cl.matches.awaitingOpp": "بانتظار الخصم",
    "cl.matches.oppSubmitted": "أرسل الخصم نتيجته — دورك",
    "cl.matches.processing": "جارٍ المعالجة…",
    "cl.matches.expired": "منتهية",
    "cl.matches.submitScore": "إرسال النتيجة",
    "cl.matches.editScore": "تعديل النتيجة",
    "cl.score.title": "النتيجة ضد {name}",
    "cl.score.helper": "يُرسل كل لاعب نتيجته من وجهة نظره. إذا تطابقت النتائج، تُعتمد رسميًا. وإلا فإنها تُحوّل إلى نزاع يحلّه المسؤول.",
    "cl.score.myScore": "نتيجتك",
    "cl.score.oppScore": "نتيجة الخصم",
    "cl.score.save": "إرسال",
    "cl.score.savedToast": "تم إرسال النتيجة",
    "cl.score.errInvalid": "يجب أن تكون كلتا النتيجتين أعدادًا بين 0 و99",
    "cl.lb.kicker": "// الترتيب",
    "cl.lb.loading": "جارٍ تحميل الترتيب...",
    "cl.lb.empty": "لا توجد مباريات مكتملة بعد — كن أول من يُسجّل نتيجة.",
    "cl.lb.player": "اللاعب",
    "cl.lb.form": "الأداء",
    "clAdm.kicker": "نزاعات الكلاسيكي",
    "clAdm.title": "حل نزاعات الكلاسيكي",
    "clAdm.empty": "لا توجد نزاعات كلاسيكي نشطة.",
    "clAdm.loading": "جارٍ تحميل النزاعات...",
    "clAdm.resolve": "حل",
    "clAdm.reported": "أبلغ",
    "clAdm.notSubmitted": "لم يُرسل",
    "clAdm.modalTitle": "تحديد النتيجة النهائية",
    "clAdm.modalHelp": "ستُعتمد كلتا النتيجتين كنتيجة نهائية. سيتلقّى كلا اللاعبين إشعار push.",
    "clAdm.note": "ملاحظة داخلية (اختياري)",
    "clAdm.cancel": "إلغاء",
    "clAdm.confirm": "تأكيد التجاوز",
    "clAdm.confirming": "جارٍ التأكيد...",
    "clAdm.resolvedToast": "تم حل نزاع الكلاسيكي",
    "clAna.kicker": "تحليلات الكلاسيكي",
    "clAna.title": "لوحة أداء دوري الكلاسيكي",
    "clAna.loading": "جارٍ تحميل التحليلات...",
    "clAna.empty": "لا توجد بيانات للعائلة المحددة.",
    "clAna.kpiQualified": "مؤهلون",
    "clAna.kpiActive": "نشطون",
    "clAna.kpiActiveGames": "ألعاب نشطة",
    "clAna.kpiRequests": "طلبات بانتظار الرد",
    "clAna.kpiCompleted": "مكتملة",
    "clAna.kpiDisputes": "نزاعات مفتوحة",
    "clAna.perGameKicker": "تفصيل لكل لعبة",
    "clAna.colGame": "اللعبة",
    "clAna.colPlayers": "اللاعبون",
    "clAna.colPending": "طلبات بانتظار الرد",
    "clAna.colCompleted": "مباريات مكتملة",
    "clAna.colDisputes": "مباريات متنازع عليها",
    "clAna.colChat": "رسائل الدردشة",
    "clAna.colTop": "أفضل لاعب",
    "clAna.generatedAt": "تم التوليد في",

    // Phase 4: community chat
    "cl.browse.tabChat": "الدردشة",
    "cl.chat.loading": "جارٍ تحميل الدردشة...",
    "cl.chat.empty": "لا توجد رسائل بعد — كن أول من يُلقي التحية.",
    "cl.chat.placeholder": "اكتب رسالة…",
    "cl.chat.send": "إرسال",
    "cl.chat.sending": "جارٍ الإرسال...",
    "cl.chat.pinKicker": "مُثبّت",
    "cl.chat.pinEmpty": "لا توجد قواعد مُثبّتة بعد.",
    "cl.chat.pinEdit": "تعديل",
    "cl.chat.pinSave": "حفظ",
    "cl.chat.pinCancel": "إلغاء",
    "cl.chat.pinSaved": "تم حفظ الرسالة المُثبّتة",
    "cl.chat.deleteConfirm": "حذف هذه الرسالة؟",
    "cl.chat.deleted": "حُذفت بواسطة {by}",
    "cl.chat.errImageType": "يجب أن تكون الصورة PNG أو JPEG أو WEBP",
    "cl.chat.errImageSize": "يجب ألّا تتجاوز الصورة 5 ميجابايت",


    // ─── V2 mobile shell (iter 42 i18n) ───
    // Bottom nav
    "v2.nav.myleague": "دوريي",
    "v2.nav.explore":  "استكشف",
    "v2.nav.social":   "المجتمع",
    "v2.nav.store":    "المتجر",
    "v2.nav.profile":  "حسابي",
    "v2.nav.back2v1":  "← العودة إلى الإصدار v1",
    "v2.shell.preview": "ePLAY · معاينة الجوال",
    "v2.shell.phase":   "v2 / المرحلة 1",
    "v2.shell.loading": "جارٍ التحميل…",

    // V2 Match Detail (Arabic)
    "v2.match.back":              "رجوع",
    "v2.match.notfound":          "المباراة غير موجودة.",
    "v2.match.scheduled":         "مجدولة",
    "v2.match.home":              "المضيف",
    "v2.match.away":              "الضيف",
    "v2.match.you":               "أنت",
    "v2.match.final":             "النتيجة النهائية",
    "v2.match.pending":           "قيد التأكيد",
    "v2.match.autoDrawn":         "تعادل تلقائي (لم يحضر الطرفان)",
    "v2.match.adminOverride":     "قرار المشرف",
    "v2.match.status.confirmed":  "مؤكدة",
    "v2.match.status.pending":    "قيد التأكيد",
    "v2.match.status.disputed":   "متنازع عليها",
    "v2.match.status.scheduled":  "مجدولة",
    "v2.match.status.admin":      "مشرف",
    "v2.match.submission.received": "أُرسلت",
    "v2.match.submission.waiting":  "بانتظار",
    "v2.match.submission.empty":    "لم تُرسل النتيجة بعد",
    "v2.match.submit.title":        "أرسل نتيجتك",
    "v2.match.submit.help":         "كل لاعب يرسل نتيجته بشكل مستقل. تُعتمد المباراة عند تطابق النتيجتين.",
    "v2.match.submit.screenshot":   "اضغط لرفع لقطة شاشة",
    "v2.match.submit.change":       "تغيير",
    "v2.match.submit.pick":         "اختر ملفاً",
    "v2.match.submit.cta":          "أرسل النتيجة",
    "v2.match.submit.busy":         "جارٍ الإرسال…",
    "v2.match.toast.noFile":        "ارفع لقطة شاشة أولاً.",
    "v2.match.toast.submitted":     "تم إرسال النتيجة.",
    "v2.match.disputed.title":      "متنازع عليها",
    "v2.match.disputed.body":       "النتائج لا تتطابق. سيراجع المشرف اللقطات ويُصدر القرار قريباً.",
    "v2.match.chat.kicker":     "// دردشة المباراة",
    "v2.match.chat.title":      "محادثة مع {name}",
    "v2.match.chat.rule":       "إذا أرسلت رسالة ولم يرد منافسك بنهاية يوم المباراة، تُمنح الفوز 3-0 (+3 نقاط في الترتيب). استخدم الدردشة لتحديد وقت بدء المباراة.",
    "v2.match.chat.placeholder":"اقترح موعد بدء المباراة…",
    "v2.match.chat.empty.title":"لا توجد رسائل بعد",
    "v2.match.chat.empty.body": "أرسل الرسالة الأولى لتحديد موعد المباراة. لدى منافسك حتى نهاية اليوم للرد.",
    "v2.match.yourScore":   "نتيجتك",
    "v2.match.oppScore":    "نتيجة المنافس",
    "v2.match.locked.title":"الشوط الثاني مغلق",
    "v2.match.locked.body": "ستتمكن من إرسال نتيجة الشوط الثاني فور تأكيد الشوط الأول من الطرفين (أو حسمه من قِبَل المشرف).",
    "v2.match.locked.gotoG1":"الانتقال للشوط الأول",
    "v2.match.mod.kicker":  "// أدوات المشرف",
    "v2.match.mod.title":   "تجاوز النتيجة",
    "v2.match.mod.help":    "حدّد النتيجة النهائية يدوياً لهذه المباراة. استخدم هذا لحسم النزاعات أو تصحيح أخطاء أبلغ عنها اللاعبون. يتم تحديث الترتيب فوراً ويصل اللاعبين إشعار بالقرار.",
    "v2.match.mod.cta.open":      "تجاوز النتيجة",
    "v2.match.mod.cta.reoverride":"تعديل التجاوز",
    "v2.match.mod.apply":   "تطبيق التجاوز",
    "v2.match.mod.applied": "تم تجاوز النتيجة إلى {h}-{a}. تم تحديث الترتيب.",



    // V2 Player Profile (Arabic)
    "v2.player.notfound":   "اللاعب غير موجود.",
    "v2.player.error":      "تعذّر تحميل بيانات اللاعب. حاول مجدداً.",
    "v2.player.winRate":    "نسبة الفوز",
    "v2.player.followers":  "متابِع",
    "v2.player.following":  "متابَع",
    "v2.player.follow":     "متابعة",
    "v2.player.unfollow":   "إلغاء المتابعة",
    "v2.player.h2h":        "مواجهات",
    "v2.player.message":    "رسالة",
    "v2.player.stats":      "إحصائيات اللاعب",
    "v2.player.played":     "اللعبت",
    "v2.player.won":        "فوز",
    "v2.player.drawn":      "تعادل",
    "v2.player.lost":       "خسارة",
    "v2.player.gf":         "أهداف",
    "v2.player.ga":         "ضد",
    "v2.player.gd":         "فارق",
    "v2.player.points":     "نقاط",
    "v2.player.pts":        "نقاط",
    "v2.player.wdl":        "ف-ت-خ",
    "v2.player.seasons":    "مواسم",
    "v2.player.form":       "الأداء الأخير",
    "v2.player.h2hHistory": "تاريخ المواجهات المباشرة",
    "v2.player.avatar.tooLarge": "الصورة كبيرة جداً (الحد الأقصى 1 ميغا). اقتطعها أو اضغطها أولاً.",
    "v2.player.avatar.updated":  "تم تحديث الصورة الشخصية.",
    "v2.player.avatar.upload":   "رفع صورة شخصية",
    "v2.player.avatar.replace":  "استبدال الصورة الشخصية",

    // V2 DM thread (Arabic)
    "v2.dm.empty.title":    "لا توجد رسائل بعد",
    "v2.dm.empty.body":     "ابدأ محادثة لتحديد موعد مباراتك. مواجهتا الأسبوع تظهران هنا.",
    "v2.dm.placeholder":    "اكتب رسالة…",
    "v2.dm.send":           "إرسال",

    // V2 H2H (Arabic)
    "v2.h2h.kicker":              "// مواجهة مباشرة",
    "v2.h2h.help":                "مباراة واحدة = شوطان (مضيف + ضيف). كلا الشوطين يُجدَّولان في نفس اليوم. يُفتح الشوط الثاني بعد تأكيد الشوط الأول من الطرفين.",
    "v2.h2h.message":             "رسالة",
    "v2.h2h.profile":              "الملف",
    "v2.h2h.opp":                  "المنافس",
    "v2.h2h.game":                 "الشوط {n}",
    "v2.h2h.locked":               "مغلق حتى انتهاء الشوط الأول",
    "v2.h2h.yourSubmission":       "نتيجتك",
    "v2.h2h.oppSubmission":        "نتيجة المنافس",
    "v2.h2h.cta.submit":           "أرسل نتيجتك",
    "v2.h2h.cta.waiting":          "بانتظار المنافس",
    "v2.h2h.cta.view":             "عرض تفاصيل المباراة",
    "v2.h2h.toast.win":            "✓ تم تأكيد الجولة {round} — فزت {h}-{a}! +3 نقاط",
    "v2.h2h.toast.loss":           "تم تأكيد الجولة {round} — النتيجة النهائية {h}-{a}.",
    "v2.h2h.toast.draw":           "تم تأكيد الجولة {round} — تعادل {h}-{a}. +1 نقطة",
    "v2.h2h.toast.disputed":       "نزاع في الجولة {round} — نتيجتك لا تطابق المنافس. سيراجعها المشرف.",
    "v2.h2h.reschedule.cta":       "إعادة جدولة",
    "v2.h2h.reschedule.scheduled": "مجدولة",
    "v2.h2h.reschedule.send":      "إرسال الاقتراح",
    "v2.h2h.reschedule.accept":    "قبول",
    "v2.h2h.reschedule.withdraw":  "سحب",
    "v2.h2h.reschedule.applied":   "تم النقل إلى {date}.",
    "v2.h2h.reschedule.proposed":  "تم إرسال الاقتراح — بانتظار قبول المنافس لتاريخ {date}.",
    "v2.h2h.reschedule.withdrawn": "تم سحب الاقتراح.",
    "v2.h2h.reschedule.errFuture": "اختر تاريخاً مستقبلياً.",
    "v2.h2h.reschedule.oppProposed": "اقترح المنافس {date}",
    "v2.h2h.reschedule.youProposed": "اقترحت {date} — بانتظار المنافس.",



    // V2 AuthGate (مدخل الدوري على /v2)
    "v2.auth.kicker.signin": "// تسجيل دخول",
    "v2.auth.kicker.signup": "// لاعب جديد",
    "v2.auth.title.signin":  "ادخل الدوري",
    "v2.auth.title.signup":  "أنشئ حسابك",
    "v2.auth.sub.signin":    "سجّل الدخول لرفع النتائج، صعود الترتيب، وكسب الرموز.",
    "v2.auth.sub.signup":    "دوري مكوّن من 20 لاعب، نتائج موثقة بلقطة شاشة، وجوائز موسمية.",
    "v2.auth.tab.signin":    "تسجيل الدخول",
    "v2.auth.tab.signup":    "حساب جديد",
    "v2.auth.or":            "أو",
    "v2.auth.googleCta":     "المتابعة بحساب Google",
    "v2.auth.platform.mobile":  "موبايل",
    "v2.auth.platform.console": "كونسول",
    "v2.auth.gameid":        "اسم اللاعب داخل اللعبة",
    "v2.auth.whatsapp":      "واتساب",
    "v2.auth.nationality":   "الجنسية",
    "v2.auth.nationality.placeholder": "اختر دولتك (اختياري)",
    "v2.auth.placeholder.username": "اسم_المستخدم",
    "v2.auth.placeholder.gameid":   "معرّف داخل اللعبة",
    "v2.auth.placeholder.whatsapp": "+971 5x xxx xxxx",
    "v2.auth.creating":      "جارٍ إنشاء الحساب…",
    "v2.auth.create":        "إنشاء حساب",
    "v2.auth.haveAccount":   "لديك حساب بالفعل؟ سجّل دخول",
    "v2.auth.footer":        "ePlay · دوري الأبطال",


    // MyLeague
    "v2.my.welcome":      "أهلاً بعودتك",
    "v2.my.season":       "الموسم الحالي",
    "v2.my.master":       "الدوري الرئيسي",
    "v2.my.players":      "{n}/{m} لاعبًا",
    "v2.my.viewing":      "· يتم العرض",
    "v2.my.rank":         "الترتيب",
    "v2.my.points":       "النقاط",
    "v2.my.gd":           "فارق",
    "v2.my.viewHub":      "ادخل مركز الدوري",
    "v2.my.empty.title":  "لا يوجد دوري نشط",
    "v2.my.empty.body":   "اختر بطولة من تبويب الاستكشاف لبدء موسم.",
    "v2.my.empty.cta":    "تصفّح البطولات",
    "v2.my.nextMatch":    "المباراة القادمة",
    "v2.my.allMatches":   "كل المباريات",
    "v2.my.noScheduled":  "لا توجد مباريات مجدولة",
    "v2.my.scheduled":    "مجدولة",
    "v2.my.seeAll":       "عرض الكل",
    "v2.my.recent":       "آخر النتائج",
    "v2.my.tbd":          "لاحقًا",
    "v2.my.round":        "الجولة {n}",
    "v2.my.vs":           "ضد {opp}",
    "v2.my.auto":         "تلقائي",
    "v2.my.quick":        "الترتيب",
    "v2.my.myStats":      "إحصائياتي",
    "v2.my.classics":     "كلاسيك",
    "v2.my.byol":         "دوري خاص",
    "v2.my.picker.title": "تبديل الدوري",
    "v2.my.picker.empty": "لا توجد دوريات متاحة.",
    "v2.my.picker.mine":  "دوري",

    // Explore
    "v2.exp.kicker":       "استكشف",
    "v2.exp.title":        "اختر بطولتك",
    "v2.exp.subtitle":     "ست بطولات. خمس منها متاحة الآن.",
    "v2.exp.mobileMaster": "دوري الجوال الرئيسي",
    "v2.exp.consoleMaster":"دوري الكونسول الرئيسي",
    "v2.exp.classicsTitle":"كلاسيك",
    "v2.exp.byolTitle":    "دوري خاص (BYOL)",
    "v2.exp.byolBody":     "أنشئ دوريك الخاص ودَعوة أصدقائك بنظام المواسم نفسه.",
    "v2.exp.classicsBody": "PES و FIFA الكلاسيكية على الكمبيوتر عبر Parsec.",
    "v2.exp.live":         "مباشر",
    "v2.exp.open":         "مفتوح",
    "v2.exp.locked":       "مغلق",
    "v2.exp.soon":         "قريبًا",
    "v2.exp.viewLeague":   "عرض الدوري",
    "v2.exp.openLeague":   "افتح",
    "v2.exp.fillProgress": "{n}/{m} · {p}% ممتلئ",
    "v2.exp.classics.cta": "ادخل كلاسيك",
    "v2.exp.byol.cta":     "ادخل BYOL",

    // Social
    "v2.soc.kicker":       "المجتمع",
    "v2.soc.title":        "المجتمع",
    "v2.soc.tab.feed":     "الموجز",
    "v2.soc.tab.messages": "الرسائل",
    "v2.soc.tab.discover": "اكتشف",
    "v2.soc.feed.empty":   "لا منشورات حتى الآن — نتائج المباريات تُنشَر هنا تلقائيًا.",
    "v2.soc.msg.empty":    "لا محادثات بعد.",
    "v2.soc.search":       "ابحث عن لاعبين أو نوادٍ",
    "v2.soc.discover.empty": "لا يوجد لاعبون لاكتشافهم بعد.",
    "v2.soc.search.empty":  "لا توجد نتائج",

    // Profile
    "v2.prof.kicker":         "حسابي",
    "v2.prof.title":          "حسابي",
    "v2.prof.noClub":         "بدون اسم نادٍ",
    "v2.prof.reliability":    "الالتزام",
    "v2.prof.performance":    "الأداء",
    "v2.prof.played":         "لُعبت",
    "v2.prof.won":            "فوز",
    "v2.prof.lost":           "خسارة",
    "v2.prof.gf":             "أهداف له",
    "v2.prof.ga":             "أهداف عليه",
    "v2.prof.winPct":         "نسبة الفوز",
    "v2.prof.loadingStats":   "تحميل الإحصائيات…",
    "v2.prof.settings":       "الإعدادات",
    "v2.prof.language":       "اللغة",
    "v2.prof.logout":         "خروج",
    "v2.prof.admin":          "المسؤول",

    // Tokens
    "v2.tok.balance":     "الرصيد",
    "v2.tok.tokens":      "رمزًا",
    "v2.tok.next":        "الرمز التالي",
    "v2.tok.pts":         "نقطة",
    "v2.tok.ratio":       "{n} نقطة = 1",
    "v2.tok.unlock":      "سيُفعَّل الإنفاق عند إطلاق المتجر.",
    "v2.tok.wallet":      "محفظة الرموز",
    "v2.tok.earned":      "حصلت {e} · أنفقت {s}",
    "v2.tok.activity":    "آخر النشاطات",
    "v2.tok.empty":       "لا نقاط مكتسبة بعد — افز بمبارياتك لتعبئة محفظتك.",
    "v2.tok.simulate":    "محاكاة فوز (+3 نقاط)",
    "v2.tok.simulating":  "جارٍ المحاكاة…",
    "v2.tok.outcomeWin":  "فوز",
    "v2.tok.outcomeDraw": "تعادل",
    "v2.tok.outcomeLoss": "خسارة",
    "v2.tok.simulated":   "محاكاة",
    "v2.tok.simWin":      "فوز محاكى",
    "v2.tok.runningTotal":"الإجمالي {pts}",
    "v2.tok.tokenGained": "+{n} رمز",
    "v2.tok.soon":        "قريبًا",

    // Reward overlay
    "v2.rew.victory":     "فوز!",
    "v2.rew.testWin":     "فوز اختباري",
    "v2.rew.matchWin":    "فوز في المباراة",
    "v2.rew.tokenLine":   "+{n} رمز",
    "v2.rew.tokenLineOne":"+1 رمز",
    "v2.rew.pointsLine":  "+{n} نقطة",
    "v2.rew.totalBalance":"إجمالي الرصيد",
    "v2.rew.continue":    "متابعة",

    // Store
    "v2.store.kicker":      "المتجر",
    "v2.store.title":       "أشكال البطاقات",
    "v2.store.balance":     "رصيدك",
    "v2.store.career":      "{n} نقطة كلية",
    "v2.store.skins":       "الأشكال",
    "v2.store.teasers":     "قريبًا — حدود وإطارات",
    "v2.store.footer":      "// اكسب الرموز بالفوز // {n} نقطة = 1 رمز //",
    "v2.store.redeem":      "استبدل",
    "v2.store.locked":      "مغلق",
    "v2.store.apply":       "تطبيق",
    "v2.store.remove":      "إزالة",
    "v2.store.active":      "مفعّل",
    "v2.store.unlocked":    "تم فتح {name}!",
    "v2.store.applied":     "تم تطبيق {name}",
    "v2.store.removed":     "تمت إزالة الشكل",
    "v2.store.errRedeem":   "تعذّر الاستبدال",
    "v2.store.errApply":    "تعذّر التطبيق",
    "v2.store.needMore":    "تحتاج إلى {n} رمز إضافي",

    // Skins
    "v2.skin.bronze.name":     "البرونزي",
    "v2.skin.bronze.tagline":  "ابدأ الصعود",
    "v2.skin.bronze.label":    "برونزي",
    "v2.skin.elite.name":      "النخبة",
    "v2.skin.elite.tagline":   "اشحذ حدّك",
    "v2.skin.elite.label":     "نخبة",
    "v2.skin.legend.name":     "أسطورة",
    "v2.skin.legend.tagline":  "اكسب ذهبك",
    "v2.skin.legend.label":    "أسطورة",
    "v2.skin.phantom.name":    "الشبح",
    "v2.skin.phantom.tagline": "اختفِ مع الفوز",
    "v2.skin.phantom.label":   "شبح",
    "v2.skin.egypt_pharaohs.name":    "فراعنة مصر",
    "v2.skin.egypt_pharaohs.tagline": "اِحكُم النيل",
    "v2.skin.egypt_pharaohs.label":   "فراعنة",
    "v2.skin.algeria_fennecs.name":    "محاربو الصحراء",
    "v2.skin.algeria_fennecs.tagline": "فنّاكات الجزائر",
    "v2.skin.algeria_fennecs.label":   "فنّاكات",
    "v2.skin.saudi_falcons.name":    "صقور السعودية",
    "v2.skin.saudi_falcons.tagline": "حلِّق فوق الجميع",
    "v2.skin.saudi_falcons.label":   "صقور",
    "v2.skin.morocco_atlas.name":    "أسود الأطلس",
    "v2.skin.morocco_atlas.tagline": "زئير الأطلس",
    "v2.skin.morocco_atlas.label":   "أسود الأطلس",

    // My Skins
    "v2.myskins.title":     "أشكالي",
    "v2.myskins.owned":     "{n} مملوكة",
    "v2.myskins.empty":     "لا تملك أي شكل بعد.",
    "v2.myskins.cta":       "زُر المتجر ←",
    "v2.myskins.store":     "المتجر",

    // League Hub
    "v2.hub.error":          "الدوري غير متاح",
    "v2.hub.back":           "رجوع",
    "v2.hub.tab.standings":  "الترتيب",
    "v2.hub.tab.fixtures":   "المباريات",
    "v2.hub.tab.players":    "اللاعبون",
    "v2.hub.tab.feed":       "الموجز",
    "v2.hub.tab.chat":       "الدردشة",
    "v2.hub.players.you":    "أنت",
    "v2.hub.players.dm":     "محادثة",
    "v2.hub.players.empty":  "لم يُسجَّل لاعبون بعد.",
    "v2.hub.standings.empty":"لا ترتيب بعد — لم تُلعب أي مباراة.",
    "v2.hub.fixtures.openEmpty":"ستُولَّد المباريات عند اكتمال الدوري.",
    "v2.hub.fixtures.empty": "لا توجد مباريات بعد.",
    "v2.cal.today":      "اليوم",
    "v2.cal.tomorrow":   "غداً",
    "v2.cal.yesterday":  "أمس",
    "v2.cal.inDays":     "بعد {n} أيام",
    "v2.cal.daysAgo":    "قبل {n} أيام",
    "v2.cal.tbd.line1":  "غير",
    "v2.cal.tbd.line2":  "محدّد",
    "v2.cal.matchCount": "{n} مباراة",


    // V2 My Matches (Arabic)
    "v2.mm.kicker":     "// الجدول",
    "v2.mm.title":      "مبارياتي",
    "v2.mm.filter.upcoming": "القادمة",
    "v2.mm.filter.recent":   "السابقة",
    "v2.mm.filter.all":      "الكل",
    "v2.mm.empty.upcoming":  "لا توجد مباريات قادمة. عُد عند بداية الجولة التالية.",
    "v2.mm.empty.recent":    "لا توجد نتائج مؤكدة بعد. أرسل لقطة شاشة لتسجيل أول مباراة.",
    "v2.mm.empty.all":       "لا توجد مباريات في أي دوري بعد.",
    "v2.mm.won":  "فوز",
    "v2.mm.lost": "خسارة",
    "v2.mm.drawn":"تعادل",

    // V2 Account (Arabic)
    "v2.acc.kicker":        "// إعدادات",
    "v2.acc.title":         "الحساب",
    "v2.acc.lang.kicker":   "// اللغة",
    "v2.acc.lang.title":    "اللغة",
    "v2.acc.pass.kicker":   "// الأمان",
    "v2.acc.pass.title":    "تغيير كلمة المرور",
    "v2.acc.pass.old":      "كلمة المرور الحالية",
    "v2.acc.pass.new":      "كلمة المرور الجديدة (6 أحرف على الأقل)",
    "v2.acc.pass.cta":      "تحديث كلمة المرور",
    "v2.acc.pass.busy":     "جارٍ التحديث…",
    "v2.acc.pass.toast":    "تم تحديث كلمة المرور.",
    "v2.acc.pass.errShort": "كلمة المرور الجديدة يجب أن تكون 6 أحرف على الأقل.",
    "v2.acc.exit.kicker":   "// الدوري",
    "v2.acc.exit.title":    "الخروج من الدوري الحالي",
    "v2.acc.exit.body":     "سيتم إخراجك من الدوري وستخسر أي مباريات لم تُلعب. سيتم وضعك في دوري مفتوح آخر إذا توفّر.",
    "v2.acc.exit.confirmPh":"اكتب EXIT للتأكيد",
    "v2.acc.exit.cta":      "الخروج من الدوري",
    "v2.acc.exit.errConfirm":"اكتب EXIT تماماً للتأكيد.",
    "v2.acc.del.kicker":    "// منطقة خطر",
    "v2.acc.del.title":     "حذف الحساب",
    "v2.acc.del.body":      "هذا يحذف ملفك الشخصي وإحصائياتك وسجل الدردشة بشكل دائم. جميع المباريات غير الملعوبة تُحتسب خسارة.",
    "v2.acc.del.cta":       "حذف حسابي",
    "v2.acc.del.passPh":    "كلمة المرور",
    "v2.acc.del.confirmPh": "اكتب DELETE للتأكيد",
    "v2.acc.del.cancel":    "إلغاء",
    "v2.acc.del.confirmCta":"حذف نهائياً",
    "v2.acc.del.warn":      "لا يمكن التراجع عن هذا الإجراء.",
    "v2.acc.del.errConfirm":"اكتب DELETE تماماً للتأكيد.",

    // V2 Notifications (Arabic)
    "v2.notif.kicker":     "// الإشعارات",
    "v2.notif.title":      "الإشعارات",
    "v2.notif.markAll":    "تعليم الكل كمقروء",
    "v2.notif.empty.title":"لا إشعارات جديدة",
    "v2.notif.empty.body": "ستظهر هنا دعوات المباريات والنتائج والمتابعات ورسائل الدردشة.",
    "v2.notif.fallback":   "إشعار جديد",

    // V2 push opt-in (Arabic)
    "v2.push.kicker":  "// ابقَ على اطلاع",
    "v2.push.title":   "فعّل تنبيهات المباراة",
    "v2.push.body":    "احصل على إشعار فوري عندما يرفع منافسك النتيجة، عند تأكيد المباراة، أو عند انطلاق جولة جديدة.",
    "v2.push.enable":  "تفعيل",
    "v2.push.busy":    "جارٍ الطلب…",
    "v2.push.later":   "ليس الآن",
    "v2.push.dismiss": "إغلاق",
    "v2.push.toast.on":     "تم تفعيل الإشعارات — سنُنبّهك عند الأحداث المهمة.",
    "v2.push.toast.denied": "الإشعارات محظورة. فعّلها من إعدادات المتصفح للاشتراك لاحقاً.",
    "v2.push.toast.failed": "تعذّر تفعيل الإشعارات. حاول لاحقاً.",

    // V2 World Cup (Arabic)
    "v2.wc.kicker":         "// وضع كأس العالم",
    "v2.wc.tagline":        "مباشر الآن · اكشف منتخباً · مطابقة سرّية · تصدّر الترتيب",
    "v2.wc.soon":           "قريباً",
    "v2.wc.testing":        "تجريبي",
    "v2.wc.cta.join":       "انضم الآن",
    "v2.wc.mobile.title":   "كأس العالم · موبايل",
    "v2.wc.mobile.sub":     "مطابقة سرّية · 4 أسابيع · 20 مباراة في الأسبوع",
    "v2.wc.console.title":  "كأس العالم · كونسول",
    "v2.wc.console.sub":    "مطابقة سرّية · 4 أسابيع · 20 مباراة في الأسبوع",
    "v2.wc.cta.players":    "انضم الآن",
    "v2.wc.cta.staff":      "افتح الوضع",
    "v2.wc.spec.title":     "كيف يعمل",
    "v2.wc.tab.play":       "العب",
    "v2.wc.tab.stats":      "إحصائياتي",
    "v2.wc.tab.standings":  "الترتيب",
    "v2.wc.tab.timeline":   "الجدول الزمني",
    "v2.wc.tab.admin":      "الإدارة",
    "v2.wc.tab.rules":      "القواعد",
    "v2.wc.reveal.cta":     "اكشف منتخبي",
    "v2.wc.reveal.again":   "اكشف مجدداً",
    "v2.wc.notice.testing": "تجريبي — ستتم إعادة تعيين جميع النتائج قبل بداية كأس العالم الرسمية. حد 20 مباراة أسبوعياً مفعّل كما لو كانت حقيقية.",
    "v2.wc.week":           "أسبوع",
    "v2.wc.champions":      "أسبوع الأبطال",
    "v2.wc.champions.sub":  "أفضل 100 موبايل · أفضل 50 كونسول يتأهلون",
    "v2.wc.cap":            "{played}/{cap} مباراة هذا الأسبوع",
    "v2.wc.next.ends":      "ينتهي الأسبوع خلال",
    "v2.wc.players.title":  "اللاعبون المتصلون",
    "v2.wc.players.empty":  "لا يوجد لاعبون متصلون الآن. ابقَ على هذه الصفحة — يظهر اللاعبون فور كشفهم.",
    "v2.wc.send.invite":    "إرسال دعوة",
    "v2.wc.invites.in":     "الدعوات المستلمة",
    "v2.wc.invites.out":    "الدعوات المرسلة",
    "v2.wc.accept":         "قبول",
    "v2.wc.decline":        "رفض",
    "v2.wc.cancel":         "إلغاء",
    "v2.wc.match.host":     "المضيف — أنشئ الغرفة وشارك الرمز",
    "v2.wc.match.guest":    "الضيف — انضم إلى غرفة المضيف",
    "v2.wc.match.forfeit":  "مغادرة (تُحتسب خسارة 0-3)",
    "v2.wc.match.report":   "الإبلاغ عن الخصم",
    "v2.wc.report.title":   "الإبلاغ عن هذا اللاعب",
    "v2.wc.report.rules":   "3 بلاغات = تحذير. 4 بلاغات = استبعاد تلقائي من دوري كأس العالم. استخدم هذا فقط في حالة الغش أو الإساءة أو رفض اللعب.",
    "v2.wc.report.submit":  "إرسال البلاغ",
    "v2.wc.removed.title":  "تم استبعادك من كأس العالم",
    "v2.wc.removed.body":   "تم استبعادك من دوري كأس العالم لهذا الموسم بسبب البلاغات المتكررة.",
    "v2.wc.warning.body":   "لديك 3 بلاغات ضدك. واحد آخر وستتم إزالتك تلقائياً من الدوري.",
    "v2.wc.qualifies":      "متأهل",
    "v2.wc.standings.empty": "لا توجد مباريات مؤكدة بعد. كن أول لاعب.",
    "v2.wc.host":           "المضيف",
    "v2.wc.guest":          "الضيف",

    // V2 Friendlies (Arabic)
    "v2.fr.kicker":         "// المباريات الودية الدولية",
    "v2.fr.tagline":        "مباشر الآن · اكشف منتخباً · تحدَّ أي لاعب · تصدّر الترتيب",
    "v2.fr.live":           "مباشر",
    "v2.fr.banner.title":   "المباريات الودية الدولية",
    "v2.fr.banner.sub":     "اكشف منتخباً وطنياً عشوائياً وتحدَّ أي لاعب",
    "v2.fr.banner.cta":     "اكشف منتخبك",

    // V2 UFL (Arabic) — iter 86
    "v2.ufl.kicker":        "// يو إف إل",
    "v2.ufl.tagline":       "تشكيلات حقيقية · موبايل · مباشر الآن",
    "v2.ufl.console.title": "UFL · كونسول",
    "v2.ufl.console.sub":   "دوري حصري للاعبي UFL على الكونسول — مجموعات + خروج المغلوب",
    "v2.ufl.mobile.title":  "UFL · موبايل",
    "v2.ufl.mobile.sub":    "دوري حصري للاعبي UFL على الموبايل — مجموعات + خروج المغلوب",
    "v2.ufl.mobile.subLive":"غرف لعب سريعة من ٤ لاعبين · أنشئ أو انضم لفريق",
    "v2.ufl.livePill":      "مباشر",
    "v2.ufl.cta.enter":     "ادخل",

    // UFL Hub & flows (Arabic) — iter 86
    "ufl.hub.kicker":            "// UFL · موبايل",
    "ufl.hub.title":             "UFL موبايل",
    "ufl.hub.sub":               "ابحث عن فريق. اكسب المصداقية. تسلّق السلم.",
    "ufl.hub.quickPlay.title":   "لعب سريع",
    "ufl.hub.quickPlay.sub":     "اقتران مع ٤ لاعبين عشوائيين",
    "ufl.hub.teams.title":       "أنشئ / انضم لفريق",
    "ufl.hub.teams.sub":         "ابنِ فريقك بدعوة فقط",
    "ufl.hub.teams.premium":     "ميزة مدفوعة · مجاني الآن",
    "ufl.hub.credibility":       "المصداقية",
    "ufl.hub.gamesRated":        "{n} مباراة مُقيَّمة",
    "ufl.hub.history":           "السجل",
    "ufl.hub.back":              "رجوع",

    "ufl.qp.idle.title":         "ابحث عن مباراة",
    "ufl.qp.idle.body":          "اضغط بالأسفل لدخول الطابور. حين يُقرن أول لاعبَين، يبدأ مؤقت دقيقة واحدة — وعند انضمام اللاعب الرابع تُغلق الغرفة فورًا.",
    "ufl.qp.idle.uflName":       "اسمك في UFL",
    "ufl.qp.idle.uflNamePh":     "مثال: ProStriker99 — يُشارَك في الدردشة عند إغلاق الغرفة",
    "ufl.qp.exitRoom":           "مغادرة — لا استجابة",
    "ufl.qp.toast.leftRoom":     "غادرت الغرفة.",
    "ufl.qp.idle.queueLine":     "{n} {label} في الطابور",
    "ufl.qp.idle.queuePlayer":   "لاعب",
    "ufl.qp.idle.queuePlayers":  "لاعبين",
    "ufl.qp.idle.estimated":     "وقت الانتظار التقريبي: ~{secs} ث",
    "ufl.qp.idle.joinBtn":       "لعب سريع · انضم للطابور",
    "ufl.qp.queuing.title":      "البحث عن لاعبين…",
    "ufl.qp.queuing.body":       "ستُقترن فور دخول لاعب آخر. وقت الانتظار يعتمد على الازدحام.",
    "ufl.qp.queuing.position":   "{n} {label} في الانتظار",
    "ufl.qp.queuing.leaveBtn":   "اخرج من الطابور",
    "ufl.qp.matched.leaveBtn":   "غادر الغرفة",
    "ufl.qp.matched.title":      "تم إيجاد غرفة",
    "ufl.qp.matched.body":       "بانتظار لاعبين إضافيين · {n}/{cap}",
    "ufl.qp.matched.countdown":  "الإغلاق خلال {ss}ث",
    "ufl.qp.locked.title":       "تم إغلاق الغرفة",
    "ufl.qp.locked.body":        "{n} لاعبين · الدردشة لمدة {mins} دقيقة ثم تُغلق.",
    "ufl.qp.locked.chatLeft":    "تُغلق الدردشة خلال {ss}",
    "ufl.qp.closed.title":       "أُغلقت الدردشة",
    "ufl.qp.closed.body":        "قيّم كل اللاعبين الآخرين من ١ إلى ٥ لكسب رمز.",
    "ufl.qp.rate.title":         "قيّم هذا اللاعب",
    "ufl.qp.rate.note":          "يجب أن يقيّم كل لاعب الآخرين. عند اكتمال التقييمات، يحصل كل عضو على رمز واحد.",
    "ufl.qp.rate.you":           "أنت",
    "ufl.qp.rate.done":          "✓ مُقيَّم",
    "ufl.qp.chat.placeholder":   "أرسل رسالة",
    "ufl.qp.chat.empty":         "ألقِ التحية — نسّقوا مباراة UFL سويًا.",
    "ufl.qp.addFriend":          "أضف صديقًا",
    "ufl.qp.alreadyFriend":      "صديق ✓",
    "ufl.qp.tokenEarned":        "+١ رمز",
    "ufl.qp.toast.queued":       "أنت في الطابور.",
    "ufl.qp.toast.leftQueue":    "تم الخروج من الطابور.",
    "ufl.qp.toast.locked":       "أُغلقت الغرفة — الدردشة متاحة.",
    "ufl.qp.toast.rated":        "تم حفظ التقييم.",

    "ufl.teams.title":           "الفرق",
    "ufl.teams.sub":             "ميزة مدفوعة · مجاني الآن",
    "ufl.teams.disclaimer":      "ميزة مدفوعة، مجانية الآن — ستصبح ميزة مدفوعة في المستقبل.",
    "ufl.teams.create":          "أنشئ فريقًا",
    "ufl.teams.namePlaceholder": "اسم الفريق (٢–٤٠ حرفًا)",
    "ufl.teams.createBtn":       "إنشاء",
    "ufl.teams.invitesTitle":    "دعوات معلّقة لك",
    "ufl.teams.myTeams":         "فرقك",
    "ufl.teams.captain":         "كابتن",
    "ufl.teams.member":          "عضو",
    "ufl.teams.membersCount":    "{n} {label}",
    "ufl.teams.memberSingular":  "عضو",
    "ufl.teams.memberPlural":    "أعضاء",
    "ufl.teams.copyLink":        "انسخ رابط الدعوة",
    "ufl.teams.copied":          "تم نسخ الرابط",
    "ufl.teams.invite":          "ادعُ باسم المستخدم",
    "ufl.teams.inviteSend":      "إرسال",
    "ufl.teams.pendingInvites":  "دعوات معلّقة",
    "ufl.teams.pendingRequests": "طلبات انضمام معلّقة",
    "ufl.teams.accept":          "قبول",
    "ufl.teams.decline":         "رفض",
    "ufl.teams.leave":           "غادر الفريق",
    "ufl.teams.delete":          "احذف الفريق",
    "ufl.teams.empty":           "لست في أي فريق. أنشئ فريقًا أو اقبل دعوة.",
    "ufl.teams.shareHint":       "شارك هذا الرابط مع من تريد ضمّهم. سيُرسلون طلب انضمام يمكنك الموافقة عليه.",
    "ufl.teams.requestSent":     "تم إرسال الطلب — بانتظار موافقة الكابتن.",
    "ufl.teams.alreadyMember":   "أنت بالفعل في هذا الفريق.",



    "v2.hub.feed.empty":     "لا منشورات بعد — نتائج المباريات تظهر هنا تلقائيًا.",
    "v2.hub.chat.empty":     "لا رسائل بعد — قل مرحبًا 👋",
    "v2.hub.chat.placeholder":"اكتب رسالة",
    "v2.hub.fillPct":        "{n}/{m} لاعبًا · {p}% ممتلئ",
    "v2.hub.openTag":        "متاحة",

    // Common
    "v2.common.loading":     "جارٍ التحميل…",
    "v2.common.cancel":      "إلغاء",
    "v2.common.close":       "إغلاق",
    "v2.common.done":        "تم",

    // Footer
    "footer.left": "ePLAY // نظام المواسم v1.0",
    "footer.right": "[ 20 لاعبًا · ذهاب وإياب · 38 مباراة / لاعب ]",

    // ========== Pro Clubs (pcl.*) ==========
    "pcl.title":              "برو كلابز",
    "pcl.kicker":             "// EA FC برو كلابز",
    "pcl.backToHub":          "رجوع",
    "pcl.tab.team":           "الفريق",
    "pcl.tab.fixtures":       "المباريات",
    "pcl.tab.standings":      "الترتيب",
    "pcl.league.current":     "البطولة الحالية",
    "pcl.league.seasonOf":    "الموسم #{n} — {pool}",
    "pcl.league.progress":    "{registered}/10 فرق مسجَّلة",
    "pcl.league.toKickOff":   "{n} فرق متبقية لانطلاق البطولة",
    "pcl.invites.kicker":     "دعواتك",
    "pcl.invites.captain":    "القائد @{name}",
    "pcl.invites.accept":     "قبول",
    "pcl.invites.decline":    "رفض",
    "pcl.create.kicker":      "أنشئ فريقك كقائد",
    "pcl.create.namePh":      "اسم الفريق",
    "pcl.create.btn":         "إنشاء الفريق",
    "pcl.create.subtitle":    "ستكون القائد. ادعُ حتى 9 لاعبين آخرين. تبدأ البطولة فور تسجيل 10 فرق.",
    "pcl.create.tooShort":    "اسم الفريق قصير جدًا",
    "pcl.create.failed":      "تعذّر إنشاء الفريق.",
    "pcl.create.success":     "تم إنشاء الفريق! ادعُ حتى 9 لاعبين.",
    "pcl.team.squad":         "التشكيلة",
    "pcl.team.size":          "{size}/10 لاعبين · فئة {pool}",
    "pcl.team.invitePh":      "معرف اللاعب المُراد دعوته",
    "pcl.team.inviteOk":      "تم إرسال الدعوة",
    "pcl.team.inviteFail":    "تعذّر إرسال الدعوة",
    "pcl.team.actionOk":      "تم",
    "pcl.team.actionFail":    "فشل الإجراء",
    "pcl.role.captain":       "قائد",
    "pcl.role.deputy":        "نائب القائد",
    "pcl.role.player":        "لاعب",
    "pcl.role.you":           "◂ أنت",
    "pcl.role.promote":       "+ نائب",
    "pcl.role.transfer":      "+ قيادة",
    "pcl.role.kick":          "طرد",
    "pcl.fx.empty":           "لم تبدأ البطولة بعد. تُنشر المباريات فور انضمام 10 فرق.",
    "pcl.fx.matchday":        "الجولة",
    "pcl.fx.notFound":        "المباراة غير موجودة.",
    "pcl.fx.backToHub":       "العودة إلى برو كلابز",
    "pcl.fx.readOnly":        "عرض فقط — يستطيع قادة الفريقين المُتنافسَين فقط إرسال النتيجة أو الدردشة.",
    "pcl.fx.tabSubmit":       "إرسال النتيجة",
    "pcl.fx.tabChat":         "دردشة",
    "pcl.fx.tabResch":        "إعادة الجدولة",
    "pcl.fx.scorers":         "المسجِّلون",
    "pcl.fx.home":            "المضيف",
    "pcl.fx.away":            "الضيف",
    "pcl.status.scheduled":   "مُجدوَلة",
    "pcl.status.awaiting":    "بانتظار النتائج",
    "pcl.status.confirmed":   "مؤكَّدة",
    "pcl.status.disputed":    "متنازَع عليها",
    "pcl.sub.title":          "النتيجة النهائية",
    "pcl.sub.yourGoals":      "أهدافك",
    "pcl.sub.oppGoals":       "أهداف الخصم",
    "pcl.sub.scorers":        "المسجِّلون",
    "pcl.sub.noScorers":      "أضف مسجِّلًا لكل هدف بعد ضبط نتيجة فريقك (الأهداف العكسية مسموحة).",
    "pcl.sub.pickPlayer":     "اختر المسجِّل",
    "pcl.sub.ownGoal":        "هدف عكسي",
    "pcl.sub.addScorer":      "+ إضافة مسجِّل",
    "pcl.sub.goals":          "أهداف",
    "pcl.sub.screenshot":     "صورة من النتيجة النهائية",
    "pcl.sub.pickFile":       "اختر صورة",
    "pcl.sub.submitBtn":      "إرسال النتيجة",
    "pcl.sub.alreadySent":    "أرسل فريقك النتيجة — بانتظار القائد الآخر.",
    "pcl.sub.oppSubmitted":   "الفريق الآخر أرسل النتيجة — دورك الآن.",
    "pcl.sub.needScreenshot": "أرفق صورة للنتيجة النهائية.",
    "pcl.sub.sumMismatch":    "مجموع أهداف المسجِّلين يجب أن يطابق نتيجة فريقك.",
    "pcl.sub.failed":         "فشل إرسال النتيجة.",
    "pcl.sub.recorded":       "تم تسجيل النتيجة — بانتظار الفريق الآخر.",
    "pcl.sub.confirmed":      "تم تأكيد النتيجة!",
    "pcl.sub.disputed":       "النتائج غير متطابقة — سيراجع المشرف.",
    "pcl.chat.placeholder":   "اكتب رسالة…",
    "pcl.chat.empty":         "لا توجد رسائل بعد. ابدأ الحوار.",
    "pcl.chat.failed":        "تعذّر إرسال الرسالة.",
    "pcl.rs.proposeTitle":    "اقترح موعدًا جديدًا",
    "pcl.rs.proposeBody":     "يجب أن يوافق القائدان قبل تحديث الجدول.",
    "pcl.rs.proposeBtn":      "إرسال الاقتراح",
    "pcl.rs.pickDate":        "اختر موعدًا جديدًا أولًا.",
    "pcl.rs.proposed":        "تم إرسال الاقتراح — بانتظار القائد الآخر.",
    "pcl.rs.accepted":        "تم قبول الموعد — تحديث الجدول.",
    "pcl.rs.declined":        "تم رفض إعادة الجدولة.",
    "pcl.rs.acceptBtn":       "قبول",
    "pcl.rs.declineBtn":      "رفض",
    "pcl.rs.recent":          "آخر الاقتراحات (هذه الجلسة)",
    "pcl.rs.failed":          "فشلت إعادة الجدولة.",

    // ============================================================
    // WC 2026 — Hub, modes, locked view (iter 81+85)
    // ============================================================
    "wc26.back":               "رجوع",
    "wc26.hub.subtitle":       "اختر مسارك نحو الكأس.",
    "wc26.hub.unitedAsOne":    "متحدون · كواحد",
    "wc26.hero.united":        "متحدون",
    "wc26.hero.as":            "كـ",
    "wc26.hero.one":           "واحد",
    "wc26.host.mexico":        "المكسيك",
    "wc26.host.usa":           "أمريكا",
    "wc26.host.canada":        "كندا",
    "wc26.fact.teams":         "منتخب",
    "wc26.fact.cities":        "مدينة",
    "wc26.fact.matches":       "مباراة",
    "wc26.fact.days":          "يوم",
    "wc26.staffPreview":       "معاينة إدارية",
    "wc26.staffPreview.body":  "يُفتح الدخول العام قبل ٢٤ ساعة من انطلاق البطولة. اللاعبون يشاهدون حالياً العدّاد + القواعد + خيار التنبيه.",
    "wc26.locked.title":       "يُفتح الدخول للاعبين",
    "wc26.locked.firstMatch":  "المباراة الأولى · ١١ يونيو ٢٠٢٦ · ١٢:٠٠ بتوقيت ET (المكسيك ضد جنوب أفريقيا)",
    "wc26.locked.howItWorks":  "كيف ستعمل",
    "wc26.locked.threeModes":  "٣ أنماط · كأس واحد",
    "wc26.locked.footer":      "نراكم على أرض الملعب.",
    "wc26.notify.on":          "سننبهك",
    "wc26.notify.off":         "نبهني",
    "wc26.notify.signin":      "سجّل الدخول لتفعيل التنبيهات.",
    "wc26.notify.success":     "سننبهك فور فتح هذا النمط.",
    "wc26.notify.removed":     "تم إيقاف التنبيه.",
    "wc26.enter":              "دخول",
    "wc26.kickoff":            "ينطلق خلال",
    "wc26.opensIn":            "يُفتح خلال",
    "wc26.mode.tournament.chapter":   "٠١ · أصيل",
    "wc26.mode.tournament.title":     "بطولة الـ٤٨ منتخبًا",
    "wc26.mode.tournament.tagline":   "اختر منتخبًا. دافِع عن الشعار. كأس واحد.",
    "wc26.mode.tournament.hook":      "اختر منتخبًا. دافِع عن الشعار. كأس واحد.",
    "wc26.mode.immersion.chapter":    "٠٢ · الانغماس",
    "wc26.mode.immersion.title":      "الانغماس — الدوري اليومي",
    "wc26.mode.immersion.tagline":    "عِش كأس العالم الحقيقي. منتخب عشوائي كل يوم.",
    "wc26.mode.immersion.hook":       "عِش كأس العالم الحقيقي. منتخب عشوائي كل يوم. نفس المباراة التي يلعبونها.",
    "wc26.mode.dreamteam.chapter":    "٠٣ · فريق الأحلام",
    "wc26.mode.dreamteam.title":      "فريق الأحلام — حصص أسبوعية",
    "wc26.mode.dreamteam.tagline":    "ابنِ تشكيلة لم يرها العالم. اهزم كل من يلعب بنفس القواعد.",
    "wc26.mode.dreamteam.hook":       "ابنِ تشكيلة لم يرها العالم. اهزم كل من يلعب بنفس القواعد.",
    "wc26.rules.tournament.1":   "أول ٤٨ مسجّلًا لكل منصّة يملؤون البطولة. اختر أيًا من المنتخبات الـ٤٨ الحقيقية.",
    "wc26.rules.tournament.2":   "١٢ مجموعة من ٤ · ٦ مباريات لكل لاعب · يتأهل الأول والثاني + أفضل ٨ ثوالث.",
    "wc26.rules.tournament.3":   "دور الـ٣٢ → ١٦ → ربع → نصف: مواجهتان ذهابًا وإيابًا، قاعدة هدف الأرض، وقت إضافي، ركلات ترجيح.",
    "wc26.rules.tournament.4":   "النهائي + لقاء المركز الثالث: مباراة واحدة بوقت إضافي وركلات ترجيح.",
    "wc26.rules.tournament.5":   "الموبايل والكونسول يجريان بطولتين مستقلتين. بطل واحد لكل منصّة.",
    "wc26.rules.immersion.1":    "كل يوم مباراة حقيقي، يُسنَد إليك منتخب عشوائي من منتخبات اليوم.",
    "wc26.rules.immersion.2":    "خصمك هو من سحب المنتخب الذي يواجهه منتخبك في تلك المباراة الحقيقية — نفس المواجهة التي يشاهدها العالم.",
    "wc26.rules.immersion.3":    "كل ثنائي يخوض مباراتين: ذهاب وإياب، مع نفس الخصم في الشوطين.",
    "wc26.rules.immersion.4":    "النقاط تتراكم على مدى ٣٣ يومًا. بعد كل مرحلة يُقصى أدنى ٧٠٪ — ينجو أعلى ٣٠٪ فقط.",
    "wc26.rules.immersion.5":    "كل شريحة تتسع لـ ١٠٠٠ لاعب. أبطال الشرائح يتنافسون في النهائي الكبير يوم ١٩ يوليو.",
    "wc26.rules.immersion.6":    "فوز = ٣ نقاط · تعادل = ١ · خسارة = ٠. نسّق وقت البداية في دردشة المباراة.",
    "wc26.rules.dreamteam.1":    "كل اثنين ٠٠:٠٠ ت.ع.م: تُكشف ٢٠ حصة قارّية جديدة للأسبوع.",
    "wc26.rules.dreamteam.2":    "أعلن تشكيلة من ٢٤ لاعبًا: ٨ دفاع / ٨ وسط / ٨ هجوم تطابق حصة مباراتك المختارة.",
    "wc26.rules.dreamteam.3":    "الخادم يتحقق من تشكيلتك — لا ثغرات تعتمد على الأمانة.",
    "wc26.rules.dreamteam.4":    "فوز = ٣ + (أهدافك − أهداف الخصم) · تعادل = ١ · خسارة = ٠.",
    "wc26.rules.dreamteam.5":    "أفضل ٣ في كل دورة (من اثنين إلى اثنين) يدخلون قاعة المشاهير.",
    "wc26.rules.dreamteam.6":    "تشكيلة مريبة؟ قدّم بلاغًا بلقطة شاشة. المخالفون المتكررون يُحظرون.",
    "wc26.rules.dreamteam.7":    "اللاعبون الحاليون الحقيقيون فقط — لا يُسمح بإضافة لاعبين معتزلين إلى التشكيلة.",
    "wc26.rules.dreamteam.8":    "يُسمح بإضافة بطاقة لاعب Booster واحدة فقط كحد أقصى في التشكيلة.",
    "wc26.authentic.subhubTitle":     "أصيل · اختر الصيغة",
    "wc26.authentic.subhubSub":       "كلتا الصيغتين تحتسبان لنفس الكأس.",
    "wc26.dreamteam.subhubTitle":     "فريق الأحلام — اختر المنصة",
    "wc26.dreamteam.subhubSub":       "نمط واحد. مجمعان. الحصص الأسبوعية تُعاد كل اثنين.",
    // صفحات دخول الأنماط
    "wc26.entry.format":        "الصيغة",
    "wc26.entry.schedule":      "الجدول",
    "wc26.entry.feel":          "كيف يكون اللعب",
    "wc26.entry.hook.label":    "الجاذبية",
    "wc26.entry.pickPlatform":  "اختر منصّتك",
    "wc26.entry.platformNote":  "اختر مرة واحدة عند الدخول — للحفاظ على عدالة المواجهات.",
    "wc26.entry.enter":         "دخول",
    "wc26.entry.openMobile":    "افتحه على الواجهة الجديدة:",
    "wc26.entry.backToHub":     "كل الأنماط",
    "wc26.entry.locked":        "يُفتح قبل ٢٤ ساعة من الانطلاق",
    "wc26.card.sched.tournament": "~٤ أسابيع · ١١ يونيو – ١٩ يوليو",
    "wc26.card.sched.immersion":  "٣٣ يوم مباريات · النهائي ١٩ يوليو",
    "wc26.card.sched.dreamteam":  "أسبوعي · يُعاد كل اثنين",
    "wc26.tournament.feel":     "سجّل، احجز منتخبًا، وانغمس في نحو ٤ أسابيع من المنافسة الحقيقية. دور المجموعات قاسٍ — ست مباريات في سبعة أيام. انجُ من القطع وتزداد الأدوار الإقصائية توترًا: لا تتقدّم إلا إذا تفوّقت على خصمك عبر شوطين.",
    "wc26.tournament.sched.1.label": "إغلاق دور المجموعات",
    "wc26.tournament.sched.1.date":  "~٢٧ يونيو",
    "wc26.tournament.sched.2.label": "تستمر الأقواس حتى",
    "wc26.tournament.sched.2.date":  "١٩ يوليو",
    "wc26.tournament.stat.1":   "منتخبًا",
    "wc26.tournament.stat.2":   "مجموعات من ٤",
    "wc26.tournament.stat.3":   "في الأقواس",
    "wc26.immersion.feel":      "افتح التطبيق في ١١ يونيو. المكسيك تواجه جنوب أفريقيا. تضغط «اسحب فريقي» — تتبدّل الأعلام وتستقر على 🇲🇽 المكسيك. تُقرن مع اللاعب الذي سحب جنوب أفريقيا. مباراتان اليوم: ذهاب وإياب. سجّل، أكّد، واحصد نقاطك. وغدًا منتخب جديد.",
    "wc26.immersion.sched.1.label": "دور المجموعات",
    "wc26.immersion.sched.1.date":  "١١ – ٢٧ يونيو",
    "wc26.immersion.sched.2.label": "دور الـ٣٢",
    "wc26.immersion.sched.2.date":  "٢٨ يونيو – ٣ يوليو",
    "wc26.immersion.sched.3.label": "دور الـ١٦",
    "wc26.immersion.sched.3.date":  "٤ – ٧ يوليو",
    "wc26.immersion.sched.4.label": "ربع النهائي",
    "wc26.immersion.sched.4.date":  "٩ – ١١ يوليو",
    "wc26.immersion.sched.5.label": "نصف النهائي",
    "wc26.immersion.sched.5.date":  "١٤ – ١٥ يوليو",
    "wc26.immersion.sched.6.label": "النهائي الكبير",
    "wc26.immersion.sched.6.date":  "١٩ يوليو",
    "wc26.immersion.stat.1":    "يوم مباريات",
    "wc26.immersion.stat.2":    "لكل شريحة",
    "wc26.immersion.stat.3":    "ينجون كل قطع",
    "wc26.dreamteam.feel":      "صباح الاثنين. دورة جديدة انطلقت للتو. تتصفّح الحصص الـ٢٠ — المباراة ٧ تتطلب ٨ أوروبا / ٨ أفريقيا / ٦ آسيا / ٢ أمريكا. صعبة. تنتقي ٢٤ لاعبًا يناسبونها وتعتمد تشكيلتك — يتحقق الخادم ✓. تدخل الردهة، تدعو أعلى خصم تقييمًا، وتفوز ٣-١ مع مكافأة فارق الأهداف. +٥ للدورة.",
    "wc26.dreamteam.sched.1.label": "تبدأ الدورة",
    "wc26.dreamteam.sched.1.date":  "الاثنين ٠٠:٠٠ ت.ع.م",
    "wc26.dreamteam.sched.2.label": "مباريات لكل دورة",
    "wc26.dreamteam.sched.2.date":  "٢٠",
    "wc26.dreamteam.sched.3.label": "إعادة الضبط",
    "wc26.dreamteam.sched.3.date":  "كل اثنين",
    "wc26.dreamteam.stat.1":    "حصص أسبوعية",
    "wc26.dreamteam.stat.2":    "لاعب بالتشكيلة",
    "wc26.dreamteam.stat.3":    "ادخل قاعة المشاهير",
    "wc26.platform.mobile":     "موبايل",
    "wc26.platform.console":    "كونسول",
    "wc26.platform.openOnV2":   "افتحه على الواجهة الجديدة:",
    "wc26.chip.tournament":     "أصيل · بطولة الـ٤٨ منتخب",
    "wc26.chip.immersion":      "أصيل · الانغماس · دوري يومي",
    "wc26.chip.dreamteam":      "فريق الأحلام · حصص أسبوعية",
    "wc26.league.tabs.home":      "الرئيسية",
    "wc26.league.tabs.myleague":  "دوري‎ي",
    "wc26.league.tabs.today":     "اليوم",
    "wc26.league.tabs.schedule":  "الجدول",
    "wc26.league.tabs.history":   "السجل",
    "wc26.league.register":       "سجّل في هذا المجمع",
    "wc26.league.registered":     "مُسجَّل",
    "wc26.league.coordinate":     "نسّق وقت البداية في الدردشة أدناه ثم سجّل النتيجة",
    "wc26.league.submitResult":   "تسجيل النتيجة",
    "wc26.league.awaiting":       "بانتظار تأكيد الخصم.",
    "wc26.league.replaying":      "إعادة تجسيد المباراة الحقيقية:",
    "wc26.league.you":            "أنت",
    "wc26.league.opponent":       "الخصم",
    "wc26.league.chat.title":     "نسّق البداية",
    "wc26.league.chat.empty":     "لا توجد رسائل بعد. استخدم ردًا سريعًا أو اكتب بالأسفل.",
    "wc26.league.chat.placeholder": "اكتب رسالة…",
    "wc26.league.chat.send":      "إرسال",
    "wc26.league.chip.ready":     "جاهز؟",
    "wc26.league.chip.5min":      "٥ دقائق",
    "wc26.league.chip.10min":     "أحتاج ١٠ دقائق",
    "wc26.league.chip.gg":        "مباراة طيبة",
    "wc26.league.chip.tomorrow":  "نفس الوقت غدًا؟",
    "wc26.league.chip.lag":       "تقطيع — نعيد القرعة؟",
    "wc26.league.day":            "يوم",
    "wc26.league.bye":            "راحة",
    "wc26.league.bye.body":       "استمتع بيوم الراحة. النقاط مُحتسبة تلقائيًا.",
    "wc26.league.noDay":          "لا مباريات اليوم.",
    "wc26.league.noDay.body":     "يوم المباراة القادم سيُشغّل قرعتك اليومية تلقائيًا.",
    "wc26.league.filter.all":     "الكل",
    "wc26.league.filter.safe":    "آمن",
    "wc26.league.filter.cut":     "تحت خط القطع",
    "wc26.league.filter.out":     "مُقصى",
    "wc26.league.filter.win":     "انتصارات",
    "wc26.league.filter.draw":    "تعادلات",
    "wc26.league.filter.loss":    "هزائم",
    "wc26.league.filter.bye":     "راحات",
    "wc26.league.searchPlayer":   "ابحث عن لاعب…",
    "wc26.league.cutBar":         "قطع · أعلى {pct}٪ يتأهلون",
    "wc26.league.todayBadge":     "اليوم",
    "wc26.league.nextCut":        "القطع القادم",
    "wc26.league.viewFullTable":  "عرض الجدول الكامل ←",
    "wc26.league.reveal.drawing":  "نسحب منتخبك…",
    "wc26.league.reveal.yourTeam": "منتخبك",
    "wc26.league.reveal.fixture":  "المباراة التي تعيد تجسيدها",
    "wc26.league.reveal.matching": "نبحث عن خصمك…",
    "wc26.league.reveal.opponent": "خصمك",
    "wc26.league.reveal.waiting":  "بانتظار سحب خصم لك…",
    "wc26.league.reveal.waitingBody": "ستُقرن فور سحب لاعب آخر على الجانب المنافس. عُد بعد قليل.",
    "wc26.league.reveal.bye":      "راحة · يوم استراحة",
    "wc26.league.reveal.byeBody":  "لا خصم اليوم — النقاط تُحتسب تلقائيًا.",
    "wc26.league.reveal.continue": "لنلعب ←",
    "dt.back":                    "رجوع",
    "wc26.league.locked":         "دوري كأس العالم 2026 يفتح قبل ٢٤ ساعة من انطلاق المباراة الأولى.",
    "wc26.league.toastJoined":    "أنت في الدوري. حظًا موفقًا.",
    "wc26.league.headerChip":     "أصيل · انغماس · دوري يومي",
    "wc26.league.backChip":       "أصيل",
    "wc26.league.kickerImm":      "// الانغماس",
    "wc26.league.title":          "الدوري اليومي",
    "wc26.league.sub":            "يحاكي مباريات كأس العالم الحقيقية · ٣٣ يومًا · أعلى ٣٠٪ يتأهلون",
    "wc26.league.rank":           "الترتيب",
    "wc26.league.points":         "النقاط",
    "wc26.league.enterTitle":     "ادخل الدوري",
    "wc26.league.enterBody":      "بمجرد التسجيل، في كل يوم مباراة بكأس العالم سيتم تعيين مباراة لك وأحد فريقيها، وتُقرن مع لاعب آخر على الفريق المنافس. تتراكم النقاط على مدار ٣٣ يومًا. أعلى ٣٠٪ يتأهلون في كل مرحلة.",
    "wc26.league.registerBtn":    "سجّل · {pool}",
    "wc26.league.journey":        "// الرحلة",
    "wc26.league.miniStandings":  "ترتيب مصغّر · أفضل ٥",
    "wc26.league.idleTitle":      "مباريات اليوم الحقيقية",
    "wc26.league.idleNoFix":      "لا توجد مباريات بعد لهذا التاريخ — الإدارة تعمل على إضافتها.",
    "wc26.league.idleHelp":       "ستُعيّن عشوائيًا لإحدى مباريات اليوم الحقيقية وتُقرن مع لاعب آخر على الفريق المنافس.",
    "wc26.league.rollBtn":        "اسحب فريقي",
    "wc26.league.screenshotReq":  "يجب رفع لقطة شاشة",
    "wc26.league.scoreSubmitted": "تم تسجيل النتيجة.",
    "wc26.league.legHome":        "الجولة {n} · أرضك",
    "wc26.league.legAway":        "الجولة {n} · ملعب الخصم",
    "wc26.league.leg":            "الجولة {n}",
    "wc26.league.submittedLine":  "سجّلت {h}–{a}. بانتظار تأكيد الخصم.",
    "wc26.league.confirmedTag":   "مُؤكَّد",
    "wc26.league.victory":        "انتصار",
    "wc26.league.defeat":         "هزيمة",
    "wc26.league.draw":           "تعادل",
    "wc26.league.byeDay":         "يوم راحة",
    "wc26.league.byeFooter":      "+{pts} نقاط · لا خصم اليوم.",
    "wc26.league.dispTitle":      "النتائج غير متطابقة.",
    "wc26.league.dispBody":       "سيقوم المسؤول بحل النزاع.",
    "wc26.league.survival":       "// البقاء",
    "wc26.league.shardLine":      "مجموعة #{n} · {total} لاعب · أعلى {pct}٪ يتأهلون",
    "wc26.league.safeLine":       "آمن · #{rank} من {cutoff}",
    "wc26.league.belowCut":       "تحت خط القطع · #{rank} (القطع عند #{cutoff})",
    "wc26.league.yourPts":        "نقاطك",
    "wc26.league.cutMarker":      "قطع · #{cutoff}",
    "wc26.league.registerFirst":  "سجّل أولًا.",
    "wc26.league.shardShown":     "مجموعة #{n} · {shown}/{total} مرئيون",
    "wc26.league.statTotal":      "الإجمالي",
    "wc26.league.statScheduled":  "مجدول",
    "wc26.league.statLive":       "مباشر",
    "wc26.league.statSubmitted":  "مُرسَل",
    "wc26.league.statConfirmed":  "مؤكَّد",
    "wc26.league.statDisputed":   "متنازع عليه",
    "wc26.league.noShard":        "لا توجد مباريات مرسومة لهذه المواجهة في مجموعتك.",
    "wc26.league.stage.group":    "دور المجموعات",
    "wc26.league.stage.r32":      "دور الـ ٣٢",
    "wc26.league.stage.r16":      "دور الـ ١٦",
    "wc26.league.stage.qf":       "ربع النهائي",
    "wc26.league.stage.sf":       "نصف النهائي",
    "wc26.league.stage.final":    "النهائي",
    "wc26.league.cutAdvance":     "▼ قطع · أعلى {pct}٪ يتأهلون",
    "wc26.league.noMatches":      "لا مباريات بعد.",
    "wc26.league.noFilter":       "لا مباريات تطابق هذا الفلتر.",
    "wc26.league.preview":        "وضع المعاينة · بتاريخ {date}",
    "wc26.league.fixtureCount":   "{n} مباراة",
    "wc26.league.statusScheduled":"مجدول",
    "wc26.league.statusLive":     "مباشر",
    "wc26.league.statusAwait":    "بالانتظار",
    "wc26.league.statusConf":     "مؤكَّد",
    "wc26.league.statusDisp":     "نزاع",
    "wc26.league.statusForf":     "خسارة بانسحاب",
    "wc26.league.statusBye":      "راحة",
    "wc26.league.statusSafe":     "آمن",
    "wc26.league.statusCut":      "قطع",
    "wc26.league.statusOut":      "مُقصى",
    "wc26.league.tstatus.registration": "التسجيل",
    "wc26.league.tstatus.live":         "مباشر",
    "wc26.league.tstatus.complete":     "مكتمل",
    "wc26.league.tstatus.scheduled":    "مجدول",

    "wct.unavailable":            "البطولة غير متاحة. حاول لاحقًا.",
    "wct.headerChip":             "أصيل · بطولة ٤٨ منتخبًا",
    "wct.backChip":               "رجوع",
    "wct.kicker":                 "// أصيل",
    "wct.title":                  "بطولة ٤٨ منتخبًا",
    "wct.sub":                    "تجربة للانطلاق الرسمي · ١٢ مجموعة · أقواس إقصائية",
    "wct.testBadge":              "تجريبي",
    "wct.testMode":               "وضع تجريبي",
    "wct.testingBody":            "تجربة للانطلاق الرسمي لكأس العالم ٢٠٢٦. ٤٨ لاعبًا · ١٢ مجموعة · دور المجموعات ينتهي الإثنين ٢٣:٥٩ بتوقيت الرياض. أفضل اثنين من كل مجموعة + أفضل ٨ ثوالث يتأهلون إلى الأدوار الإقصائية.",
    "wct.platform.console":       "كونسول",
    "wct.platform.mobile":        "موبايل",
    "wct.join.slots":             "الأماكن تمتلئ",
    "wct.join.cta":               "انضم إلى كأس العالم",
    "wct.join.body":              "الأسبق أحق. عند امتلاء كل الـ ٤٨ مكانًا، تبدأ البطولة وتُفتح بطولة جديدة.",
    "wct.join.toast":             "سحبت {flag} {name}! المجموعة {g}",
    "wct.join.fail":              "تعذّر الانضمام",
    "wct.idleBody":               "ستفتح بطولة جديدة عند انتهاء الحالية. ترقّب.",
    "wct.yourTeam":               "فريقك",
    "wct.group":                  "المجموعة {g}",
    "wct.deadline.ends":          "تنتهي المجموعة",
    "wct.tabs.matches":           "مبارياتي",
    "wct.tabs.group":             "المجموعة",
    "wct.tabs.standings":         "الترتيب",
    "wct.tabs.bracket":           "الأقواس",
    "wct.noMatches":              "لا مباريات بعد. سيبدأ دور المجموعات بمجرد امتلاء الـ ٤٨ مكانًا.",
    "wct.match.host":             "مضيف",
    "wct.match.guest":            "ضيف",
    "wct.match.forfSilence":      "قُرّرت بقاعدة الصمت في الدردشة",
    "wct.match.forfDeadline":     "انتهى الموعد — خسارة بانسحاب",
    "wct.submit.scores":          "أدخل النتيجتين",
    "wct.submit.shotReq":         "لقطة الشاشة مطلوبة",
    "wct.submit.toast":           "تم تسجيل النتيجة",
    "wct.submit.fail":            "فشل",
    "wct.submit.cta":             "أرسل النتيجة",
    "wct.submit.phMy":            "نتيجتي",
    "wct.submit.phOpp":           "نتيجة الخصم",
    "wct.submit.waiting":         "تم الإرسال. بانتظار الخصم…",
    "wct.et.title":               "الوقت الإضافي",
    "wct.et.body":                "انتهت المباراة بالتعادل. أدخل نتيجة الوقت الإضافي (والركلات الترجيحية إذا تعادل الوقت الإضافي أيضًا) لتحديد الفائز.",
    "wct.et.pens":                "ركلات الترجيح",
    "wct.et.cta":                 "إرسال الوقت الإضافي",
    "wct.auto.body":              "التأكيد التلقائي معلّق حتى",
    "wct.auto.deadline":          "الإثنين ٢٣:٥٩ بتوقيت الرياض",
    "wct.auto.body2":             "النتائج المرسلة تنتظر حتى الموعد النهائي؛ لن يخسر أي طرف بسبب الخمول قبل ذلك. بعد الموعد، يرث الخصم غير المُرسِل النتيجة المُرسَلة.",
    "wct.auto.waiting":           "بانتظار الخصم…",
    "wct.auto.yourTurn":          "دورك — أرسل قبل الإثنين ٢٣:٥٩ بتوقيت الرياض",
    "wct.chat.title":             "دردشة المباراة",
    "wct.chat.empty":             "ألقِ التحية لتنسيق المباراة.",
    "wct.chat.placeholder":       "رسالة…",
    "wct.groupChat.title":        "دردشة المجموعة {g}",
    "wct.groupChat.empty":        "نسّق مواعيد المباريات مع مجموعتك هنا.",
    "wct.groupChat.placeholder":  "راسل مجموعتك…",
    "wct.bracket.final":          "النهائي",
    "wct.bracket.third":          "المركز الثالث",
    "wct.bracket.tbd":            "لاحقًا",
    "wct.tracker.title":          "المسجّلون",
    "wct.tracker.slots":          "/٤٨ مكان",
    "wct.tracker.remaining":      "{n} مكان متبقٍ قبل بدء البطولة",
    "wct.tracker.groupProgress":  "دور المجموعات قيد التقدّم",
    "wct.tracker.koProgress":     "الأدوار الإقصائية قيد التقدّم",
    "wct.tracker.complete":       "البطولة منتهية",
    "wct.preview.kicker":         "// معاينة المجموعات",
    "wct.preview.meta":           "١٢ مجموعة · ٤ لكل مجموعة",
    "wct.preview.openSlot":       "— مكان شاغر —",
    "wct.you":                    "أنت",
    "wct.played":                 "ل",

    "dt.headerChip":              "فريق الأحلام · حصص أسبوعية",
    "dt.kicker":                  "// فريق الأحلام",
    "dt.title":                   "حصص أسبوعية",
    "dt.sub":                     "٢٠ مباراة لكل دورة · ٨ دفاع / ٨ وسط / ٨ هجوم",
    "dt.tabs.home":               "الرئيسية",
    "dt.tabs.lobby":              "الردهة",
    "dt.tabs.match":              "المباراة",
    "dt.tabs.leaderboard":        "لوحة الصدارة",
    "dt.tabs.history":            "السجل",
    "dt.continent.europe":        "أوروبا",
    "dt.continent.africa":        "أفريقيا",
    "dt.continent.asia":          "آسيا",
    "dt.continent.americas":      "الأمريكتان",
    "dt.pos.def":                 "دفاع",
    "dt.pos.mid":                 "وسط",
    "dt.pos.fwd":                 "هجوم",
    "dt.week":                    "// أسبوع {id}",
    "dt.gameOf":                  "المباراة",
    "dt.gameUnlock":              "تُفتح المباراة التالية بعد إنهاء هذه.",
    "dt.cycleDone":               "أنهيت كل الـ {n} مباريات هذا الأسبوع. دورة جديدة تنطلق الإثنين ٠٠:٠٠ ت.ع.م.",
    "dt.split.banner":            "المباراة {n} · ابنِ تشكيلة من {total} لاعبًا تطابق هذه الحصة",
    "dt.split.player":            "{n} لاعب",
    "dt.split.players":           "{n} لاعبين",
    "dt.split.total":             "الإجمالي: {n} لاعبين · ٨ دفاع · ٨ وسط · ٨ هجوم",
    "dt.lobby.online":            "// متصلون · {n} {label}",
    "dt.lobby.player":            "لاعب",
    "dt.lobby.players":           "لاعبين",
    "dt.lobby.gameBanner":        "أنت في المباراة {n} · ادعُ أي شخص لتقليل وقت الانتظار.",
    "dt.lobby.firstInvite":       "ستنضم إلى الدورة تلقائيًا فور إرسال أول دعوة أو لعب أول مباراة.",
    "dt.lobby.empty":             "لا أحد متصل الآن. ادعُ صديقًا للعب!",
    "dt.lobby.invite":            "دعوة",
    "dt.lobby.inviteSent":        "أُرسلت ✓",
    "dt.lobby.inviteToast":       "تم إرسال الدعوة للمباراة {n} — لديهم ٣٠ ثانية للقبول.",
    "dt.lobby.rankLine":          "الترتيب #{rank} · {pts} نقطة · فارق {gd}",
    "dt.invite.notify":           "{name} دعاك إلى المباراة {n}",
    "dt.invite.accept":           "قبول",
    "dt.invite.decline":          "رفض",
    "dt.invite.started":          "بدأت المباراة!",
    "dt.invite.aPlayer":          "لاعب",
    "dt.match.empty":             "لا مباراة نشطة. توجّه إلى الردهة لدعوة خصم.",
    "dt.match.gameStatus":        "المباراة {n} · {status}",
    "dt.match.confirmed":         "✓ مؤكَّد",
    "dt.match.disputed":          "⚠ نزاع",
    "dt.match.homeLabel":         "أرضك · م{n}",
    "dt.match.awayLabel":         "خارج · م{n}",
    "dt.match.condTitle":         "// شروط التشكيلة · تحقق قبل البدء",
    "dt.match.condYours":         "تشكيلتك",
    "dt.match.condOpp":           "تشكيلة @{name}",
    "dt.match.spotMismatch":      "لاحظت مخالفة؟ اضغط على التبليغ وأرفق لقطة شاشة.",
    "dt.match.updateReport":      "تحديث البلاغ",
    "dt.match.reportSquad":       "بلّغ عن التشكيلة",
    "dt.match.reportedStatus":    "بلّغت عن هذه المباراة · الحالة: {status}",
    "dt.match.waiting":           "سجّلت {h}–{a}. بانتظار تأكيد الخصم.",
    "dt.match.disputeBody":       "النتائج غير متطابقة. سيقوم المسؤول بالحل.",
    "dt.match.finalLine":         "نهائي · لك {a} نقطة · للخصم {b} نقطة",
    "dt.match.chatTitle":         "دردشة المباراة",
    "dt.match.chatPlaceholder":   "اكتب رسالة…",
    "dt.match.chatEmpty":         "ألقِ التحية على خصمك.",
    "dt.mini.condPending":        "الشروط قيد المراجعة…",
    "dt.mini.totalLine":          "الإجمالي {n} · ٨د/٨و/٨ه",
    "dt.report.title":            "بلاغ عن التشكيلة",
    "dt.report.body":             "بلّغ إذا لم تلتزم تشكيلتهم بالحصة الخاصة بمباراتهم.",
    "dt.report.already":          "لقد بلّغت عن هذه المباراة سابقًا — الإرسال مجددًا سيُحدّث أدلتك.",
    "dt.report.issue":            "ما المشكلة؟",
    "dt.report.placeholder":      "مثال: تشكيلتهم تضم ٥ لاعبين آسيويين بينما المباراة ٤ تتطلب ٦.",
    "dt.report.attach":           "أرفق لقطة شاشة (مطلوبة)",
    "dt.report.attached":         "مرفق: {name}",
    "dt.report.minReason":        "السبب يجب أن يكون ٥ أحرف على الأقل.",
    "dt.report.needShot":         "يرجى إرفاق لقطة شاشة كدليل.",
    "dt.report.failed":           "فشل البلاغ.",
    "dt.report.sentToast":        "تم إرسال البلاغ إلى فريق الإدارة.",
    "dt.report.send":             "أرسل البلاغ",
    "dt.submit.title":            "// أرسل النتيجة النهائية",
    "dt.submit.toast":            "تم تسجيل النتيجة.",
    "dt.submit.cta":              "أرسل النتيجة النهائية",
    "dt.submit.attachOpt":        "أرفق لقطة شاشة (اختياري)",
    "dt.lb.you":                  "أنت",
    "dt.lb.yourRank":             "ترتيبك · #{rank}",
    "dt.lb.header":               "ل · ف-ت-خ · فارق · نقاط",
    "dt.lb.empty":                "لا مباريات هذا الأسبوع بعد.",
    "dt.lb.col.player":           "اللاعب",
    "dt.history.empty":           "لا مباريات هذا الأسبوع بعد.",
    "dt.history.gameNum":         "المباراة {n}",
    "dt.history.win":             "فوز",
    "dt.history.loss":            "خسارة",
    "dt.history.draw":            "تعادل",
    "dt.opp":                     "الخصم",
  },
};

const LanguageContext = createContext(null);

// Helper to interpolate {placeholders} inside a translated string
function interpolate(template, params) {
  if (!params) return template;
  return Object.keys(params).reduce(
    (s, key) => s.replaceAll(`{${key}}`, String(params[key])),
    template
  );
}

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("gml_lang") || "en");

  useEffect(() => {
    const dict = translations[lang] || translations.en;
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dict.dir);
    localStorage.setItem("gml_lang", lang);
  }, [lang]);

  const t = useCallback(
    (key, params) => {
      const dict = translations[lang] || translations.en;
      const raw = dict[key] ?? translations.en[key] ?? key;
      return interpolate(raw, params);
    },
    [lang]
  );

  const toggle = () => setLang((l) => (l === "en" ? "ar" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, t, toggle, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used inside LanguageProvider");
  return ctx;
};
